export const MagstimLocalisation = {
  "en": {
    "about": "About",
    "about_address": "The Magstim Company Ltd,\r\nSpring Gardens, Whitland,\r\nWales, U.K. SA34 0HR",
    "about_ref": "5453-00",
    "about_ref_analytics": "5736-00",
    "about_udi": "(01)05060229532725\r\n(21){0}\r\n(11){1}",
    "about_udi_analytics": "(01)05060229532794\r\n(21){0}\r\n(11){1}",
    "accuracy_analytics": "Accuracy Analytics",
    "add_additional_landmark": "Add Additional Landmark",
    "add_additional_landmarks": "Add additional landmarks",
    "add_clinical_assessment": "Add Clinical Assessment",
    "additional_landmark_name": "Additional Landmark Name",
    "advanced_search": "Advanced Filters",
    "advanced_search_active_patients": "Active Patients",
    "advanced_search_all_clinics": "All Clinics",
    "advanced_search_all_devices": "All Devices",
    "advanced_search_all_organisations": "All Organisations",
    "advanced_search_all_patients": "All Patients",
    "advanced_search_applied_filters": "Applied Filters: ",
    "advanced_search_archived_patients": "Archived Patients",
    "advanced_search_filters_help": "Select or deselect boxes to filter your search.",
    "advanced_search_include": "Include in Search",
    "advanced_search_max": "Max",
    "advanced_search_min": "Min",
    "advanced_search_plan_completed": "Plan Completed",
    "advanced_search_rmt_level": "rMT Level",
    "advanced_search_scale": "Scale",
    "advanced_search_search_parameters": "Search Parameters",
    "advanced_search_showing": "Showing",
    "advanced_search_treater": "Treater",
    "analytics": "Analytics",
    "analytics_all_treaters": "All Treaters",
    "analytics_average_rmt": "Average rMT",
    "analytics_average_rmt_percent": "Average rMT (%)",
    "analytics_chart": "Chart",
    "analytics_clinics_rmt": "Clinics rMTs",
    "analytics_comparison": "Comparison",
    "analytics_data": "Data",
    "analytics_devices_rmt": "Devices rMTs",
    "analytics_last_sync_completed_time": "Last sync completed time",
    "analytics_last_sync_started_time": "Last sync started time",
    "analytics_number_of_clinics": "Clinic Count",
    "analytics_number_of_devices": "Device Count",
    "analytics_number_of_organisations": "Organisation Count",
    "analytics_number_of_patients": "Patient Count",
    "analytics_number_of_protocols": "Protocol Count",
    "analytics_number_of_protocols_with_accuracy_data": "Protocol Count (with accuracy information)",
    "analytics_number_of_pulses": "Pulse Count",
    "analytics_number_of_pulses_in_contact_tolerance": "Pulses Within Contact Tolerance",
    "analytics_number_of_pulses_in_contact_tolerance_short": "Contact",
    "analytics_number_of_pulses_in_distance_tolerance": "Pulses Within Distance Tolerance",
    "analytics_number_of_pulses_in_distance_tolerance_short": "Distance",
    "analytics_number_of_pulses_in_rotation_tolerance": "Pulses Within Rotation Tolerance",
    "analytics_number_of_pulses_in_rotation_tolerance_short": "Rotation",
    "analytics_number_of_pulses_in_tilt_tolerance": "Pulses Within Tilt Tolerance",
    "analytics_number_of_pulses_in_tilt_tolerance_short": "Tilt",
    "analytics_number_of_pulses_in_Tolerance": "Pulses Within Tolerance",
    "analytics_number_of_pulses_in_tolerance_percent": "Pulses Within Tolerance (%)",
    "analytics_number_of_pulses_in_Tolerance_short": "Tolerance",
    "analytics_number_of_pulses_in_tolerance_with_accuracy_data": "Pulses Within Tolerance (with accuracy information)",
    "analytics_number_of_pulses_with_accuracy_data": "Pulse Count (with accuracy information)",
    "analytics_number_of_rating_scales": "Rating Scale Count",
    "analytics_number_of_ratings": "Ratings Count",
    "analytics_number_of_rmts": "rMT Count",
    "analytics_number_of_treaters": "Treater Count",
    "analytics_number_of_treatments": "Treatment Count",
    "analytics_number_of_treatments_with_accuracy_data": "Treatment Count (with accuracy information)",
    "analytics_patient_patients_rmt": "Patients rMTs",
    "analytics_progress": "Progress",
    "analytics_progress_chart": "Analytics Progress Chart",
    "analytics_rmt_percent": "rMT (%)",
    "analytics_summary": "Summary",
    "analytics_time_period": "Time Period",
    "analytics_title": "{0} Analytics",
    "analytics_total_number_of_treatments": "Number of Treatments",
    "analytics_treater_treaters_accuracy": "Treaters Accuracy",
    "analytics_treater_treaters_assessments": "Treaters Assessments",
    "analytics_treater_treaters_rmt": "Treaters rMTs",
    "analytics_treatment_plans_completed": "Treatment Plans Completed",
    "application_error_1": "Application pre-loading initiated. ",
    "application_error_10": "Patient Profile - Overview displayed. ",
    "application_error_100": "HV over voltage. Restart system. ",
    "application_error_1001": "Executable {0} failed verification. ",
    "application_error_1002": "Database integrity check failed. ",
    "application_error_1003": "Executable {0} passed verification. ",
    "application_error_1004": "Database integrity check passed. ",
    "application_error_1005": "Application process {0} started. ",
    "application_error_1006": "Application process {0} exited. ",
    "application_error_1007": "Application process {0} exited unexpectedly. {1} - {2}. ",
    "application_error_101": "Mainframe invalid system configuration. Restart system. ",
    "application_error_1012": "System unlocked for service access. ",
    "application_error_1013": "Application {0} failed to respond. ",
    "application_error_1015": "Process monitor has detected multiple application failures. Contact service. ",
    "application_error_1016": "System storage level low. ",
    "application_error_1017": "System storage level critical. ",
    "application_error_102": "Mainframe stop line fault. Restart system. ",
    "application_error_103": "Base coil stop line fault. Restart system. ",
    "application_error_104": "UI stop line fault. Restart system. ",
    "application_error_105": "Mainframe dump system fault. Restart system. ",
    "application_error_106": "Invalid coil category for the current system configuration. Restart system. ",
    "application_error_107": "Invalid mainframe NVRAM checksum. Restart system. ",
    "application_error_108": "Mainframe faulty charging relay detected. Restart system. ",
    "application_error_109": "Mainframe ARM LED drive failure. Restart system. ",
    "application_error_11": "Patient Profile - MT History displayed. ",
    "application_error_110": "Mainframe external PSU fault. Restart system. ",
    "application_error_111": "Mainframe over temperature. Restart system. ",
    "application_error_112": "Mainframe snubber board over temperature. Restart system. ",
    "application_error_113": "Mainframe under temperature. Restart system. ",
    "application_error_114": "HVCAP under temperature. Restart system. ",
    "application_error_115": "Mainframe snubber board under temperature. Restart system. ",
    "application_error_116": "Mainframe ambient over temperature. Restart system. ",
    "application_error_117": "Mainframe failed to produce protocol. Restart system. ",
    "application_error_119": "Mainframe EPV limit exceeded. Contact Service. ",
    "application_error_12": "Patient Profile - Treatment Plan displayed. ",
    "application_error_120": "Mainframe HCI limit exceeded. Contact Service. ",
    "application_error_121": "Mainframe EPV/HCI EEPROM checksum error. Restart system. ",
    "application_error_122": "Mainframe EPV/HCI EEPROM not initialized. Restart system. ",
    "application_error_123": "Mainframe service date expired. Contact Service. ",
    "application_error_124": "Database failure - application will be restarted to check database integrity. ",
    "application_error_125": "StimGuide connection lost.  ",
    "application_error_126": "StimGuide connection established. ",
    "application_error_127": "StimGuide connection lost. Exit the current session. ",
    "application_error_128": "Treatment Started {0} - {1}, {2}, {3}, {4}, {5}, {6}, {7},{8}, Raw Coil Temps - T1: {9} T2: {10}. Predicted Coil Temps - T1: {11} T2: {12} ",
    "application_error_129": "Treatment Started {0} - {1}, {2}, {3}, {4}, {5}, {6}, {7}, {8}, {9}, Raw Coil Temps - T1: {10} T2: {11}. Predicted Coil Temps - T1: {12} T2: {13} ",
    "application_error_13": "Patient Profile - Treatment History displayed. ",
    "application_error_130": "Treatment complete. Raw Coil Temps - T1: {0} T2: {1}. Predicted Coil Temps - T1: {2} T2: {3} ",
    "application_error_131": "Parameter {0} has been modified from {1} to {2}. ",
    "application_error_132": "{0} additional pulses have been delivered. Raw Coil Temps - T1: {1} T2: {2}. Predicted Coil Temps - T1: {3} T2: {4} ",
    "application_error_133": "Treatment delivery has been suspended. Raw Coil Temps - T1: {0} T2: {1}. Predicted Coil Temps - T1: {2} T2: {3} ",
    "application_error_134": "Treatment delivery has been resumed. Raw Coil Temps - T1: {0} T2: {1}. Predicted Coil Temps - T1: {2} T2: {3} ",
    "application_error_135": "Treatment accuracy reported as {0} : {1}, {2}, {3}, {4}. ",
    "application_error_136": "Run treatment screen has been closed and treatment has been cancelled. ",
    "application_error_137": "StimGuide workflow Error. Exit the current session. ",
    "application_error_138": "Failed to save data, not enough storage available. Free: {0}, Required: {1}. Contact Service. ",
    "application_error_139": "A coil has been connected the mainframe. ",
    "application_error_14": "Build or Edit Treatment Plan displayed. ",
    "application_error_140": "Coil ready to use. Coil ID: {0}, TSPS: {1}, TLTC: {2}, S1TC: {3}, S2TC: {4}, Average Power: {5}. ",
    "application_error_141": "StimGuide is being configured. ",
    "application_error_142": "StimGuide configuration complete. ",
    "application_error_143": "GPIO connection failure. ",
    "application_error_144": "USB/Mass Storage Device connected. ",
    "application_error_145": "USB/Mass Storage Device disconnected. ",
    "application_error_146": "GPIO Exception. ",
    "application_error_147": "Login attempt failed. ",
    "application_error_148": "User: {0} has logged into the system. ",
    "application_error_149": "New user: {0} created by {1} with role: {2}. ",
    "application_error_15": "New individual treatment creation initialized. ",
    "application_error_150": "User: {0} password reset. ",
    "application_error_151": "Coil out of position relative to the treatment target. Suspend treatment and reposition Coil before resuming. ",
    "application_error_152": "Output set from {0} to {1}. HVCAP: {2}. ",
    "application_error_153": "Coil predicted temperature has reached 40C - Raw Coil Temps - T1: {0} T2: {1}. Predicted Coil Temps - T1: {2} T2: {3} ",
    "application_error_154": "Pulse delivered at {0:###0.#}% - HVCAP: {1}. ",
    "application_error_155": "Unknown Fault ({0}). Restart the system. ",
    "application_error_156": "Mainframe EPV limit exceeded. Contact Service. ",
    "application_error_157": "Mainframe HCI limit exceeded. Contact Service. ",
    "application_error_158": "Port Expander Configuration Failure. Restart system and Contact Service.",
    "application_error_159": "Port Expander 0 Failure. Restart system and Contact Service.",
    "application_error_16": "Individual treatment template {0} is being modified. ",
    "application_error_160": "Port Expander 1 Failure. Restart system and Contact Service.",
    "application_error_161": "Product number incompatible with current software.",
    "application_error_162": "Protocol synchronization failure. Please retry treatment delivery.",
    "application_error_163": "Remote upgrade is available for the system {0} - {1} ",
    "application_error_164": "UI Software update initiated - From: {0} To: {1} ",
    "application_error_165": "Mainframe Software update initiated - From: {0} To: {1} ",
    "application_error_166": "UI Software update {0} successful. ",
    "application_error_167": "Mainframe Software update successful. ",
    "application_error_168": "UI Software update (0) failed. ",
    "application_error_169": "Mainframe Software update failed. ",
    "application_error_17": "Individual treatment template {0} saved. ",
    "application_error_170": "System remaining pulses are empty. Contact Sales. ",
    "application_error_171": "Max system pulse usage reached. Contact Sales. ",
    "application_error_172": "Please Switch to Treatment Coil",
    "application_error_173": "System Configuration Unknown. Please Contact Service.",
    "application_error_18": "New combined treatment creation initialized. ",
    "application_error_19": "Combined treatment template {0} is being modified. ",
    "application_error_2": "System Initialization successful. ",
    "application_error_20": "Combined treatment template {0} saved. ",
    "application_error_21": "New treatment plan created and assigned to a patient. ",
    "application_error_22": "Existing treatment plan has been updated. ",
    "application_error_23": "Treatments home displayed. ",
    "application_error_24": "{0} treatment cloned. ",
    "application_error_25": "System - User Info displayed. ",
    "application_error_26": "System - Hardware info displayed. ",
    "application_error_27": "System - System Info displayed. ",
    "application_error_28": "User information modification initiated. ",
    "application_error_29": "User information modified. ",
    "application_error_3": "First-time use wizard initiated. ",
    "application_error_30": "Date and time settings modification initiated. ",
    "application_error_31": "Date and time settings modified. ",
    "application_error_32": "Volume increased. ",
    "application_error_33": "Volume decreased. ",
    "application_error_34": "Brightness increased. ",
    "application_error_35": "Brightness decreased. ",
    "application_error_36": "Language settings modification initiated. ",
    "application_error_37": "Language settings modified. ",
    "application_error_38": "Region changed to {0}. ",
    "application_error_39": "Language set to {0}. ",
    "application_error_4": "Login screen displayed. ",
    "application_error_40": "Report template modification initiated. ",
    "application_error_41": "Report template modified. ",
    "application_error_42": "Contact us displayed. ",
    "application_error_43": "User signed out. ",
    "application_error_44": "User accessed help menu (Main Menu). ",
    "application_error_45": "User accessed help menu (rMT determination). ",
    "application_error_46": "User accessed help menu (Run Treatment). ",
    "application_error_47": "rMT Determination displayed. ",
    "application_error_48": "Run Treatment displayed. ",
    "application_error_49": "Network connection lost. ",
    "application_error_5": "Setup complete. ",
    "application_error_50": "Network connection established. ",
    "application_error_51": "Stimulator connection lost. Wait for reconnect.",
    "application_error_52": "Stimulator connection established. ",
    "application_error_53": "Stimulator connection lost. Wait for reconnect.",
    "application_error_54": "Coil ROM checksum incorrect. Disconnect and Reconnect Coil. ",
    "application_error_55": "EEPROM checksum incorrect. Disconnect and Reconnect Coil. ",
    "application_error_56": "Invalid coil interface category. Disconnect and Reconnect Coil. ",
    "application_error_57": "Invalid coil power category. Disconnect and Reconnect Coil. ",
    "application_error_58": "Coil temperature sensor circuit failure. Disconnect and Reconnect Coil. ",
    "application_error_59": "Bad serial command to coil. Disconnect and Reconnect Coil. ",
    "application_error_6": "Patient home displayed. ",
    "application_error_60": "Internal coil software error. Disconnect and Reconnect Coil. ",
    "application_error_61": "Invalid coil identification. Disconnect and Reconnect Coil. ",
    "application_error_62": "Invalid coil temperature algorithm coefficient. Disconnect and Reconnect Coil. ",
    "application_error_63": "Coil controller malfunction. Disconnect and Reconnect Coil. ",
    "application_error_64": "Rapid² coil algorithm constant checksum error. Disconnect and Reconnect Coil. ",
    "application_error_65": "Invalid coil enhanced power byte checksum. Disconnect and Reconnect Coil. ",
    "application_error_66": "Invalid coil average power checksum. Disconnect and Reconnect Coil. ",
    "application_error_67": "Coil under temperature. Disconnect and Reconnect Coil. ",
    "application_error_68": "Coil brown out detected. Disconnect and Reconnect Coil. ",
    "application_error_69": "Coil serial communications with mainframe lost (Coil Disconnected). Disconnect and Reconnect Coil. ",
    "application_error_7": "Failure to read from database. Retry operation. ",
    "application_error_70": "Bad serial command received outside of TRIGGATE. Disconnect and Reconnect Coil. ",
    "application_error_71": "Coil EMC Detected. Disconnect and Reconnect Coil. ",
    "application_error_72": "Coil invalid power identification. Disconnect and Reconnect Coil. ",
    "application_error_73": "Coil hardware stop activated. Disconnect and Reconnect Coil. ",
    "application_error_74": "Coil watchdog timeout. Disconnect and Reconnect Coil. ",
    "application_error_75": "Coil temperature interlock 3 activated. Disconnect and Reconnect Coil. ",
    "application_error_76": "Coil stop line fault. Disconnect and Reconnect Coil. ",
    "application_error_77": "Coil air extraction unit not operating correctly. Disconnect and Reconnect Coil. ",
    "application_error_78": "Coil EPV EEPROM Checksum error. Disconnect and Reconnect Coil. ",
    "application_error_79": "Coil EPV limit exceeded. Contact Service. ",
    "application_error_8": "\r\n\t\tFailure to write to database. Retry operation. ",
    "application_error_80": "Coil expiry date exceeded. Contact Service. ",
    "application_error_81": "Mainframe power fail. Restart system. ",
    "application_error_82": "Mainframe stack underflow. Restart system. ",
    "application_error_83": "Mainframe stack overflow. Restart system. ",
    "application_error_84": "Mainframe RTS overrun. Restart system. ",
    "application_error_85": "Mainframe watchdog timeout. Restart system. ",
    "application_error_86": "Mainframe unexpected reset. Restart system. ",
    "application_error_87": "Mainframe bad checksum. Restart system. ",
    "application_error_88": "Mainframe SYS debug error. Restart system. ",
    "application_error_89": "Coil over temp. Remove coil from Patient. ",
    "application_error_9": "New patient profile creation initiated. ",
    "application_error_90": "Coil max difference. Restart system. ",
    "application_error_91": "Mainframe stack over temperature. Restart system. ",
    "application_error_92": "Mainframe stack under temperature. Restart system. ",
    "application_error_93": "Mainframe stack max difference. Restart system. ",
    "application_error_94": "HVCAP over temperature. Restart system. ",
    "application_error_95": "HV Transformer over temperature. Restart system. ",
    "application_error_96": "Mainframe charge threshold failure. Restart system. ",
    "application_error_97": "VREF check failure. Restart system. ",
    "application_error_98": "HVCAP voltage comparison failure. Restart system. ",
    "application_error_99": "Mainframe charging fault. Restart system. ",
    "apply": "Apply",
    "are_you_sure": "Are you sure?",
    "armed_upper": "READY",
    "arming_upper": "ARMED",
    "assessment_analytics": "Assessment Analytics",
    "assessments": "Assessments",
    "assessor_type": "Assessed by",
    "assessor_type_external": "External",
    "assessor_type_physician": "Physician",
    "assessor_type_user": "User",
    "back": "Back",
    "basic_search": "Back to Search",
    "bootloader_exit_with_error_code_caption": "Magstim Bootloader Programmer",
    "bootloader_exit_with_error_code_message": "The update has failed, do you want to retry?",
    "bootloader_rollback_not_available_caption": "Magstim Bootloader Programmer",
    "bootloader_rollback_not_available_message": "Unable to find firmware to rollback to previously installed version '{0}' in folder: \r\n    \r\n{1}",
    "cancel": "Cancel",
    "cancel_warning_discard_and_exit": "Discard & exit",
    "cancel_warning_resume_edit": "Resume edit",
    "cancel_warning_title": "Warning",
    "cannot_find_user_in_pdm": "Error getting user - please check with the system administrator that the user is setup correctly",
    "changes_not_saved_warning": "Warning! Changes unsaved. Select OK to leave.",
    "charge_delay_duration": "Duration",
    "charge_delay_ms": "ms",
    "charge_delay_off": "Off",
    "charge_delay_on": "On",
    "charge_delay_title": "Charge Delay",
    "clear_filters": "Clear Filters",
    "clinic": "Clinic",
    "clinic_accuracy": "Clinic Accuracy",
    "clinic_add": "Add Clinic",
    "clinic_address": "Address",
    "clinic_analytics": "Clinic  Analytics",
    "clinic_analytics_help": "Use the buttons below to view the detailed clinic analytics for {0} ",
    "clinic_assessments": "Clinic Assessments",
    "clinic_country": "Country",
    "clinic_edit": "Edit Clinic",
    "clinic_max_users": "Max Users Per Clinic",
    "clinic_name": "Clinic Name",
    "clinic_phone": "Contact Number",
    "clinic_rep": "Clinic Representative",
    "clinic_rmt": "Clinic rMTs",
    "clinic_search": "Clinic Search",
    "clinic_status": "Status",
    "clinic_treatments": "Clinic Treatments",
    "clinic_users_per_clinic": "Users Per Clinic",
    "clinic_zip": "Zip / Postal Code",
    "clinical_assessment": "Clinical Assessment",
    "clinical_assessment_all_scales": "All Scales",
    "clinical_assessment_assessed_by": "Assessed By",
    "clinical_assessment_assessment_count": "Assessment Count",
    "clinical_assessment_assessment_date": "Assessment Date",
    "clinical_assessment_baseline": "Baseline",
    "clinical_assessment_change_all_time": "All Time Change",
    "clinical_assessment_change_from_previous": "Change From Previous",
    "clinical_assessment_change_in_range": "Change in Range",
    "clinical_assessment_chart_no_data": "Chart will show when at least 2 assessments have been carried out",
    "clinical_assessment_column_assessment_count_in_range": "Assessment count (in range)",
    "clinical_assessment_column_average_baseline": "Average baseline",
    "clinical_assessment_column_average_last_recorded": "Average last recorded",
    "clinical_assessment_column_improvement": "Improvement (-ive good)",
    "clinical_assessment_first_assessment_date": "First Assessment Date",
    "clinical_assessment_first_assessment_score": "First Assessment Score",
    "clinical_assessment_first_in_range_assessment_date": "First in Range Assessment Date",
    "clinical_assessment_first_in_range_assessment_score": "First in Range Assessment Score",
    "clinical_assessment_in_range_assessment_count": "Assessment in Range Count",
    "clinical_assessment_last_assessment": "Last Assessment",
    "clinical_assessment_last_assessment_rating": "Last Assessment Rating",
    "clinical_assessment_latest_assessment_date": "Latest Assessment Date",
    "clinical_assessment_rating_scale": "Rating Scale",
    "clinical_assessment_rating_score": "Rating Score",
    "clinical_assessment_rating_score_pc": "Rating Score %",
    "clinical_assessment_self_assessed": "Self assessed",
    "clinical_assessment_test_type": "Assessed Type",
    "clinical_assessment_type": "Assessment Type",
    "clinical_assessment_type_link": "Link",
    "clinical_assessment_type_link_copied": "Link Copied to Clipboard",
    "clinical_assessment_type_manual": "Manual Results Entry",
    "clinical_assessment_type_self": "Patient Self Assessment",
    "clinical_assessment_type_self_get_link": "Generate Link",
    "clinical_assessment_type_self_get_link_help": "Press ",
    "clinical_assessment_type_user": "User Assessment",
    "clinical_assessment_type_user_start": "Start Assessment",
    "clinical_assessments": "Clinical Assessments",
    "clinical_ratings_app_bdi_question_0": "Sadness",
    "clinical_ratings_app_bdi_question_1": "Pessimism",
    "clinical_ratings_app_bdi_question_10": "Agitation",
    "clinical_ratings_app_bdi_question_11": "Loss of Interest",
    "clinical_ratings_app_bdi_question_12": "Indecisiveness",
    "clinical_ratings_app_bdi_question_13": "Wothlessness",
    "clinical_ratings_app_bdi_question_14": "Loss of Energy",
    "clinical_ratings_app_bdi_question_15": "Changes in Sleeping Pattern",
    "clinical_ratings_app_bdi_question_16": "Irritability",
    "clinical_ratings_app_bdi_question_17": "Changes in Appetite",
    "clinical_ratings_app_bdi_question_18": "Concentration Difficulty",
    "clinical_ratings_app_bdi_question_19": "Tiredness or Fatigue",
    "clinical_ratings_app_bdi_question_2": "Past Failure",
    "clinical_ratings_app_bdi_question_20": "Loss of Interest in Sex",
    "clinical_ratings_app_bdi_question_3": "Loss of Pleasure",
    "clinical_ratings_app_bdi_question_4": "Guilty Feelings",
    "clinical_ratings_app_bdi_question_5": "Punishment Feelings",
    "clinical_ratings_app_bdi_question_6": "Self-Dislike",
    "clinical_ratings_app_bdi_question_7": "Self-Criticalness",
    "clinical_ratings_app_bdi_question_8": "Suicidal Thoughts or Wishes",
    "clinical_ratings_app_bdi_question_9": "Crying",
    "clinical_ratings_app_bdi_response_major": "Major",
    "clinical_ratings_app_bdi_response_minor": "Minor",
    "clinical_ratings_app_bdi_response_moderate": "Moderate",
    "clinical_ratings_app_bdi_response_severe": "Severe",
    "clinical_ratings_app_bdi_result_mild": "Mild",
    "clinical_ratings_app_bdi_result_minimal": "Minimal",
    "clinical_ratings_app_bdi_result_moderate": "Moderate",
    "clinical_ratings_app_bdi_result_severe": "Severe",
    "clinical_ratings_app_cesd_question_0": "I was bothered by things that usually don't bother me",
    "clinical_ratings_app_cesd_question_1": "I did not feel like eating",
    "clinical_ratings_app_cesd_question_10": "My sleep was restless",
    "clinical_ratings_app_cesd_question_11": "I was happy",
    "clinical_ratings_app_cesd_question_12": "I talked less than usual",
    "clinical_ratings_app_cesd_question_13": "I felt lonely",
    "clinical_ratings_app_cesd_question_14": "People were unfriendly",
    "clinical_ratings_app_cesd_question_15": "I enjoyed life",
    "clinical_ratings_app_cesd_question_16": "I had crying spells",
    "clinical_ratings_app_cesd_question_17": "I felt sad",
    "clinical_ratings_app_cesd_question_18": "I felt that people dislike me",
    "clinical_ratings_app_cesd_question_19": "I could not get going",
    "clinical_ratings_app_cesd_question_2": "I felt like that I could not shake off the blues even with help from family and friends",
    "clinical_ratings_app_cesd_question_3": "I felt I was just as good as other people",
    "clinical_ratings_app_cesd_question_4": "I had trouble keeping my mind on what I was doing",
    "clinical_ratings_app_cesd_question_5": "I felt depressed",
    "clinical_ratings_app_cesd_question_6": "I felt that everything I did was an effort",
    "clinical_ratings_app_cesd_question_7": "I felt hopeful about my future",
    "clinical_ratings_app_cesd_question_8": "I thought my life has been a failure",
    "clinical_ratings_app_cesd_question_9": "I felt fearful",
    "clinical_ratings_app_cesd_response_major": "Major",
    "clinical_ratings_app_cesd_response_minor": "Minor",
    "clinical_ratings_app_cesd_response_moderate": "Moderate",
    "clinical_ratings_app_cesd_response_none": "None",
    "clinical_ratings_app_cesd_result_depressionindicated": "Depression Indicated",
    "clinical_ratings_app_cesd_result_none": "None",
    "clinical_ratings_app_csdd_question_0": "Anxiety",
    "clinical_ratings_app_csdd_question_1": "Sadness",
    "clinical_ratings_app_csdd_question_10": "Lack of energy",
    "clinical_ratings_app_csdd_question_11": "Diurnal variation of mood",
    "clinical_ratings_app_csdd_question_12": "Difficulty falling asleep",
    "clinical_ratings_app_csdd_question_13": "Multiple awakenings during sleep",
    "clinical_ratings_app_csdd_question_14": "Early morning awakenings",
    "clinical_ratings_app_csdd_question_15": "Suicide",
    "clinical_ratings_app_csdd_question_16": "Self-depreciation",
    "clinical_ratings_app_csdd_question_17": "Pessimism",
    "clinical_ratings_app_csdd_question_18": "Mood congruent delusions",
    "clinical_ratings_app_csdd_question_2": "Lack of reactivity to pleasant events",
    "clinical_ratings_app_csdd_question_3": "Irritability",
    "clinical_ratings_app_csdd_question_4": "Agitation",
    "clinical_ratings_app_csdd_question_5": "Retardation",
    "clinical_ratings_app_csdd_question_6": "Multiple physical complaints",
    "clinical_ratings_app_csdd_question_7": "Loss of interest",
    "clinical_ratings_app_csdd_question_8": "Appetite loss",
    "clinical_ratings_app_csdd_question_9": "Weight loss",
    "clinical_ratings_app_csdd_response_major": "Major",
    "clinical_ratings_app_csdd_response_minor": "Minor",
    "clinical_ratings_app_csdd_response_moderate": "Moderate",
    "clinical_ratings_app_csdd_result_abscence": "Abscence",
    "clinical_ratings_app_csdd_result_definitemajordepression": "Definite Major Depression",
    "clinical_ratings_app_csdd_result_mild": "Mild",
    "clinical_ratings_app_csdd_result_probablemajordepression": "Probable Major Depression",
    "clinical_ratings_app_gad7_question_0": "Feeling nervous, anxious or on edge?",
    "clinical_ratings_app_gad7_question_1": "Not being able to stop or control worrying?",
    "clinical_ratings_app_gad7_question_2": "Worrying too much about different things?",
    "clinical_ratings_app_gad7_question_3": "Trouble relaxing?",
    "clinical_ratings_app_gad7_question_4": "Being so restless that it is hard to sit still?",
    "clinical_ratings_app_gad7_question_5": "Becoming easily annoyed or irritable?",
    "clinical_ratings_app_gad7_question_6": "Feeling afraid as if something awful might happen?",
    "clinical_ratings_app_gad7_response_morethanhalfthedays": "More than half the days",
    "clinical_ratings_app_gad7_response_nearlyeveryday": "Nearly every day",
    "clinical_ratings_app_gad7_response_notatall": "Not at all",
    "clinical_ratings_app_gad7_response_severaldays": "Several days",
    "clinical_ratings_app_gad7_result_mild": "Mild",
    "clinical_ratings_app_gad7_result_moderate": "Moderate",
    "clinical_ratings_app_gad7_result_none": "None",
    "clinical_ratings_app_gad7_result_severe": "Severe",
    "clinical_ratings_app_gds15_question_0": "Are you basically satisfied with your life?",
    "clinical_ratings_app_gds15_question_1": "Have you dropped many of your activities and interests?",
    "clinical_ratings_app_gds15_question_10": "Do you think it is wonderful to be alive now?",
    "clinical_ratings_app_gds15_question_11": "Do you feel pretty worthless the way your are now?",
    "clinical_ratings_app_gds15_question_12": "Do you feel full of energy?",
    "clinical_ratings_app_gds15_question_13": "Do you feel that your situation is hopeless?",
    "clinical_ratings_app_gds15_question_14": "Do you think most people are better off than you are?",
    "clinical_ratings_app_gds15_question_2": "Do you feel that your life is empty?",
    "clinical_ratings_app_gds15_question_3": "Do you often get bored?",
    "clinical_ratings_app_gds15_question_4": "Are you in good spirits most of the time?",
    "clinical_ratings_app_gds15_question_5": "Are you afraid that something bad is going to happen to you?",
    "clinical_ratings_app_gds15_question_6": "Do you feel happy most of the time?",
    "clinical_ratings_app_gds15_question_7": "Do you often feel helpless?",
    "clinical_ratings_app_gds15_question_8": "Do you prefer to stay at home rather than going out and doing new things?",
    "clinical_ratings_app_gds15_question_9": "Do you feel you have more problems with memory than most?",
    "clinical_ratings_app_gds15_response_no": "No",
    "clinical_ratings_app_gds15_response_yes": "Yes",
    "clinical_ratings_app_gds15_result_none": "None",
    "clinical_ratings_app_gds15_result_seekmedicaladvice": "Seek Medical Advice",
    "clinical_ratings_app_gds4_question_0": "Are you basically satisfied with your life?",
    "clinical_ratings_app_gds4_question_1": "Do you feel that your life is empty?",
    "clinical_ratings_app_gds4_question_2": "Are you afraid that something bad is going to happen to you?",
    "clinical_ratings_app_gds4_question_3": "Do you feel happy most of the time?",
    "clinical_ratings_app_gds4_response_no": "No",
    "clinical_ratings_app_gds4_response_yes": "Yes",
    "clinical_ratings_app_gds4_result_depressed": "Depressed",
    "clinical_ratings_app_gds4_result_notdepressed": "Not Depressed",
    "clinical_ratings_app_gds4_result_uncertain": "Uncertain",
    "clinical_ratings_app_hads_question_0": "Feel tense or 'wound up'",
    "clinical_ratings_app_hads_question_1": "I still enjoy the things I used to enjoy",
    "clinical_ratings_app_hads_question_10": "I feel restless as I have to be on the move",
    "clinical_ratings_app_hads_question_11": "I look forwards with enjoyment to things",
    "clinical_ratings_app_hads_question_12": "I get sudden feelings of panic",
    "clinical_ratings_app_hads_question_13": "I can enjoy a good book or radio or TV program",
    "clinical_ratings_app_hads_question_2": "I get a sort of frightened feeling as if something awful is about to happen",
    "clinical_ratings_app_hads_question_3": "I can laugh and see the funny side of things",
    "clinical_ratings_app_hads_question_4": "Worrying thoughts go through my mind",
    "clinical_ratings_app_hads_question_5": "I feel cheerful",
    "clinical_ratings_app_hads_question_6": "I can sit at ease and feel relaxed",
    "clinical_ratings_app_hads_question_7": "I feel as if I am slowed down",
    "clinical_ratings_app_hads_question_8": "I get a sort of frightened feeling like 'butterflies' in the stomach",
    "clinical_ratings_app_hads_question_9": "I have lost interest in my appearance",
    "clinical_ratings_app_hads_response_major": "Major",
    "clinical_ratings_app_hads_response_minor": "Minor",
    "clinical_ratings_app_hads_response_moderate": "Moderate",
    "clinical_ratings_app_hads_response_none": "None",
    "clinical_ratings_app_hads_result_abnormal": "Abnormal",
    "clinical_ratings_app_hads_result_borderline": "Borderline",
    "clinical_ratings_app_hads_result_normal": "Normal",
    "clinical_ratings_app_hamd_question_0": "Depressed Mood",
    "clinical_ratings_app_hamd_question_1": "Feelings of Guilt",
    "clinical_ratings_app_hamd_question_10": "Anxiety - Somatic",
    "clinical_ratings_app_hamd_question_11": "Somatic Symptoms - Gastrointestinal",
    "clinical_ratings_app_hamd_question_12": "Somatic Symptoms - General",
    "clinical_ratings_app_hamd_question_13": "Genital Symptoms",
    "clinical_ratings_app_hamd_question_14": "Hypochondriasis",
    "clinical_ratings_app_hamd_question_15": "Weight Loss",
    "clinical_ratings_app_hamd_question_16": "Insight",
    "clinical_ratings_app_hamd_question_17": "Diurnal Variation",
    "clinical_ratings_app_hamd_question_18": "Depersonalization and Derealization",
    "clinical_ratings_app_hamd_question_19": "Paranoid Symptoms",
    "clinical_ratings_app_hamd_question_2": "Suicide",
    "clinical_ratings_app_hamd_question_20": "Obsessional Symptoms",
    "clinical_ratings_app_hamd_question_3": "Insomnia (Initial)",
    "clinical_ratings_app_hamd_question_4": "Insomnia (Middle)",
    "clinical_ratings_app_hamd_question_5": "Insomnia (Delayed)",
    "clinical_ratings_app_hamd_question_6": "Work and Interests",
    "clinical_ratings_app_hamd_question_7": "Retardation",
    "clinical_ratings_app_hamd_question_8": "Agitation",
    "clinical_ratings_app_hamd_question_9": "Anxiety - Psychic",
    "clinical_ratings_app_hamd_response_absent": "Absent",
    "clinical_ratings_app_hamd_response_major": "Major",
    "clinical_ratings_app_hamd_response_minor": "Minor",
    "clinical_ratings_app_hamd_response_moderate": "Moderate",
    "clinical_ratings_app_hamd_response_severe": "Severe",
    "clinical_ratings_app_hamd_result_mild": "Mild",
    "clinical_ratings_app_hamd_result_moderate": "Moderate",
    "clinical_ratings_app_hamd_result_normal": "Normal",
    "clinical_ratings_app_hamd_result_severe": "Severe",
    "clinical_ratings_app_hamd_result_verysevere": "Very Severe",
    "clinical_ratings_app_idssr_question_0": "Falling asleep",
    "clinical_ratings_app_idssr_question_1": "Sleep during the night",
    "clinical_ratings_app_idssr_question_10": "Decreased or increased appetite",
    "clinical_ratings_app_idssr_question_11": "Decreased or increased weight",
    "clinical_ratings_app_idssr_question_12": "Concentration/decision making",
    "clinical_ratings_app_idssr_question_13": "View of myself",
    "clinical_ratings_app_idssr_question_14": "View of my future",
    "clinical_ratings_app_idssr_question_15": "Thoughts of death or suicide",
    "clinical_ratings_app_idssr_question_16": "General interest",
    "clinical_ratings_app_idssr_question_17": "Energy level",
    "clinical_ratings_app_idssr_question_18": "Capacity for pleasure or enjoyment",
    "clinical_ratings_app_idssr_question_19": "Interest in sex",
    "clinical_ratings_app_idssr_question_2": "Waking up too early",
    "clinical_ratings_app_idssr_question_20": "Feeling slowed down",
    "clinical_ratings_app_idssr_question_21": "Feeling restless",
    "clinical_ratings_app_idssr_question_22": "Aches and pains",
    "clinical_ratings_app_idssr_question_23": "Other bodily symptoms",
    "clinical_ratings_app_idssr_question_24": "Panic / Phobic symptoms",
    "clinical_ratings_app_idssr_question_25": "Constipation / diarrhoea",
    "clinical_ratings_app_idssr_question_26": "Interpersonal sensitivity",
    "clinical_ratings_app_idssr_question_27": "Leaden paralysis / physical energy",
    "clinical_ratings_app_idssr_question_3": "Sleeping too much",
    "clinical_ratings_app_idssr_question_4": "Feeling sad",
    "clinical_ratings_app_idssr_question_5": "Feeling irritable",
    "clinical_ratings_app_idssr_question_6": "Feeling anxious or tense",
    "clinical_ratings_app_idssr_question_7": "Response of your mood to good or desired events",
    "clinical_ratings_app_idssr_question_8": "Mood in relation to the time of day",
    "clinical_ratings_app_idssr_question_9": "The quality of your mood",
    "clinical_ratings_app_idssr_response_major": "Major",
    "clinical_ratings_app_idssr_response_minor": "Minor",
    "clinical_ratings_app_idssr_response_moderate": "Moderate",
    "clinical_ratings_app_idssr_response_none": "None",
    "clinical_ratings_app_idssr_result_mild": "Mild",
    "clinical_ratings_app_idssr_result_moderate": "Moderate",
    "clinical_ratings_app_idssr_result_none": "None",
    "clinical_ratings_app_idssr_result_severe": "Severe",
    "clinical_ratings_app_idssr_result_verysevere": "Very Severe",
    "clinical_ratings_app_madrs_question_0": "Apparent sadness",
    "clinical_ratings_app_madrs_question_1": "Reported sadness",
    "clinical_ratings_app_madrs_question_2": "Inner tension",
    "clinical_ratings_app_madrs_question_3": "Reduced sleep",
    "clinical_ratings_app_madrs_question_4": "Reduced appetite",
    "clinical_ratings_app_madrs_question_5": "Concentration difficulties",
    "clinical_ratings_app_madrs_question_6": "Lassitude",
    "clinical_ratings_app_madrs_question_7": "Inability to feel",
    "clinical_ratings_app_madrs_question_8": "Pessimistic thoughts",
    "clinical_ratings_app_madrs_question_9": "Suicidal thoughts",
    "clinical_ratings_app_madrs_response_extreme": "Extreme",
    "clinical_ratings_app_madrs_response_highest": "Highest",
    "clinical_ratings_app_madrs_response_major": "Major",
    "clinical_ratings_app_madrs_response_minor": "Minor",
    "clinical_ratings_app_madrs_response_moderate": "Moderate",
    "clinical_ratings_app_madrs_response_none": "None",
    "clinical_ratings_app_madrs_response_severe": "Severe",
    "clinical_ratings_app_madrs_result_mild": "Mild",
    "clinical_ratings_app_madrs_result_moderate": "Moderate",
    "clinical_ratings_app_madrs_result_normal": "Normal",
    "clinical_ratings_app_madrs_result_severe": "Severe",
    "clinical_ratings_app_message_submission_complete": "Your clinical rating has been submitted.\r\n    \r\nYou can now close this window.",
    "clinical_ratings_app_phq9_question_0": "Little interest or pleasure in doing things?",
    "clinical_ratings_app_phq9_question_1": "Feeling down, depressed, or hopeless?",
    "clinical_ratings_app_phq9_question_2": "Trouble falling or staying asleep, or sleeping too much?",
    "clinical_ratings_app_phq9_question_3": "Feeling tired or having little energy?",
    "clinical_ratings_app_phq9_question_4": "Poor appetite or overeating?",
    "clinical_ratings_app_phq9_question_5": "Feeling bad about yourself – or that you are a failure or have let yourself or your family down?",
    "clinical_ratings_app_phq9_question_6": "Trouble concentrating on things, such as reading the newspaper or watching television?",
    "clinical_ratings_app_phq9_question_7": "Moving or speaking so slowly that other people could have noticed? Or the opposite – being so fidgety or restless that you have been moving around a lot more than usual?",
    "clinical_ratings_app_phq9_question_8": "Thoughts that you would be better off dead or of hurting yourself in some way?",
    "clinical_ratings_app_phq9_response_morethanhalfthedays": "More than half the days",
    "clinical_ratings_app_phq9_response_nearlyeveryday": "Nearly every day",
    "clinical_ratings_app_phq9_response_notatall": "Not at all",
    "clinical_ratings_app_phq9_response_severaldays": "Several days",
    "clinical_ratings_app_phq9_result_mild": "Mild",
    "clinical_ratings_app_phq9_result_minimal": "Minimal",
    "clinical_ratings_app_phq9_result_moderate": "Moderate",
    "clinical_ratings_app_phq9_result_moderatelysevere": "Moderately Severe",
    "clinical_ratings_app_phq9_result_severe": "Severe",
    "clinical_ratings_app_qids_question_0": "Falling asleep",
    "clinical_ratings_app_qids_question_1": "Sleep during the night",
    "clinical_ratings_app_qids_question_10": "View of myself",
    "clinical_ratings_app_qids_question_11": "Thoughts of death or suicide",
    "clinical_ratings_app_qids_question_12": "General interest",
    "clinical_ratings_app_qids_question_13": "Energy level",
    "clinical_ratings_app_qids_question_14": "Feeling slowed down",
    "clinical_ratings_app_qids_question_15": "Feeling restless",
    "clinical_ratings_app_qids_question_2": "Waking up too early",
    "clinical_ratings_app_qids_question_3": "Sleeping too much",
    "clinical_ratings_app_qids_question_4": "Feeling sad",
    "clinical_ratings_app_qids_question_5": "Decreased appetite",
    "clinical_ratings_app_qids_question_6": "Increased appetite",
    "clinical_ratings_app_qids_question_7": "Decreased weight (Last two weeks)",
    "clinical_ratings_app_qids_question_8": "Increased weight (Last two weeks)",
    "clinical_ratings_app_qids_question_9": "Concentration/Decision Making",
    "clinical_ratings_app_qids_response_major": "Major",
    "clinical_ratings_app_qids_response_minor": "Minor",
    "clinical_ratings_app_qids_response_moderate": "Moderate",
    "clinical_ratings_app_qids_response_none": "None",
    "clinical_ratings_app_qids_result_mild": "Mild",
    "clinical_ratings_app_qids_result_moderate": "Moderate",
    "clinical_ratings_app_qids_result_none": "None",
    "clinical_ratings_app_qids_result_severe": "Severe",
    "clinical_ratings_app_qids_result_verysevere": "VerySevere",
    "clinical_ratings_app_title_assessment": "Assessment {0}",
    "clinical_ratings_app_title_error": "Error",
    "clinical_ratings_app_title_submission_complete": "Submission complete",
    "clinical_ratings_app_undefined": "Undefined",
    "clinical_ratings_app_ybocs_question_0": "Time occupied by obsessive thoughts",
    "clinical_ratings_app_ybocs_question_1": "Obsession-free interval",
    "clinical_ratings_app_ybocs_question_10": "Resistance against compulsions",
    "clinical_ratings_app_ybocs_question_11": "Degree of control over compulsive behaviour",
    "clinical_ratings_app_ybocs_question_2": "Interference due to obsessive thoughts",
    "clinical_ratings_app_ybocs_question_3": "Distress associated with obsessive thoughts",
    "clinical_ratings_app_ybocs_question_4": "Resistance against obsessions",
    "clinical_ratings_app_ybocs_question_5": "Degree of control over obsessive thoughts",
    "clinical_ratings_app_ybocs_question_6": "Time spent performing compulsive behaviours",
    "clinical_ratings_app_ybocs_question_7": "Compulsion-free interval",
    "clinical_ratings_app_ybocs_question_8": "Interference due to compulsive behaviours",
    "clinical_ratings_app_ybocs_question_9": "Distress associated with compulsive behaviour",
    "clinical_ratings_app_ybocs_response_major": "Major",
    "clinical_ratings_app_ybocs_response_minor": "Minor",
    "clinical_ratings_app_ybocs_response_moderate": "Moderate",
    "clinical_ratings_app_ybocs_response_none": "None",
    "clinical_ratings_app_ybocs_response_severe": "Severe",
    "clinical_ratings_app_ybocs_result_extreme": "Extreme",
    "clinical_ratings_app_ybocs_result_mild": "Mild",
    "clinical_ratings_app_ybocs_result_moderate": "Moderate",
    "clinical_ratings_app_ybocs_result_none": "None",
    "clinical_ratings_app_ybocs_result_severe": "Severe",
    "clinical_ratings_app_zungsds_question_0": "I feel down-hearted and blue",
    "clinical_ratings_app_zungsds_question_1": "Morning is when I feel the best",
    "clinical_ratings_app_zungsds_question_10": "My mind is as clear as it used to be",
    "clinical_ratings_app_zungsds_question_11": "I find it easy to do the things I used to",
    "clinical_ratings_app_zungsds_question_12": "I am restless and can’t keep still",
    "clinical_ratings_app_zungsds_question_13": "I feel hopeful about the future",
    "clinical_ratings_app_zungsds_question_14": "I am more irritable than usual",
    "clinical_ratings_app_zungsds_question_15": "I find it easy to make decisions",
    "clinical_ratings_app_zungsds_question_16": "I feel that I am useful and needed",
    "clinical_ratings_app_zungsds_question_17": "My life is pretty full",
    "clinical_ratings_app_zungsds_question_18": "I feel that other would be better off if I were dead",
    "clinical_ratings_app_zungsds_question_19": "I still enjoy the things I used to do",
    "clinical_ratings_app_zungsds_question_2": "I have crying spells or feel like it",
    "clinical_ratings_app_zungsds_question_3": "I have trouble sleeping at night",
    "clinical_ratings_app_zungsds_question_4": "I eat as much as I used to",
    "clinical_ratings_app_zungsds_question_5": "I still enjoy sex",
    "clinical_ratings_app_zungsds_question_6": "I noticed that I am losing weight",
    "clinical_ratings_app_zungsds_question_7": "I have trouble with constipation",
    "clinical_ratings_app_zungsds_question_8": "My heart beats faster than usual",
    "clinical_ratings_app_zungsds_question_9": "I get tired for no reason",
    "clinical_ratings_app_zungsds_response_major": "Major",
    "clinical_ratings_app_zungsds_response_minor": "Minor",
    "clinical_ratings_app_zungsds_response_moderate": "Moderate",
    "clinical_ratings_app_zungsds_response_none": "None",
    "clinical_ratings_app_zungsds_result_mild": "Mild",
    "clinical_ratings_app_zungsds_result_moderate": "Moderate",
    "clinical_ratings_app_zungsds_result_normal": "Normal",
    "clinical_ratings_app_zungsds_result_severe": "Severe",
    "clinical_ratings_error_expired": "The link expired on {0}.\r\n  \r\nPlease contact your clinician for another test.",
    "clinical_ratings_error_invalid_arg": "Test link is invalid.\r\n  \r\nPlease contact your clinician for another test.",
    "clinical_ratings_error_missing_arg": "Test link is missing.\r\n  \r\nPlease contact your clinician for another test.",
    "clinical_ratings_error_submission_failed": "Submssion failed with error code {0}.\r\n  \r\nPlease contact your clinician to return the results.\r\n\r\nYour responses were:\r\n\r\n{1}\r\n",
    "clinical_ratings_must_be_greater_than": "Rating must be greater than or equal to",
    "clinical_ratings_must_be_less_than": "Rating must be less than or equal to",
    "clinical_ratings_no_future": "Cannot be in the future",
    "clinical_ratings_out_of_range": "Rating out of range",
    "clinical_ratings_scale_invalid": "Rating scale invalid",
    "clinics": "Clinics",
    "coil_upper": "COIL",
    "combined_treatment_not_unique": "The combined treatment {0} has the same treatments",
    "comparison_equals": "=",
    "comparison_greater": ">",
    "comparison_greater_equals": ">=",
    "comparison_less": "<",
    "comparison_less_equals": "<=",
    "connected_upper": "CONNECTED",
    "contact_address": "Address",
    "contact_address_detail": "The Magstim Company Ltd.  \r\nSpring Gardens, Whitland, \r\nSA34 0HR, UK",
    "contact_details_feedback": "feedback@magstim.com",
    "contact_email": "Email Us",
    "contact_email_detail": "sales@magstim.com\r\nsupport@magstim.com\r\nfeedback@magstim.com",
    "contact_email_detail_sales": "sales@magstim.com",
    "contact_email_detail_support": "support@magstim.com",
    "contact_email_help": "*Replies will be send to the email address associated with this profile",
    "contact_email_sent": "Your message has been sent, thank you.",
    "contact_map_link": "https://maps.google.com/maps?ll=51.820153,-4.599156&z=10&t=m&hl=en-US&gl=US&mapclient=embed&cid=15958836266708482297",
    "contact_phone": "Telephone",
    "contact_phone_number": "+44 (0) 1994 240798",
    "contact_send": "Send",
    "contact_web": "Web",
    "contact_web_detail": "https://www.magstim.com/",
    "contact_within_tolerance_count": "Contact Within Tolerance Count",
    "create_combined_treatment_template_confirmation_message": "Treatment has been saved successfully.",
    "create_individual_treatment_template_confirmation_message": "Treatment has been saved successfully.",
    "create_insurance_provider_name_must_be_unique": "Insurance Provider name must be unique",
    "create_organisation_name_must_be_unique": "Organisation name must be unique",
    "create_patient_confirmation_message": "Information has been saved successfully.",
    "create_user_all_fields_must_be_completed": "All fields marked with a * must be completed",
    "create_user_email_must_be_unique": "User email must be unique",
    "create_user_error": "Error creating user",
    "date_of_birth_conformation_dob_label": "Date of Birth",
    "date_of_birth_conformation_message": "Please ask your patient to confirm their date of birth, then enter the details below:",
    "date_of_birth_conformation_ok": "OK",
    "date_of_birth_conformation_title": "Date of Birth Confirmation",
    "date_of_birth_error": "Sorry, date of birth incorrect.",
    "date_time_separator": " at ",
    "define_targets_help": "Ensure the coil is at a 45° angle to the mid-line of the head and placed tangential to the curvature of the head",
    "detailed_report_patient_default_title": "Patient Report",
    "detailed_report_patient_heading": "Patient Report : {0}",
    "detailed_report_patient_sub_heading_information": "Patient Information",
    "detailed_report_patient_subject": "Patient {0} - {1}",
    "detailed_report_standard_info_clinic_details": "Clinic Details",
    "detailed_report_standard_info_date_created": "Report created",
    "detailed_report_standard_info_date_range": "Report timeframe",
    "detailed_report_treater_default_title": "Treater Report",
    "detailed_report_treater_heading": "Treater Report : {0}",
    "detailed_report_treater_sub_header_patient": "{0} - {1}",
    "detailed_report_treater_sub_heading_information": "Treater Information",
    "detailed_report_treater_subject": "Treater {0} - {1}",
    "device": "Device",
    "device_accuracy": "Device Accuracy",
    "device_analytics": "Device Analytics",
    "device_analytics_help": "Use the buttons below to view the detailed device analytics for {0}",
    "device_details": "Device Details",
    "device_enforced_wait_time_left": "System can be armed in {0} seconds",
    "device_rmt": "Device rMTs",
    "device_traceability": "Device Traceability",
    "device_treatments": "Device Treatments",
    "device_wait_for_enforced_wait_time": "Please wait until the system can be armed",
    "devices": "Devices",
    "discard_treatment_answer_no": "Cancel",
    "discard_treatment_answer_yes": "Discard",
    "discard_treatment_message": "Are you sure you want to discard this treatment?",
    "discard_treatment_not_allowed_in_combined": "You are unable to delete this individual treatment template while it is used in the following combined treatment templates:\r\n    \r\n{0}\r\n\r\nPlease edit the combined treatment templates to no longer include this individual treatment template and try deleting again.\r\n",
    "discard_treatmentplan_answer_yes": "Confirm",
    "disconnected_upper": "DISCONNECTED",
    "distance_within_tolerance_count": "Distance Within Tolerance Count",
    "download": "Download",
    "download_complete": "{0}% Complete",
    "download_file_count": "{0} of {1}",
    "download_updates": "Downloading Updates...",
    "edit_patient_additional_info": "Additional Information",
    "edit_patient_address_label": "Address",
    "edit_patient_back": "Back",
    "edit_patient_clinical_assessment": "Clinical Assessment Baseline",
    "edit_patient_confirm_cancel": "Any unsaved data will be lost.",
    "edit_patient_contact_number_label": "Contact Number",
    "edit_patient_country_label": "Country",
    "edit_patient_day_label": "DD",
    "edit_patient_diagnosis": "Diagnosis",
    "edit_patient_diagnosis_code_label": "ICD-10 Code Type",
    "edit_patient_dob_name_label": "Date of Birth*",
    "edit_patient_dosage_label": "Dosage",
    "edit_patient_edit_label": "Edit",
    "edit_patient_effective_date_label": "Effective Date",
    "edit_patient_essential_info": "Essential Information (*Required Fields)",
    "edit_patient_ethnicity_label": "Patient Ethnicity",
    "edit_patient_first_name_label": "First Name*",
    "edit_patient_frequency_label": "Frequency",
    "edit_patient_gender_columnname": "Patient Gender",
    "edit_patient_gender_label": "Gender",
    "edit_patient_handedness_label": "Patient Handedness",
    "edit_patient_id_label": "Patient ID*",
    "edit_patient_insurance_provider_label": "Insurance Provider",
    "edit_patient_last_name_label": "Last Name*",
    "edit_patient_managing_physician_label": "Managing Physician",
    "edit_patient_medication_label": "Medication",
    "edit_patient_medication_record": "Medication Record",
    "edit_patient_medications": "Medications",
    "edit_patient_month_label": "MM",
    "edit_patient_next": "Next",
    "edit_patient_notes_label": "General Notes",
    "edit_patient_patient_id_must_be_unique": "Patient ID must be unique",
    "edit_patient_primary_diagnosis_label": "Primary Diagnosis",
    "edit_patient_referring_physician_label": "Referring Physician",
    "edit_patient_required": "required",
    "edit_patient_save_label": "Save",
    "edit_patient_secondary_diagnosis_label": "Secondary Diagnosis",
    "edit_patient_title_label": "Add new or edit patient details (*required fields)",
    "edit_patient_treatment_stage_label": "Treatment Stage",
    "edit_patient_unit_label": "Units",
    "edit_patient_validation_error": "Please correct the following",
    "edit_patient_year_label": "YYYY",
    "edit_patient_zip_label": "Post Code",
    "edit_treatment_plan_confirmation_message": "Saved successfully. A new patient treatment plan:\r\n{0}\r\nhas been assigned for\r\n{1} - Patient ID: {2}",
    "edit_treatment_plan_none": "None",
    "edit_treatment_plan_stimguide_required": "StimGuide Required",
    "enum_usertype_magstimadmin": "Magstim Admin",
    "enum_usertype_organisationadmin": "Organisation Admin",
    "enum_usertype_organisationuser": "Organisation User",
    "error_upper": "ERROR",
    "error_value_reason": "{0} {1}",
    "event_code": "Event Code",
    "event_log": "Event Log",
    "event_message": "Message",
    "event_time": "Date / Time",
    "filter_option_alltime": "All Time",
    "filter_option_last4weeks": "Last 4 Weeks",
    "filter_option_last6months": "Last 6 Months",
    "filter_option_lastyear": "Last Year",
    "frequency_too_high_for_power": "Frequency too high for power",
    "ftu_wizard_cancel_caption": "Any unsaved data will be lost.\r\n    \r\nAre you sure you wish to cancel?",
    "ftu_wizard_cancel_continue": "Continue Setup",
    "ftu_wizard_cancel_shutdown": "Shutdown",
    "full_name": "Full Name",
    "generic_duplicate_property_warning_message": "\"An item with the same {0} already exists. Please try a different {0}.\"",
    "head_tracker_upper": "HEAD TRACKER",
    "help_file_name": "MPS14-US-03.pdf",
    "hide_nav_view": "Hide navigation view",
    "history_details_burst_accuracy": "Average Accuracy",
    "history_details_burst_additionalPulses": "Additional Pulses",
    "history_details_burst_bpc": "Bursts Per Cycle",
    "history_details_burst_cycles": "Total No. of Cycles",
    "history_details_burst_cycleTime": "Cycle Time",
    "history_details_burst_duration": "Treatment Duration",
    "history_details_burst_manualLocation": "Manual Location",
    "history_details_burst_mode": "Mode",
    "history_details_burst_pcRMT": "Treatment %rMT Level",
    "history_details_burst_ppb": "Pulses Per Burst",
    "history_details_burst_pps": "Hz (PPS)",
    "history_details_burst_pulses": "Total No. of Pulses",
    "history_details_burst_stimguideLocation": "StimGuide Location",
    "history_details_standard_accuracy": "Average Accuracy",
    "history_details_standard_additionalPulses": "Additional Pulses",
    "history_details_standard_duration": "Treatment Duration",
    "history_details_standard_manualLocation": "Manual Location",
    "history_details_standard_mode": "Mode",
    "history_details_standard_offTime": "Off Time",
    "history_details_standard_onTime": "On Time",
    "history_details_standard_pcRMT": "Treatment %rMT Level",
    "history_details_standard_pps": "Hz (PPS)",
    "history_details_standard_ppt": "Pulses Per Train",
    "history_details_standard_pulses": "Total No. of Pulses",
    "history_details_standard_stimguideLocation": "StimGuide Location",
    "history_details_standard_trains": "Total No. of Trains",
    "history_details_stimguide_required": "StimGuide Required",
    "home_contact_us": "Contact us",
    "home_patients": "Patients",
    "home_sign_out": "Sign out",
    "home_system": "System",
    "home_treatments": "Treatments",
    "image_upload_help": "jpg or png less than 1MB.",
    "import": "Import",
    "import_export": "Import / Export",
    "import_export_error": "Patient CSV data in unknown / invalid format.\r\n\r\nFor further information on the file format and detailed instructions for importing the data, please consult the Help Documentation, Operating Manual or contact Magstim Support.",
    "import_export_help": "To import pre-existing patient data, please use the Import function.\r\n    \r\nTo export the patient data for download please use the Export function. \r\n\r\nFor further information on the file format and detailed instructions for importing or exporting the data, please consult the Help Documentation, Operating Manual or contact Magstim Support.",
    "include": "Include",
    "include_report_footer": "Include Footer",
    "include_report_header": "Include Header",
    "include_report_image": "Include Image",
    "include_report_title": "Include Title",
    "individual_treatment_not_unique": "The treatment {0} has the same settings",
    "individual_treatment_type_burst": "Burst",
    "individual_treatment_type_standard": "Standard",
    "info_upper": "INFO",
    "insurance_provider": "Insurance Provider",
    "insurance_provider_add": "Add Insurance Provider",
    "insurance_provider_details": "Details",
    "insurance_provider_edit": "Edit Insurance Provider",
    "insurance_provider_name": "Name",
    "insurance_providers": "Insurance Providers",
    "landmark_date": "Created",
    "landmark_delete": "Delete",
    "landmark_delete_message": "Are you sure you want to delete this landmark?",
    "landmark_edit": "Edit",
    "landmark_name": "Name",
    "landmark_none": "None",
    "landmark_show": "Show",
    "landmark_x_pos": "x (mm)",
    "landmark_y_pos": "y (mm)",
    "landmark_z_pos": "z (mm)",
    "landmarks_edit": "Edit Addtional Landmarks",
    "landmarks_manage": "Manage Landmarks",
    "landmarks_to_register": "Landmarks to register",
    "language_english_chinese": "Chinese",
    "language_english_uk": "English (UK)",
    "language_english_us": "English (US)",
    "last_sync_time_message": "Sync last run on {0} at {1}",
    "location": "Location",
    "login_error_invalid": "is invalid",
    "login_error_message": "Details incorrect",
    "login_error_message_permissions": "You do not have the permission to access the device, please contact your system administrator.",
    "login_error_mismatch": "does not match",
    "login_error_required": "is required",
    "login_error_title": "Error",
    "login_error_tooshort": "is too short",
    "login_password": "Password",
    "login_signin": "Sign in",
    "login_tagline": "TMS Therapy",
    "login_username": "Username",
    "logo_too_big_message": "The logo must be less than 1MB. ",
    "marker_upper": "MARKER",
    "max_must_be_more_than_Min": "Max must be more than Min",
    "max_required": "Max value required",
    "max_train_on_time_exceeded": "Max train on time exceeded",
    "medication_add": "Add Medication",
    "message_box_cancel": "Cancel",
    "message_box_done": "Done",
    "message_box_no": "No",
    "message_box_OK": "OK",
    "message_box_yes": "Yes",
    "min_must_be_less_than_max": "Min must be less than Max",
    "min_required": "Min value required",
    "month_1": "January ",
    "month_1_short": "Jan",
    "month_10": "October",
    "month_10_short": "Oct",
    "month_11": "November",
    "month_11_short": "Nov",
    "month_12": "December",
    "month_12_short": "Dec",
    "month_2": "February",
    "month_2_short": "Feb",
    "month_3": "March",
    "month_3_short": "Mar",
    "month_4": "April",
    "month_4_short": "Apr",
    "month_5": "May",
    "month_5_short": "May",
    "month_6": "June",
    "month_6_short": "Jun",
    "month_7": "July",
    "month_7_short": "Jul",
    "month_8": "August",
    "month_8_short": "Aug",
    "month_9": "September",
    "month_9_short": "Sep",
    "more": "more",
    "motor_threshold_exit_close": "Discard and close",
    "motor_threshold_exit_resume": "Resume rMT",
    "motor_threshold_exit_without_save": "Any unsaved data will be lost.\r\n\r\nAre you sure you wish to close?",
    "motor_threshold_help": "Please refer to the Magstim guide to motor threshold assessment for detailed information on how to perform a %rMT assessment safely and effectively.",
    "motor_threshold_info": "rMT Info",
    "motor_threshold_last": "Last Assessment By",
    "motor_threshold_last_date_format": "{0} days ago on {1}",
    "motor_threshold_no_treatment_plan": "Please assign a treatment plan to the patient.",
    "motor_threshold_notes": "Notes",
    "motor_threshold_output": "Output",
    "motor_threshold_previous": "Previous %rMT",
    "motor_threshold_response": "Response",
    "motor_threshold_save_and_close": "Save Output \r\n    & Close",
    "motor_threshold_save_and_treat": "  Save Output & Go \r\n      to Treatment",
    "motor_threshold_sub_tile": "Output Level Adjustment & Counter",
    "motor_threshold_tile": "New Motor Threshold (rMT) Determination",
    "MSG_0001": "Options Menu",
    "MSG_0002": "Single Pulse (MEP)",
    "MSG_0003": "Repetitive Mode",
    "MSG_0004": "Session Mode",
    "MSG_0005": "System",
    "MSG_0006": "File Maintenance",
    "MSG_0007": "Help",
    "MSG_0008": "Quit",
    "MSG_0009": "Single Pulse Mode",
    "MSG_0010": "Power",
    "MSG_0011": "Stimulator",
    "MSG_0012": "Output",
    "MSG_0013": "%rMT",
    "MSG_0014": "Protocol",
    "MSG_0015": "Coil Status",
    "MSG_0016": "System Status",
    "MSG_0017": "Temperature",
    "MSG_0018": "Type",
    "MSG_0019": "STOPPED",
    "MSG_0020": "ARMED",
    "MSG_0021": "READY",
    "MSG_0022": "WAITING",
    "MSG_0023": "Repetitive",
    "MSG_0024": "Session",
    "MSG_0025": "Enhanced",
    "MSG_0026": "File",
    "MSG_0027": "Single Pulse",
    "MSG_0028": "Channel 1",
    "MSG_0029": "Channel 2",
    "MSG_0030": "Time Base",
    "MSG_0031": "A = ",
    "MSG_0032": "Filters",
    "MSG_0033": "2Hz-10kHz",
    "MSG_0034": "20Hz-10kHz",
    "MSG_0035": "Volts/div",
    "MSG_0036": "L1 = ",
    "MSG_0037": "L2 = ",
    "MSG_0038": "Display",
    "MSG_0039": "Both",
    "MSG_0040": "Time Cursors",
    "MSG_0041": "Status",
    "MSG_0042": "Channel 1 Latencies",
    "MSG_0043": "Channel 2 Latencies",
    "MSG_0044": "Amplitude Cursors",
    "MSG_0045": "Trace 1",
    "MSG_0046": "Trace 2",
    "MSG_0047": "ON",
    "MSG_0048": "OFF",
    "MSG_0049": "Repetitive Setup",
    "MSG_0050": "Frequency",
    "MSG_0051": "Duration",
    "MSG_0052": "of Pulses",
    "MSG_0053": "Wait Time",
    "MSG_0054": "of Trains",
    "MSG_0055": "Total Number of Pulses",
    "MSG_0056": "Pulses",
    "MSG_0057": "Number",
    "MSG_0058": "Run Session",
    "MSG_0059": "MEP",
    "MSG_0060": "Number of",
    "MSG_0061": "Complete",
    "MSG_0062": "View",
    "MSG_0063": "Setup",
    "MSG_0064": "Session Setup",
    "MSG_0065": "Line",
    "MSG_0066": "Start Time",
    "MSG_0067": "Scroll Up",
    "MSG_0068": "Delete Line",
    "MSG_0069": "Add/Copy",
    "MSG_0070": "Delete All",
    "MSG_0071": "Scroll Down",
    "MSG_0072": "Session Mode",
    "MSG_0073": "Active Line",
    "MSG_0074": "Traces",
    "MSG_0075": "Scroll Left",
    "MSG_0076": "Scroll Right",
    "MSG_0077": "Back",
    "MSG_0078": "Yes",
    "MSG_0079": "No",
    "MSG_0080": "Shot Number",
    "MSG_0081": "Local Store",
    "MSG_0082": "Memory Card",
    "MSG_0083": "New",
    "MSG_0084": "Open",
    "MSG_0085": "Save",
    "MSG_0086": "Rename",
    "MSG_0087": "Delete",
    "MSG_0088": "Export",
    "MSG_0089": "Import",
    "MSG_0090": "Parameters",
    "MSG_0091": "Details Menu",
    "MSG_0092": "Patient Details",
    "MSG_0093": "ID#:",
    "MSG_0094": "Protocol Description:",
    "MSG_0095": "Name:",
    "MSG_0096": "Sex:",
    "MSG_0097": "Date of Birth:",
    "MSG_0098": "Time",
    "MSG_0099": "Comments:",
    "MSG_0100": "System Options Menu",
    "MSG_0101": "User Configuration",
    "MSG_0102": "System Details",
    "MSG_0103": "System Configuration",
    "MSG_0104": "UI Details",
    "MSG_0105": "POD Details",
    "MSG_0106": "Base Details",
    "MSG_0107": "Coil Details",
    "MSG_0108": "PSU Details",
    "MSG_0109": "Software Number:",
    "MSG_0110": "Hardware Number:",
    "MSG_0111": "Serial Number:",
    "MSG_0112": "Version:",
    "MSG_0113": "Revision:",
    "MSG_0114": "Version",
    "MSG_0115": "Volume",
    "MSG_0116": "Contrast",
    "MSG_0117": "Coil Switch",
    "MSG_0118": "Enter 4 Digit Access Code",
    "MSG_0119": "Clear",
    "MSG_0120": "Enter",
    "MSG_0121": "File:",
    "MSG_0122": "-----",
    "MSG_0123": "Amplitude",
    "MSG_0124": "Cursors",
    "MSG_0125": "Option",
    "MSG_0126": "Session Details",
    "MSG_0127": "Total",
    "MSG_0128": "Trains",
    "MSG_0129": "Train",
    "MSG_0130": "Number",
    "MSG_0131": "Pulses",
    "MSG_0132": "Wait",
    "MSG_0133": "Time",
    "MSG_0134": "Intensity",
    "MSG_0135": "MEP Configuration",
    "MSG_0136": "dt",
    "MSG_0137": "ATTENTION",
    "MSG_0138": "Refer to operating manual before use",
    "MSG_0139": "Service",
    "MSG_0140": "WARNING",
    "MSG_0141": "Coil Rom checksum incorrect",
    "MSG_0142": "Coil EEPROM checksum incorrect",
    "MSG_0143": "Invalid coil category",
    "MSG_0144": "Invalid coil power identification",
    "MSG_0145": "Coil temperature sensor circuit failure",
    "MSG_0146": "Bad communication detected by coil",
    "MSG_0147": "Internal coil software error",
    "MSG_0148": "Invalid coil ID",
    "MSG_0149": "Invalid coil temperature algorithm coefficient",
    "MSG_0150": "Coil controller malfunction",
    "MSG_0151": "Coil disconnected/Coil under temperature",
    "MSG_0152": "Coil brown out detected",
    "MSG_0153": "No serial communications",
    "MSG_0154": "Bad communication detected by coil",
    "MSG_0155": "Coil EMC detected",
    "MSG_0156": "Invalid coil power identification",
    "MSG_0157": "Coil hardware stop activated",
    "MSG_0158": "Coil watchdog timeout",
    "MSG_0159": "Coil temperature 3 interlock activated",
    "MSG_0160": "Coil stop line fault",
    "MSG_0161": "Base powerfail detected",
    "MSG_0162": "Base stack underflow",
    "MSG_0163": "Base stack overflow",
    "MSG_0164": "Base RTS overrun",
    "MSG_0165": "Base watchdog timeout",
    "MSG_0166": "Base unexpected reset detected",
    "MSG_0167": "Base bad ROM checksum",
    "MSG_0168": "Base debug error",
    "MSG_0169": "Coil over temperature, remove from patient",
    "MSG_0170": "Coil under temperature",
    "MSG_0171": "Coil max difference detected",
    "MSG_0172": "Base stack over temperature",
    "MSG_0173": "Base stack under temperature",
    "MSG_0174": "Base stack max difference detected",
    "MSG_0175": "Base HVCAP over temperature",
    "MSG_0176": "Base HV transformer over temperature",
    "MSG_0177": "Base charge threshold failure",
    "MSG_0178": "Base VREF check failure",
    "MSG_0179": "Base HVCAP voltage comparison failure",
    "MSG_0180": "Base charging fault",
    "MSG_0181": "Base HVCAP over voltage",
    "MSG_0182": "Invalid system configuration",
    "MSG_0183": "Base stop line fault",
    "MSG_0184": "Base coil stop line fault",
    "MSG_0185": "UI stop line fault",
    "MSG_0186": "Base dump system fault",
    "MSG_0187": "Invalid coil category for current system configuration",
    "MSG_0188": "Base invalid EEPROM checksum",
    "MSG_0189": "Base faulty charging relay detected",
    "MSG_0190": "Base arm LED drive failure",
    "MSG_0191": "External PSU fault",
    "MSG_0192": "Base over temperature",
    "MSG_0193": "Base snubber board over temperature",
    "MSG_0194": "Base Temperature Outside Limits",
    "MSG_0195": "Base ambient under temperature",
    "MSG_0196": "Base snubber board under temperature",
    "MSG_0197": "ERROR",
    "MSG_0198": "unknown fault",
    "MSG_0199": "2 ms/div",
    "MSG_0200": "5 ms/div",
    "MSG_0201": "10 ms/div",
    "MSG_0202": "20 ms/div",
    "MSG_0203": "50 ms/div",
    "MSG_0204": "50 uV/div",
    "MSG_0205": "100 uV/div",
    "MSG_0206": "200 uV/div",
    "MSG_0207": "500 uV/div",
    "MSG_0208": "1 mV/div",
    "MSG_0209": "2 mV/div",
    "MSG_0210": "5 mV/div",
    "MSG_0211": "10 mV/div",
    "MSG_0212": "Session setup not complete",
    "MSG_0213": "MEP NOT INSTALLED",
    "MSG_0214": "Continue",
    "MSG_0215": "File Store empty",
    "MSG_0216": "Save As",
    "MSG_0217": "View",
    "MSG_0218": "Are you sure you wish to delete patient information ?",
    "MSG_0219": "No file defined !",
    "MSG_0220": "File name edit active !",
    "MSG_0221": "A file is currently open !",
    "MSG_0222": "No more file areas available !",
    "MSG_0223": "A filename must contain at least one character !",
    "MSG_0224": "Are you sure you wish to delete selected file ?",
    "MSG_0225": "Are you sure you wish to overwrite selected file ?",
    "MSG_0226": "Battery",
    "MSG_0227": "Voltage",
    "MSG_0228": "Current",
    "MSG_0229": "Time",
    "MSG_0230": "Date",
    "MSG_0231": "Modify",
    "MSG_0232": "Set Time",
    "MSG_0233": "Date",
    "MSG_0234": "Month",
    "MSG_0235": "Year",
    "MSG_0236": "Hour",
    "MSG_0237": "Minute",
    "MSG_0238": "Second",
    "MSG_0239": "Cancel",
    "MSG_0240": "Line",
    "MSG_0241": "Adaptor",
    "MSG_0242": "Invalid code",
    "MSG_0243": "Ignore the coil switch ?",
    "MSG_0244": "Delete highlighted line ?",
    "MSG_0245": "Delete all session information ?",
    "MSG_0246": "Enter line frequency first",
    "MSG_0247": "No session defined",
    "MSG_0248": "No more lines can be added",
    "MSG_0249": "Option not available",
    "MSG_0250": "Max string length reached",
    "MSG_0251": "Value cannot be changed",
    "MSG_0252": "U34 No communication with base",
    "MSG_0253": "U37 Battery voltage low",
    "MSG_0254": "U35 Loss of communication with base",
    "MSG_0255": "U36 Bad NVRAM checksum",
    "MSG_0256": "U29 ROM checksum incorrect",
    "MSG_0257": "U28 Watchdog timeout",
    "MSG_0258": "U25 Stack underflow",
    "MSG_0259": "U26 Stack overflow",
    "MSG_0260": "U27 RTS overrun",
    "MSG_0261": "U24 UI Power supply failure",
    "MSG_0262": "Contact Info",
    "MSG_0263": "File name already exists",
    "MSG_0264": "Base ambient over temperature",
    "MSG_0265": "Coil too hot to run single train",
    "MSG_0266": "Coil too hot to run more than",
    "MSG_0267": "Window still being edited",
    "MSG_0268": "System ok to run",
    "MSG_0269": "Wait period too short, auto set to minimum ?",
    "MSG_0270": "Page up",
    "MSG_0271": "Page down",
    "MSG_0272": "Top page visible",
    "MSG_0273": "Bottom page visible",
    "MSG_0274": "No more lines",
    "MSG_0275": "Save changes in this window ?",
    "MSG_0276": "Save changes in last window ?",
    "MSG_0277": "Nothing being edited",
    "MSG_0278": "Please wait while new coil is processed",
    "MSG_0279": " train(s)",
    "MSG_0280": "Please wait option still initialising",
    "MSG_0281": "Processing session",
    "MSG_0282": " line(s) of session",
    "MSG_0283": "Wait period too short for line ",
    "MSG_0284": ", auto set to minimum ?",
    "MSG_0285": "Save Session",
    "MSG_0286": "System failed to produce protocol",
    "MSG_0287": "L1",
    "MSG_0288": "L2",
    "MSG_0289": "Resume",
    "MSG_0290": "System not armed",
    "MSG_0291": "Start MEP update",
    "MSG_0292": "Ignore temperature",
    "MSG_0293": "Set coil",
    "MSG_0294": "temperature limit",
    "MSG_0295": "algorithm",
    "MSG_0296": "Close",
    "MSG_0297": "Ignore E80",
    "MSG_0298": "Ignore E98",
    "MSG_0299": "Print",
    "MSG_0300": "No card fitted",
    "MSG_0301": "No Patient files detected",
    "MSG_0302": "Card is write protected",
    "MSG_0303": "File already exists, do you wish to overwrite ?",
    "MSG_0304": "Do you wish to export file as ",
    "MSG_0305": "of Bursts",
    "MSG_0306": "Cycle Time",
    "MSG_0307": "of Cycles",
    "MSG_0308": "Burst Frequency",
    "MSG_0309": "Standard",
    "MSG_0310": "Burst",
    "MSG_0311": "Notes:",
    "MSG_0312": "H/W No:",
    "MSG_0313": "Rev:",
    "MSG_0314": "S/N:",
    "MSG_0315": "Cycle",
    "MSG_0316": "Cycles",
    "MSG_0317": "Printer out of paper",
    "MSG_0318": "Printer level up",
    "MSG_0319": "Printer battery needs recharge",
    "MSG_0320": "Print head too hot, allow to cool",
    "MSG_0321": "Language",
    "MSG_0322": "English",
    "MSG_0323": "French",
    "MSG_0324": "German",
    "MSG_0325": "Spanish",
    "MSG_0326": "Italian",
    "MSG_0327": "Portugese",
    "MSG_0328": "Number of bursts too large, auto set to maximum ?",
    "MSG_0329": "Start flash memory update",
    "MSG_0330": "Flash checksum",
    "MSG_0331": "Erasing",
    "MSG_0332": "Erased",
    "MSG_0333": "Select RED dot and press RED key",
    "MSG_0334": "Re-boot the system to complete screen",
    "MSG_0335": "calibration",
    "MSG_0336": "System file processing limit has been reached on card",
    "MSG_0337": "Please wait, data transfer in progress !",
    "MSG_0338": "No more indexed file names can be generated for this file",
    "MSG_0339": "File date:",
    "MSG_0340": "No MEP data stored in this file",
    "MSG_0341": "No active lines in session setup",
    "MSG_0342": "Resume cancelled print job ?",
    "MSG_0343": "Do you wish to print ",
    "MSG_0344": "Printer communication failure",
    "MSG_0345": "No Printer detected",
    "MSG_0346": " ?",
    "MSG_0347": "Invalid file format detected !",
    "MSG_0348": " ?",
    "MSG_0349": "File already exists, do you wish to overwrite ?",
    "MSG_0350": "No more local store file areas available !",
    "MSG_0351": "U38 Bad external flash checksum detected !",
    "MSG_0352": "No Patient files",
    "MSG_0353": "detected",
    "MSG_0354": "Service Menu",
    "MSG_0355": "System History",
    "MSG_0356": "UI Errors",
    "MSG_0357": "Base Errors",
    "MSG_0358": "Update Device",
    "MSG_0359": "RON #",
    "MSG_0360": "Edit",
    "MSG_0361": "Shot Counter",
    "MSG_0362": "Numerical coil temp",
    "MSG_0363": "Fatal",
    "MSG_0364": "Non-fatal",
    "MSG_0365": "Theta mode",
    "MSG_0366": "Coil start",
    "MSG_0367": "Coil above allowed start temperature",
    "MSG_0368": "Confirm ready to trigger",
    "MSG_0369": "Set Maximum",
    "MSG_0370": "Rapid coil algorithm constant checksum incorrect",
    "MSG_0371": "Invalid enhanced power byte",
    "MSG_0372": "Average power checksum incorrect",
    "MSG_0373": "Erase Local Patient Store",
    "MSG_0374": "Are you sure you wish to erase the local store ?",
    "MSG_0375": " burst(s)",
    "MSG_0376": "Coil too hot to run single burst",
    "MSG_0377": "Cycle period too short, auto set to minimum ?",
    "MSG_0378": "Notch Filter",
    "MSG_0379": "Trace",
    "MSG_0380": "Options",
    "MSG_0381": "MEP Trace Options",
    "MSG_0382": "Auto Peak",
    "MSG_0383": "Upgrade file(s) found on SD card:",
    "MSG_0384": "No upgrade files available on SD card.",
    "MSG_0385": "No SD card present. Please insert SD card and retry.",
    "MSG_0386": "Upgrade complete. Please reboot.",
    "MSG_0387": "Error",
    "MSG_0388": "has occurred during upgrade.",
    "MSG_0389": "Processing file:",
    "MSG_0390": "All upgrade files processed.",
    "MSG_0391": "MEP pod upgrading. Please wait...",
    "MSG_0392": "Trace along blue lines ensuring indicators are within limits.",
    "MSG_0393": "Air Extraction Unit Not Operating Correctly.",
    "MSG_0394": "Charge",
    "MSG_0395": "Delay",
    "MSG_0396": "Charge Delay",
    "MSG_0397": "delay",
    "MSG_0398": "Protocol Presets",
    "MSG_0399": "cTBS",
    "MSG_0400": "iTBS",
    "MSG_0401": "in",
    "MSG_0402": "Pulses per Cycle",
    "MSG_0403": "Coil cooling period is active until",
    "MSG_0404": "Set Coil Cooling",
    "MSG_0405": "Average Power",
    "MSG_0406": "Train Warning",
    "MSG_0407": "Check Maintenance",
    "MSG_0408": "HCI limit reached, Contact your supplier.",
    "MSG_0409": "EPV error, Contact your supplier.",
    "MSG_0410": "EPV limit reached, Contact your supplier.",
    "MSG_0411": "Maintenance overdue, Check Maintenance.",
    "MSG_0412": "EPV: ",
    "MSG_0413": "HCI: ",
    "MSG_0414": "Last Service:",
    "MSG_0415": "Next Service:",
    "MSG_0416": "Jan",
    "MSG_0417": "Feb",
    "MSG_0418": "Mar",
    "MSG_0419": "Apr",
    "MSG_0420": "May",
    "MSG_0421": "Jun",
    "MSG_0422": "Jul",
    "MSG_0423": "Aug",
    "MSG_0424": "Sep",
    "MSG_0425": "Oct",
    "MSG_0426": "Nov",
    "MSG_0427": "Dec",
    "MSG_0428": "Maintenance",
    "MSG_0429": "Maintenance required, Contact your supplier.",
    "MSG_0430": "OK",
    "MSG_0431": "Due Soon",
    "MSG_0432": "Overdue",
    "MSG_0433": "Approaching Limit",
    "MSG_0434": "Exceeded",
    "MSG_0435": "Continue session ?",
    "MSG_0436": "Repetitive Mode (initialising...)",
    "MSG_0437": "Repetitive Mode",
    "MSG_0438": "Repetitive Mode",
    "MSG_0439": "Repetitive Mode",
    "MSG_0440": "Repetitive Mode",
    "MSG_0441": "Repetitive Setup",
    "MSG_0442": "Repetitive Setup",
    "mt_history_list_label": "Motor Threshold Results",
    "navigation_custom_target": "Custom target (x, y, z) ",
    "navigation_custom_target_units": "mm",
    "navigation_settings": "Navigation Settings",
    "navigation_settings_angular_tolerance": "Angular Tolerance",
    "navigation_settings_angular_tolerance_units": "Deg",
    "navigation_settings_contact_tolerance": "Contact Tolerance",
    "navigation_settings_contact_tolerance_units": "mm",
    "navigation_settings_distance_tolerance": "Distance Tolerance",
    "navigation_settings_distance_tolerance_units": "mm",
    "navigation_settings_rotation_tolerance": "Rotation Tolerance",
    "navigation_settings_rotation_tolerance_units": "Degrees",
    "navigation_settings_tilt_tolerance": "Tilt Tolerance",
    "navigation_settings_tilt_tolerance_units": "Degrees",
    "navigation_use_custom_target": "Use custom target",
    "network": "Network",
    "network_settings": "Network Settings",
    "network_settings_check_for_updates": "Check for Updates",
    "network_settings_enable_network": "Enable Network",
    "network_settings_enable_update_checking": "Enable Automatic Update Checking",
    "network_settings_reminder_period": "Automatic Update Reminder Period",
    "network_settings_reminder_period_daily": "Daily",
    "network_settings_reminder_period_monthly": "Monthly",
    "network_settings_reminder_period_weekly": "Weekly",
    "network_settings_start_full_sync": "Start full sync",
    "next": "Next",
    "no": "No",
    "no_data": "-",
    "no_data_words": "No data",
    "not_enough_data_words": "Not enough data",
    "note": "Note",
    "note_add": "Add Note",
    "note_added_by": "Added By",
    "note_created_time": "Created Date",
    "note_edit": "Edit Note",
    "note_note": "Note",
    "note_type": "Type",
    "note_type__diagnosis": "Diagnosis",
    "note_type_clinicalassessment": "Clinical Assessment",
    "note_type_medication": "Medication",
    "note_type_patient": "Patient",
    "note_type_treatment": "Treatment",
    "notes": "Notes",
    "number_of_users": "No. of Users",
    "ocd_warning_text_mdd": "MDD",
    "ocd_warning_text_ocd": "OCD",
    "ocd_warning_title": "Please select the type of target you wish to create.",
    "off": "Off",
    "on": "On",
    "organisation": "Organisation",
    "organisation_accuracy": "Organisation Accuracy",
    "organisation_add": "Add Organisation",
    "organisation_analytics": "Organisation Analytics",
    "organisation_analytics_help": "Use the buttons below to view the detailed organisation analytics for {0}",
    "organisation_api_permission_denied": "Organisation does not have permission to access this service. Please contact Magstim to gain access to additional services.",
    "organisation_assessments": "Organisation Assessments",
    "organisation_edit": "Edit Organisation",
    "organisation_max_clinics": "Max Number of Clinics",
    "organisation_max_user_count_exceeded": "Organisation has reached it's user limit, please contact Magstim.",
    "organisation_max_user_count_too_small": "Organisation already has more users than the specified maximum.",
    "organisation_max_users": "Max Number of Users",
    "organisation_max_users_much_be_a_positive_number": "You must specify a whole number greater than 1",
    "organisation_name": "Organisation Name",
    "organisation_rmt": "Organisation rMTs",
    "organisation_role_api_pdm": "PDM Permission",
    "organisation_role_api_reporting": "Analytics Permission",
    "organisation_role_api_sync": "Sync Permission",
    "organisation_treatments": "Organisation Treatments",
    "organisation_with_no_admins_error": "Archiving this item will result in the parent Organisation not having any administrators.",
    "organisation_with_no_clinics_error": "Archiving this clinic will result in the parent Organisation not having any clinics.",
    "organisations": "Organisations",
    "password_reset_no": "Cancel",
    "password_reset_success": "You will receive an email with instructions on how to reset your password in a few minutes.",
    "password_reset_title": "",
    "password_reset_warning": "Are you sure you want to reset the password for the following user?",
    "password_reset_yes": "Reset",
    "patient_accuracy": "Patient Accuracy",
    "patient_analytics": "Patient Analytics",
    "patient_analytics_help": "Use the buttons below to view the detailed patient analytics for {0}",
    "patient_assessments": "Patient Assessments",
    "patient_clinic": "Clinic",
    "patient_clinical_assessment_history": "Clinical Assessment History",
    "patient_clinical_assessment_history_chart": "Clinical Assessments Graph",
    "patient_clinical_assessment_history_table": "Clinical Assessments History",
    "patient_clinical_ratings__history": "Clinical Ratings History",
    "patient_full_name": "Patient Full Name",
    "patient_graph": "Graph",
    "patient_history": "History",
    "patient_history_plan_title": "Treatment Plan",
    "patient_home_archive": "Archive",
    "patient_home_assign_treatment_plan": "Assign Treatment Plan",
    "patient_home_created_by": "Created By",
    "patient_home_current_mt": "Current rMT Level",
    "patient_home_current_plan": "Current Plan",
    "patient_home_current_treatment_stage": "Current Treatment Stage",
    "patient_home_date_of_birth": "Date of Birth",
    "patient_home_date_time_created": "Date/time Created",
    "patient_home_edit_treatment_plan": "Edit Treatment Plan",
    "patient_home_first_name": "First Name",
    "patient_home_general_notes": "General Notes:",
    "patient_home_last_edited": "Last Edited",
    "patient_home_last_mt": "Last rMT Determination",
    "patient_home_last_name": "Last Name",
    "patient_home_last_treated": "Last Treated",
    "patient_home_last_treated_by": "Last Treated By",
    "patient_home_last_treatment": "Last Treatment",
    "patient_home_last_treatment_by": "Last Treatment By",
    "patient_home_mt_history": "rMT History",
    "patient_home_mt_history_chart": "rMT History Chart",
    "patient_home_mt_history_summary": "rMT History Summary",
    "patient_home_new_mt": "New rMT Determination",
    "patient_home_new_treatment_plan": "New Treatment Plan",
    "patient_home_no_plan_assigned": "No plan assigned",
    "patient_home_no_plan_assigned_instructions": "Assign a plan by selecting the assign treatment plan button below.",
    "patient_home_overview": "Overview",
    "patient_home_overview_details": "General Patient Details",
    "patient_home_overview_notes": "Latest Treatment Notes",
    "patient_home_overview_results": "Latest Treatment Results",
    "patient_home_overview_summary": "Treatment Plan Summary",
    "patient_home_patient_id": "Patient ID",
    "patient_home_run_treatment": "Run Treatment",
    "patient_home_search_hint": "Search-as-you-type patient first name, last name or patient ID.",
    "patient_home_search_hint_magstim_admin": "Search-as-you-type patient organisation or clinic.",
    "patient_home_treatment_archive": "Treatment History",
    "patient_home_treatment_center": "Treatment Centre",
    "patient_home_treatment_history": "Treatment Plan",
    "patient_home_treatment_plan_and_history": "Treatment Plan/History",
    "patient_home_treatments_completed": "Treatments Completed",
    "patient_imported": "Success 1 Patient Imported",
    "patient_information": "Patient Information",
    "patient_list_grouping_last_treated_last_month": "Last Month",
    "patient_list_grouping_last_treated_last_week": "Last Week",
    "patient_list_grouping_last_treated_older": "Older",
    "patient_list_grouping_last_treated_this_month": "This Month",
    "patient_list_grouping_last_treated_this_week": "This Week",
    "patient_list_grouping_last_treated_this_year": "This Year",
    "patient_list_grouping_last_treated_today": "Today",
    "patient_list_grouping_last_treated_yesterday": "Yesterday",
    "patient_medication_history": "Medication History",
    "patient_note_history": "Notes History",
    "patient_organisation": "Organisation",
    "patient_overview": "Overview",
    "patient_progress": "Patient Progress",
    "patient_reports": "Patient Reports",
    "patient_rmt": "Patient rMT",
    "patient_search_list_label": "Patient List",
    "patient_search_new_patient": "New Patient",
    "patient_search_placeholder": "Search for Patient ID, First Name and Last Name.",
    "patient_search_research_mode": "Research Mode",
    "patient_search_title": "Add new patient, or search patient profile to setup or start treatment",
    "patient_status": "Status",
    "patient_status_active": "Active",
    "patient_status_all": "All",
    "patient_status_archived": "Archived",
    "patient_timeline": "Timeline",
    "patient_treatment_overview": "Treatment Overview",
    "patient_treatments": "Patient Treatments",
    "patients_imported": "Success {0} Patients Imported",
    "pdm_account_archived": "This account is archived please contact your organisation administrator.",
    "pdm_account_archived_magstim": "This account is archived please contact your Magstim administrator.",
    "physician": "Physician",
    "physician_add": "Add Physician",
    "physician_edit": "Edit Physician",
    "physician_email": "Email",
    "physician_type": "Type",
    "physician_type_both": "Managing and Referring",
    "physician_type_managing": "Managing",
    "physician_type_referring": "Referring",
    "physicians": "Physicians",
    "plus": "plus",
    "protocol_history_details_header": "Protocol Detail",
    "protocol_mode_burst": "Burst repetitive",
    "protocol_mode_standard": "Standard repetitive",
    "protocol_name": "Protocol Name",
    "protocol_section_column_name_intensity": "Intensity",
    "protocol_section_column_name_is_additional": "",
    "protocol_section_column_name_percent_rmt": "% rMT",
    "protocol_section_column_name_pulses": "Pulses",
    "protocol_section_column_name_time_period": "Time Period",
    "protocol_section_column_name_within_tolerance": "Within Tolerance",
    "protocol_template_itbs": "iTBS",
    "protocol_template_ocd": "OCD",
    "protocol_template_rtms_lower": "rTMS Lower inter-train interval",
    "protocol_template_rtms_upper": "rTMS Upper inter-train interval",
    "protocol_templates_not_found": "All protocol templates not found",
    "protocols": "Protocols",
    "rating_scale_bdi": "BDI-II",
    "rating_scale_bdi_self_assessed": "BDI-II (Self)",
    "rating_scale_cesd": "CES-D",
    "rating_scale_cesd_self_assessed": "CES-D (Self)",
    "rating_scale_csdd": "CSDD",
    "rating_scale_csdd_self_assessed": "CSDD (Self)",
    "rating_scale_gad7": "GAD-7",
    "rating_scale_gad7_self_assessed": "GAD-7 (Self)",
    "rating_scale_gds15": "GDS-15",
    "rating_scale_gds15_self_assessed": "GDS-15 (Self)",
    "rating_scale_gds4": "GDS-4",
    "rating_scale_gds4_self_assessed": "GDS-4 (Self)",
    "rating_scale_hads": "HADS",
    "rating_scale_hads_anxiety": "HADS Anxiety",
    "rating_scale_hads_anxiety_self_assessed": "HADS Anxiety (Self)",
    "rating_scale_hads_depression": "HADS Depression",
    "rating_scale_hads_depression_self_assessed": "HADS Depression (Self)",
    "rating_scale_hads_self_assessed": "HADS (Self)",
    "rating_scale_hamd": "HAM-D",
    "rating_scale_hamd_self_assessed": "HAM-D (Self)",
    "rating_scale_idssr": "IDS-SR",
    "rating_scale_idssr_self_assessed": "IDS-SR (Self)",
    "rating_scale_madrs": "MADRS",
    "rating_scale_madrs_self_assessed": "MADRS (Self)",
    "rating_scale_phq9": "PHQ-9",
    "rating_scale_phq9_self_assessed": "PHQ-9 (Self)",
    "rating_scale_qids": "QIDS",
    "rating_scale_qids_self_assessed": "QIDS (Self)",
    "rating_scale_ybocs": "Y-BOCS",
    "rating_scale_ybocs_self_assessed": "Y-BOCS (Self)",
    "rating_scale_zungsds": "Zung SDS",
    "rating_scale_zungsds_self_assessed": "Zung SDS (Self)",
    "redefine_treatment_target": "Redefine Treatment Target",
    "redefine_treatment_target_warning": "Are you sure you want to use the current coil position as the treatment target?",
    "register_landmark_warning_message": "Please ensure both the head trackers and the markers are detected",
    "register_landmark_warning_title": "Cannot Register Landmark",
    "register_landmarks_close_message": "Discard and Close?",
    "register_landmarks_discard": "Discard and Close",
    "register_landmarks_resume": "Resume",
    "remaining_pulses": "Remaining Pulses:",
    "remaining_time": "Remaining time",
    "report": "Report",
    "report_builder": "Report Builder",
    "report_column_header_motor_thresholds_assessed_by": "Assessed By",
    "report_column_header_motor_thresholds_assessed_by_email": "E-mail",
    "report_column_header_motor_thresholds_assessed_date": "Date",
    "report_column_header_motor_thresholds_level": "rMT Level",
    "report_column_header_motor_thresholds_patient_full_name": "Patient Name",
    "report_column_header_motor_thresholds_patient_id_num": "Patient ID",
    "report_column_header_treatment_assessed_by": "Assessed By",
    "report_column_header_treatment_assessed_by_email": "E-mail",
    "report_column_header_treatment_assessed_date": "Date",
    "report_download": "Download Progress Report",
    "report_email": "eMail",
    "report_footer": "Report Footer",
    "report_header": "Report Header",
    "report_image": "Image",
    "report_logo": "Report Logo",
    "report_patient_clinical_assessment_baseline": "Baseline",
    "report_patient_clinical_assessment_date": "Date",
    "report_patient_clinical_assessment_performed_by": "Performed By",
    "report_patient_clinical_assessment_post_treatment": "Post-Treatment",
    "report_patient_clinical_assessment_rating": "Rating",
    "report_patient_clinical_assessment_scale": "Scale",
    "report_patient_clinical_assessment_table_title": "Progress Table - {0}",
    "report_patient_heading": "{0} - Treatment Report",
    "report_patient_protocol_template_duration_data": "{0}m{1:D2}s",
    "report_patient_protocol_template_frequency": "Frequency",
    "report_patient_protocol_template_frequency_data": "{0}Hz",
    "report_patient_protocol_template_location": "Location",
    "report_patient_protocol_template_number_of_trains": "Number of Trains",
    "report_patient_protocol_template_rmt_data": "{0}%",
    "report_patient_sub_heading_patient_information": "Patient Information",
    "report_patient_sub_heading_patient_progress": "Patient Progress",
    "report_patient_sub_heading_treatment_plan_summary": "Treatment Plan Summary / {0} - {1}",
    "report_patient_sub_heading_treatment_plan_summary_no_treatment": "Treatment Plan Summary",
    "report_patient_subject": "Patient {0} - {1}",
    "report_patient_title": "Treatment Report",
    "report_preview": "Preview",
    "report_section_assessments_title": "Clinical Assessments",
    "report_section_motor_thresholds_title": "Motor Thresholds",
    "report_section_treatment_title": "Treatments",
    "report_sections": "Sections",
    "report_template": "Template",
    "report_template_all": "Full Report",
    "report_template_assessment": "Assessment Report",
    "report_template_rmt": "rMT Report",
    "report_template_treatments": "Treatment Report",
    "report_time_frame": "Timeframe",
    "report_title": "Report Title",
    "rmt_add_additional_treatment_targets": "Save and add additional",
    "rmt_analytics": "rMT Analytics",
    "rmt_chart_no_data": "Chart will show when at least 2 MT determinations have been carried out.",
    "rmt_continue_to_add": "Target saved. Please continue to add a new target",
    "rmt_distance": "Distance",
    "rmt_distance_to_plane": "Distance to plane",
    "rmt_info_accuracy": "Accuracy",
    "rmt_info_date": "Date",
    "rmt_info_level": "Level",
    "rmt_info_position": "Position",
    "rmt_info_position_x": "px",
    "rmt_info_position_y": "py",
    "rmt_info_position_z": "pz",
    "rmt_info_rotation": "Rotation",
    "rmt_info_rotation_w": "rw",
    "rmt_info_rotation_x": "rx",
    "rmt_info_rotation_y": "ry",
    "rmt_info_rotation_z": "rz",
    "rmt_location": "Location",
    "rmt_location_guide": "Location Guide",
    "rmt_must_be_greater_than": "rMT must be greater than or equal to",
    "rmt_must_be_less_than": "rMT must be less than or equal to",
    "rmt_pulse_list_intensity": "Intensity",
    "rmt_pulse_list_peak_to_peak": "Peak to peak",
    "rmt_pulse_list_register": "Register",
    "rmt_pulse_list_response": "Response",
    "rmt_pulse_list_stim": "Stim",
    "rmt_pulse_list_time": "Time",
    "rmt_save_treatment_targets": "Save and close",
    "rmt_select_pulase": "Please Select a Pulse",
    "rmt_select_target": "Please register treatment target",
    "rmt_settings": "rMT Settings",
    "rmt_settings_charge_delay": "Charge delay",
    "rmt_settings_mt_hotspot_target_name": "MT hotspot target name",
    "rmt_settings_please_enter_the_details_below:": "Please enter the details below:",
    "rmt_settings_selected_scalp_landmark": "Selected scalp landmark",
    "rmt_settings_target_name": "Target name",
    "rmt_settings_tms_location_guide": "TMS location guide",
    "rmt_stimulation": "Stimulation",
    "role_admin": "Admin",
    "role_user": "User",
    "rotation_within_tolerance_count": "Rotation Within Tolerance Count",
    "route_admin": "Admin",
    "route_contact": "Contact Us",
    "route_patient_search": "Patient Search",
    "route_treatments_plans": "Treatment Plans",
    "run_treatment": "Run treatment",
    "run_treatment_location_change_message": "The next individual treatment is in location:\r\n    \r\n{0}\r\n\r\nPlease re-position your coil, then confirm when ready.",
    "run_treatment_location_change_message_title": "Change of location",
    "run_treatment_plan_combined": "Combined",
    "run_treatment_plan_controls_intensity": "Intensity",
    "run_treatment_plan_controls_latest_mt_level": "Latest rMT Level",
    "run_treatment_plan_controls_percent_mt": "% rMT",
    "run_treatment_plan_controls_title": "{0} controls",
    "run_treatment_plan_detail_title": "{0} detail",
    "run_treatment_plan_details_additional_pulses": "Additional pulses",
    "run_treatment_plan_details_average_accuracy": "Average accuracy",
    "run_treatment_plan_details_burst_per_second": "Bursts per second",
    "run_treatment_plan_details_bursts_per_cycle": "Bursts per cycle",
    "run_treatment_plan_details_cycle_time": "Cycle time",
    "run_treatment_plan_details_manual_location": "Manual Location",
    "run_treatment_plan_details_mode": "Mode",
    "run_treatment_plan_details_off_time": "Off time",
    "run_treatment_plan_details_on_time": "On time",
    "run_treatment_plan_details_percent_mt_level": "Treatment % rMT Level",
    "run_treatment_plan_details_pulses_per_burst": "Pulses per burst",
    "run_treatment_plan_details_pulses_per_second": "Pulses per second",
    "run_treatment_plan_details_pulses_per_train": "Pulses per train",
    "run_treatment_plan_details_stimguide_location": "Stimguide Location",
    "run_treatment_plan_details_total_duration": "Treatment duration",
    "run_treatment_plan_details_total_pulses": "Total no. of pulses",
    "run_treatment_plan_details_total_trains": "Total no. of trains",
    "run_treatment_plan_done": "End treatment & save data",
    "run_treatment_plan_individual": "Individual",
    "run_treatment_plan_next_treatment": "Next treatment",
    "run_treatment_plan_results_tab_notes": "Notes",
    "run_treatment_plan_results_tab_score": "Score",
    "run_treatment_plan_results_tab_score_additional_pulses": "additional pulses delivered.",
    "run_treatment_plan_results_tab_score_message_average": "Average pulses delivered within preset tolerance.",
    "run_treatment_plan_results_tab_score_message_count": "pulses may not have been delivered within tolerance.",
    "run_treatment_plan_results_tab_summary": "Summary",
    "run_treatment_plan_results_tab_summary_state_abandoned": "X",
    "run_treatment_plan_results_tab_summary_state_additional": "+",
    "run_treatment_plan_results_tab_summary_state_normal": "",
    "run_treatment_plan_results_title": "{0} results",
    "run_treatment_plan_schedule_prescription_message": "Prescribed {0} treatments of:",
    "run_treatment_plan_schedule_progress_message": "This treatment: {0} of {1}",
    "run_treatment_plan_schedule_timeline_label_results": "{0} treatment results",
    "run_treatment_plan_schedule_timeline_label_results_burst": "Burst {0} treatment results",
    "run_treatment_plan_schedule_timeline_label_results_standard": "Standard {0} treatment results",
    "run_treatment_plan_schedule_timeline_label_treatment_burst": "Burst {0} treatment",
    "run_treatment_plan_schedule_timeline_label_treatment_standard": "Standard {0} treatment",
    "run_treatment_plan_schedule_timeline_number_results": "{0}b",
    "run_treatment_plan_schedule_timeline_number_treatment": "{0}a",
    "run_treatment_plan_schedule_title": "Schedule",
    "run_treatment_plan_title": "Running {0}",
    "run_treatment_plan_treatment": "Treatment",
    "running_upper": "RUNNING",
    "search": "Search",
    "search_analytics_help": "Select the type of analytics you want to run on the {0} selected:",
    "search_placeholder": "Search-as-you-type {0}",
    "search_select_help": "Please select at least one {0} from the table.",
    "search_select_help_single": "Please select one {0} from the table.",
    "search_title": "{0} Search",
    "set_contact_offset": "Set contact offset",
    "set_contect_offset_warning_message": "Please ensure both the head trackers and the coil are detected",
    "set_contect_offset_warning_title": "Cannot set contact offset",
    "set_cz": "Set Cz",
    "set_left_preauricular": "Set left preauricular",
    "set_nasion": "Set nasion",
    "set_right_preauricular": "Set right preauricular",
    "setting_hci": "HCI %",
    "settings_admin_password_incorrect": "Admin password incorrect",
    "settings_app_version": "Application Software",
    "settings_audible_indicator": "Enable Tolerance Audio Indicator",
    "settings_date": "Date",
    "settings_epv": "EPV %",
    "settings_epv_status": "EPV Status",
    "settings_hardware_no": "Hardware no.",
    "settings_hci_status": "HCI Status",
    "settings_language": "Language",
    "settings_last_service": "Last service date",
    "settings_locale": "Locale",
    "settings_next_service": "Next service date",
    "settings_proc_mon_version": "Process Monitor Software",
    "settings_revision_no": "Revision no.",
    "settings_serial_number": "Serial Number",
    "settings_service_status": "Service status",
    "settings_software_no": "Software no.",
    "settings_stimguide_version": "StimGuide Version",
    "settings_time": "Time",
    "settings_timezone": "Timezone",
    "settings_train_warning": "Train Warning",
    "settings_user_password_incorrect": "User password is incorrect",
    "settings_version_no": "Version no.",
    "settings_volume": "Volume",
    "settings_windows_sn": "Serial Number",
    "settings_windows_update_version": "Windows Update",
    "settings_windows_version": "Platform Software",
    "show_nav_view": "Show navigation view",
    "sign_out": "Sign Out",
    "signout_warning_message": "You will be signed out in",
    "signout_warning_units": "seconds",
    "software_date": "Date",
    "software_history": "Version History",
    "software_update": "Software Update",
    "status_active": "Active",
    "status_archived": "Archived",
    "status_inactive": "Inactive",
    "status_parentarchived": "Parent Archived",
    "status_upper": "STATUS",
    "stimguide_disconnected": "Stimguide is disconnected are you sure you want to continue?",
    "stimguide_disconnected_no": "No",
    "stimguide_disconnected_yes": "Yes",
    "stimguide_landmark_reuse_generate_new": "Generate new",
    "stimguide_landmark_reuse_text": "Existing landmark is less than {0} hours old.\r\n    \r\nDo you wish to reuse this landmark or generate a new one?",
    "stimguide_landmark_reuse_use_existing": "Use existing",
    "stimuli_within_tolerance_count": "Stimuli Within Tolerance Count",
    "stopped_upper": "STOPPED",
    "success": "Success",
    "support_email_body": "Support request from - {0}\r\n\r\n-------------------\r\n\r\n{1}",
    "support_email_title": "Support Request from Magstim PDM v{0}",
    "sync_hardware_issue_reporting_mail_template_id": "d-586c8383628b468aaa6ea6883ae56c9f",
    "syncing_data": "Syncing data...",
    "syncing_data_cancelled": "Syncing data cancelled",
    "syncing_data_completed": "Syncing data completed",
    "syncing_data_error": "Error syncing {0}",
    "syncing_data_stopping": "Syncing data stopping...",
    "system_av_settings": "Audio Settings",
    "system_base_info": "Base Info",
    "system_cloud": "Cloud",
    "system_coil_info": "Coil Info",
    "system_com_port_settings": "COM Port Settings",
    "system_com_port_settings_label": "Device COM Port",
    "system_com_port_settings_reboot_label": "Please restart the application for the COM port setting to take effect.",
    "system_date_and_time": "Date and Time",
    "system_hardware_info": "Hardware Info",
    "system_help": "Help",
    "system_laguage_settings": "Language Settings",
    "system_pc_info": "PC Info",
    "system_psu_info": "PSU Info",
    "system_report_template": "Report Template",
    "system_security": "Security and Login Info",
    "system_system_info": "System Info",
    "system_user_info": "User Info",
    "system_user_information": "User Info",
    "systemuser_api_permission_denied": "System user does not have permission to access this service. Please contact Magstim to gain access to additional services.",
    "table_export_message": "Data exported to {0}",
    "table_export_no_drive_message": "No removable drive detected. Please connect one.",
    "table_export_title": "Export",
    "table_group_name_value": "{0} - {1}",
    "target_trype": "Target Type",
    "tilt_within_tolerance_count": "Tilt Within Tolerance Count",
    "tms_location_guide": "TMS location guide",
    "toggle_nav_view": "Toggle navigation view",
    "treater": "Treater",
    "treater_accuracy": "Treater Accuracy",
    "treater_analytics": "Treater Analytics",
    "treater_analytics_help": "Use the buttons below to view the detailed treater analytics for {0}",
    "treater_assessments": "Treater Assessments",
    "treater_full_name": "Treater Full Name",
    "treater_reports": "Treater Reports",
    "treater_rmt": "Treater rMT",
    "treater_search": "Treater Search",
    "treater_search_analytics_help": "Select the type of analytics you want to run on the treaters selected:",
    "treater_search_select_help": "Please select at least one treater from the table.",
    "treaters": "Treaters",
    "treatment_analytics": "Treatment Analytics",
    "treatment_archive_title": "Treatment Archive",
    "treatment_cancel_message": "The treatment is incomplete, are you sure you want to stop",
    "treatment_cancel_message_error": "Stimulator connection lost. Would you like to attempt to continue?",
    "treatment_cancel_no": "Stop & close",
    "treatment_cancel_title": "Cancel treatment?",
    "treatment_cancel_title_error": "Device Error - Connection Lost",
    "treatment_cancel_yes": "Resume treatment",
    "treatment_canceled_default_note": "Treatment canceled by user",
    "treatment_canceled_no_note_error": "A reason must be entered",
    "treatment_combined_treatment_templates": "Combined treatment templates",
    "treatment_details_millisecounds": "{0}ms",
    "treatment_details_mins_and_seconds": "{0}m{1}s",
    "treatment_details_number_of_pulses": "{0:###0.#}% of pulses ({1} pulses)",
    "treatment_details_power_output": "{0:###0.#}% power output",
    "treatment_details_rmt_level": "{0:###0.#}% rMT ({1:###0.#}% output)",
    "treatment_details_seconds": "{0:.##}s",
    "treatment_details_time_used": "{0}m{1}s out of {2}m{3}s",
    "treatment_edit_combined_summary": "Summary",
    "treatment_edit_combined_title": "Create New or Edit Combined Treatment",
    "treatment_edit_combined_treatment_name": "Treatment Name",
    "treatment_edit_combined_treatment_name_required": "Treatment Name*",
    "treatment_edit_number_of_treatment_label": "Total No. of Treatments",
    "treatment_edit_plan_name_label": "Plan Name*",
    "treatment_edit_plan_name_placeholder": "Plan Name",
    "treatment_edit_plan_summary": "Plan Summary",
    "treatment_failed_to_validate_messaage": "The system cannot deliver the specified protocol with the connected coil. Please either replace the connect coil or edit the protocol.",
    "treatment_failed_to_validate_no": "Replace coil",
    "treatment_failed_to_validate_title": "Failed to validate protocol",
    "treatment_failed_to_validate_yes": "Edit protocol",
    "treatment_history_all_treaters": "All Treaters",
    "treatment_history_changes_header": "Changes During Treatment History",
    "treatment_history_date_allTime": "All Time",
    "treatment_history_date_lastMonths12": "Last Year",
    "treatment_history_date_lastMonths6": "Last 6 Months",
    "treatment_history_date_lastWeeks4": "Last 4 Weeks",
    "treatment_history_details_header": "Treatment Detail",
    "treatment_history_details_title": "Treatment History",
    "treatment_history_table_columnname_completed": "Completed",
    "treatment_history_table_columnname_date": "Date",
    "treatment_history_table_columnname_individualTreatment": "Treatment",
    "treatment_history_table_columnname_performedBy": "Performed by",
    "treatment_history_table_columnname_planName": "Plan Name",
    "treatment_history_table_columnname_totalPulses": "Pulses Delivered",
    "treatment_history_table_device_guid": "Device Guid",
    "treatment_history_table_managing_physician_email": "Managing Physician Email",
    "treatment_history_table_managing_physician_guid": "Managing Physician Guid",
    "treatment_history_table_managing_physician_name": "Managing Physician Name",
    "treatment_history_table_referring_physician_email": "Referring Physician Email",
    "treatment_history_table_referring_physician_guid": "Referring Physician Guid",
    "treatment_history_table_referring_physician_name": "Referring Physician Name",
    "treatment_history_title": "Treatment History",
    "treatment_history_unassign_plan": "Unassign Plan",
    "treatment_history_unassign_plan_confirm_message": "Are you sure you wish to end treatment plan {0}?",
    "treatment_individual_treatment_templates": "Individual treatment templates",
    "treatment_modified_warning": "Note: Parameters modified by the system are highlighted",
    "treatment_name_no_unique": "A combined treatment with that name already exists ",
    "treatment_new_combined": "New combined",
    "treatment_new_individual": "New individual",
    "treatment_no_name_error": "Please enter a name",
    "treatment_no_treatments": "A combined treatment must contain at least 2 treatments",
    "treatment_notes_enter_additional": "Please enter any additional treatment notes",
    "treatment_notes_modify": "Modify Treatment Notes",
    "treatment_plan_edit_title": "Build or Edit Patient Treatment Plan",
    "treatment_resume_message": "The system will disarm in {0} seconds.",
    "treatment_resume_no": "Restart",
    "treatment_resume_title": "Do you wish to resume treatment?",
    "treatment_resume_yes": "Resume",
    "treatment_score_dialog_add_trains": "Add no. of trains",
    "treatment_score_dialog_report_1": "{0:###0.#}%",
    "treatment_score_dialog_report_2": "Pulses delivered within preset tolerance.",
    "treatment_score_dialog_report_3": "pulses may not have been delivered within tolerance.",
    "treatment_score_dialog_title": "Treatment score",
    "treatment_score_dialog_total_pulses": "Total no. of pulses",
    "treatment_settings": "Treatment Settings",
    "treatment_stage_completion": "Primary Plan (Completion)",
    "treatment_stage_initial": "Primary Plan (Initial)",
    "treatment_stage_maintenance": "Maintenance",
    "treatment_summary_card_duration": "Duration",
    "treatment_summary_card_mode": "Mode",
    "treatment_summary_card_pcRMT": "%rMT",
    "treatment_summary_card_pps": "Hz (PPS)",
    "treatment_summary_card_pulses": "Pulses",
    "treatment_summary_manual_location": "Manual Location",
    "treatment_summary_stimguide_location": "StimGuide Location",
    "treatment_target_settings": "Treatment Target Settings",
    "treatment_template_not_found": "Treatment template not found",
    "treatment_templates": "Treatment Templates",
    "treatment_warning": "Select a treatment template below. Notice: The safety and effectiveness of rTMS has only been established using the treatment templates labeled \"FDA\" during a controlled clinical study. The safety and efficacy of all other stimulation protocols have not been established.",
    "update_accept": "Accept",
    "update_decline": "Decline",
    "update_password_error": "Error updating password",
    "update_password_ok_message": "Password has been reset",
    "update_password_ok_title": "Success",
    "update_updates_changelog": "Changelog",
    "update_updates_title": "The following updates are available for the system",
    "updates_confirm": "Are you sure you want to apply the updates?",
    "updates_confirm_cancel": "Are you sure you wish to decline updates?",
    "updates_confirm_cancel_no": "Continue",
    "updates_confirm_cancel_yes": "Decline",
    "updates_confirm_no": "No",
    "updates_confirm_yes": "Update",
    "updates_critical": "(Critical)",
    "updates_error_downloading_updates": "There was an error downloading the updates, please try again later.",
    "updates_error_getting_updates": "There was an error getting the update information, please try again later.",
    "updates_help_1": "Choosing to accept will initiate the update progress",
    "updates_help_2": "Choosing decline will close the software update dialog with the software remaining unchanged",
    "updates_no_updates": "Your system is up to date. ",
    "updates_no_updates_title": "No updates",
    "updates_the_update_will_now_start": "The application will now close and start the updates. The system may restart several times. ",
    "updates_time_of_next_check": "Updates last checked on {0} at {1}, next check on first login after {2} on {3}",
    "upload": "Upload",
    "user": "User",
    "user_add": "Add User",
    "user_edit": "Edit User",
    "user_first_name": "First Name",
    "user_last_name": "Last Name",
    "user_roles": "Roles",
    "user_type": "User Type",
    "user_user_name": "Email",
    "userprofile_edit_details": "Edit User Details",
    "userprofile_enter_details": "Enter User Details",
    "users": "Users",
    "users_no_access": "You do not have the permission to add users, please contact your system administrator.",
    "users_offline_message": "A network connection is required to view and edit users.",
    "users_role_admin": "Admin",
    "users_role_normal": "Normal",
    "usersecurity_edituser": "Edit User Details",
    "usersecurity_newuser": "New User",
    "usersecurity_resetuser": "Reset User Password",
    "usersecurity_selectuser": "Select User",
    "usersettings_login_title": "Security and login information",
    "validating_session": "Validating session...",
    "validation_please_wait": "Please wait...",
    "validation_required": "Required",
    "validation_save": "Save",
    "validation_star": "*",
    "validation_too_large": "Too Large",
    "validation_too_long": "Too Long",
    "validation_too_short": "Too Short",
    "validation_too_small": "Too Small",
    "value_entry_warning": "{0} must be more than {1} and less than {2}",
    "version_new": "To",
    "version_old": "From",
    "view_individual_treatment_burst_bursts_per_cycle": "Bursts per Cycle",
    "view_individual_treatment_burst_bursts_per_second": "Bursts per Second",
    "view_individual_treatment_burst_cycle_time": "Cycle Time (s)",
    "view_individual_treatment_burst_percentage_of_rmt": "% Resting rMT",
    "view_individual_treatment_burst_pulses_per_burst": "Pulses per Burst",
    "view_individual_treatment_burst_pulses_per_second": "Pulses per Second",
    "view_individual_treatment_burst_total_cycles": "Total No. of Cycles",
    "view_individual_treatment_burst_total_duration": "Total Duration",
    "view_individual_treatment_burst_total_pulses": "Total No. of Pulses",
    "view_individual_treatment_standard_off_time": "Off Time",
    "view_individual_treatment_standard_on_time": "On Time",
    "view_individual_treatment_standard_percentage_of_rmt": "% Resting rMT",
    "view_individual_treatment_standard_pulses_per_second": "Pulses per Second",
    "view_individual_treatment_standard_pulses_per_train": "Pulses per Train",
    "view_individual_treatment_standard_total_duration": "Total Duration",
    "view_individual_treatment_standard_total_pulses": "Total No. of Pulses",
    "view_individual_treatment_standard_total_trains": "Total No. of Trains",
    "view_individual_treatment_title": " Individual treatment",
    "view_treatment_template_combined_title": "Combined Treatment Templates",
    "view_treatment_template_individual_title": "Individual Treatment Templates",
    "waiting_upper": "WAITING",
    "with_accuracy_data_postfix": " (with accuracy information)",
    "wizard_setup_complete": "Setup complete\r\nPlease login with your username and password to access your account.",
    "work_flow_define_rmt": "Define Motor Threshold (rMT)",
    "work_flow_define_treatment_target": "Define Treatment Target",
    "work_flow_register_landmarks": "Register Landmarks",
    "yes": "Yes"
  },
  "en_us": {
    "about": "About",
    "about_address": "The Magstim Company Ltd,\r\nSpring Gardens, Whitland,\r\nWales, U.K. SA34 0HR",
    "about_ref": "5453-00",
    "about_ref_analytics": "5736-00",
    "about_udi": "(01)05060229532725\r\n(21){0}\r\n(11){1}",
    "about_udi_analytics": "(01)05060229532794\r\n(21){0}\r\n(11){1}",
    "accuracy_analytics": "Accuracy Analytics",
    "add_additional_landmark": "Add Additional Landmark",
    "add_additional_landmarks": "Add additional landmarks",
    "add_clinical_assessment": "Add Clinical Assessment",
    "additional_landmark_name": "Additional Landmark Name",
    "advanced_search": "Advanced Filters",
    "advanced_search_active_patients": "Active Patients",
    "advanced_search_all_clinics": "All Clinics",
    "advanced_search_all_devices": "All Devices",
    "advanced_search_all_organisations": "All Organisations",
    "advanced_search_all_patients": "All Patients",
    "advanced_search_applied_filters": "Applied Filters: ",
    "advanced_search_archived_patients": "Archived Patients",
    "advanced_search_filters_help": "Select or deselect boxes to filter your search.",
    "advanced_search_include": "Include in Search",
    "advanced_search_max": "Max",
    "advanced_search_min": "Min",
    "advanced_search_plan_completed": "Plan Completed",
    "advanced_search_rmt_level": "rMT Level",
    "advanced_search_scale": "Scale",
    "advanced_search_search_parameters": "Search Parameters",
    "advanced_search_showing": "Showing",
    "advanced_search_treater": "Treater",
    "analytics": "Analytics",
    "analytics_all_treaters": "All Treaters",
    "analytics_average_rmt": "Average rMT",
    "analytics_average_rmt_percent": "Average rMT (%)",
    "analytics_chart": "Chart",
    "analytics_clinics_rmt": "Clinics rMTs",
    "analytics_comparison": "Comparison",
    "analytics_data": "Data",
    "analytics_devices_rmt": "Devices rMTs",
    "analytics_last_sync_completed_time": "Last sync completed time",
    "analytics_last_sync_started_time": "Last sync started time",
    "analytics_number_of_clinics": "Clinic Count",
    "analytics_number_of_devices": "Device Count",
    "analytics_number_of_organisations": "Organisation Count",
    "analytics_number_of_patients": "Patient Count",
    "analytics_number_of_protocols": "Protocol Count",
    "analytics_number_of_protocols_with_accuracy_data": "Protocol Count (with accuracy information)",
    "analytics_number_of_pulses": "Pulse Count",
    "analytics_number_of_pulses_in_contact_tolerance": "Pulses Within Contact Tolerance",
    "analytics_number_of_pulses_in_contact_tolerance_short": "Contact",
    "analytics_number_of_pulses_in_distance_tolerance": "Pulses Within Distance Tolerance",
    "analytics_number_of_pulses_in_distance_tolerance_short": "Distance",
    "analytics_number_of_pulses_in_rotation_tolerance": "Pulses Within Rotation Tolerance",
    "analytics_number_of_pulses_in_rotation_tolerance_short": "Rotation",
    "analytics_number_of_pulses_in_tilt_tolerance": "Pulses Within Tilt Tolerance",
    "analytics_number_of_pulses_in_tilt_tolerance_short": "Tilt",
    "analytics_number_of_pulses_in_Tolerance": "Pulses Within Tolerance",
    "analytics_number_of_pulses_in_tolerance_percent": "Pulses Within Tolerance (%)",
    "analytics_number_of_pulses_in_Tolerance_short": "Tolerance",
    "analytics_number_of_pulses_in_tolerance_with_accuracy_data": "Pulses Within Tolerance (with accuracy information)",
    "analytics_number_of_pulses_with_accuracy_data": "Pulse Count (with accuracy information)",
    "analytics_number_of_rating_scales": "Rating Scale Count",
    "analytics_number_of_ratings": "Ratings Count",
    "analytics_number_of_rmts": "rMT Count",
    "analytics_number_of_treaters": "Treater Count",
    "analytics_number_of_treatments": "Treatment Count",
    "analytics_number_of_treatments_with_accuracy_data": "Treatment Count (with accuracy information)",
    "analytics_patient_patients_rmt": "Patients rMTs",
    "analytics_progress": "Progress",
    "analytics_progress_chart": "Analytics Progress Chart",
    "analytics_rmt_percent": "rMT (%)",
    "analytics_summary": "Summary",
    "analytics_time_period": "Time Period",
    "analytics_title": "{0} Analytics",
    "analytics_total_number_of_treatments": "Number of Treatments",
    "analytics_treater_treaters_accuracy": "Treaters Accuracy",
    "analytics_treater_treaters_assessments": "Treaters Assessments",
    "analytics_treater_treaters_rmt": "Treaters rMTs",
    "analytics_treatment_plans_completed": "Treatment Plans Completed",
    "application_error_1": "Application pre-loading initiated. ",
    "application_error_10": "Patient Profile - Overview displayed. ",
    "application_error_100": "HV over voltage. Restart system. ",
    "application_error_1001": "Executable {0} failed verification. ",
    "application_error_1002": "Database integrity check failed. ",
    "application_error_1003": "Executable {0} passed verification. ",
    "application_error_1004": "Database integrity check passed. ",
    "application_error_1005": "Application process {0} started. ",
    "application_error_1006": "Application process {0} exited. ",
    "application_error_1007": "Application process {0} exited unexpectedly. {1} - {2}. ",
    "application_error_101": "Mainframe invalid system configuration. Restart system. ",
    "application_error_1012": "System unlocked for service access. ",
    "application_error_1013": "Application {0} failed to respond. ",
    "application_error_1015": "Process monitor has detected multiple application failures. Contact service. ",
    "application_error_1016": "System storage level low. ",
    "application_error_1017": "System storage level critical. ",
    "application_error_102": "Mainframe stop line fault. Restart system. ",
    "application_error_103": "Base coil stop line fault. Restart system. ",
    "application_error_104": "UI stop line fault. Restart system. ",
    "application_error_105": "Mainframe dump system fault. Restart system. ",
    "application_error_106": "Invalid coil category for the current system configuration. Restart system. ",
    "application_error_107": "Invalid mainframe NVRAM checksum. Restart system. ",
    "application_error_108": "Mainframe faulty charging relay detected. Restart system. ",
    "application_error_109": "Mainframe ARM LED drive failure. Restart system. ",
    "application_error_11": "Patient Profile - MT History displayed. ",
    "application_error_110": "Mainframe external PSU fault. Restart system. ",
    "application_error_111": "Mainframe over temperature. Restart system. ",
    "application_error_112": "Mainframe snubber board over temperature. Restart system. ",
    "application_error_113": "Mainframe under temperature. Restart system. ",
    "application_error_114": "HVCAP under temperature. Restart system. ",
    "application_error_115": "Mainframe snubber board under temperature. Restart system. ",
    "application_error_116": "Mainframe ambient over temperature. Restart system. ",
    "application_error_117": "Mainframe failed to produce protocol. Restart system. ",
    "application_error_119": "Mainframe EPV limit exceeded. Contact Service. ",
    "application_error_12": "Patient Profile - Treatment Plan displayed. ",
    "application_error_120": "Mainframe HCI limit exceeded. Contact Service. ",
    "application_error_121": "Mainframe EPV/HCI EEPROM checksum error. Restart system. ",
    "application_error_122": "Mainframe EPV/HCI EEPROM not initialized. Restart system. ",
    "application_error_123": "Mainframe service date expired. Contact Service. ",
    "application_error_124": "Database failure - application will be restarted to check database integrity. ",
    "application_error_125": "StimGuide connection lost.  ",
    "application_error_126": "StimGuide connection established. ",
    "application_error_127": "StimGuide connection lost. Exit the current session. ",
    "application_error_128": "Treatment Started {0} - {1}, {2}, {3}, {4}, {5}, {6}, {7},{8}, Raw Coil Temps - T1: {9} T2: {10}. Predicted Coil Temps - T1: {11} T2: {12} ",
    "application_error_129": "Treatment Started {0} - {1}, {2}, {3}, {4}, {5}, {6}, {7}, {8}, {9}, Raw Coil Temps - T1: {10} T2: {11}. Predicted Coil Temps - T1: {12} T2: {13} ",
    "application_error_13": "Patient Profile - Treatment History displayed. ",
    "application_error_130": "Treatment complete. Raw Coil Temps - T1: {0} T2: {1}. Predicted Coil Temps - T1: {2} T2: {3} ",
    "application_error_131": "Parameter {0} has been modified from {1} to {2}. ",
    "application_error_132": "{0} additional pulses have been delivered. Raw Coil Temps - T1: {1} T2: {2}. Predicted Coil Temps - T1: {3} T2: {4} ",
    "application_error_133": "Treatment delivery has been suspended. Raw Coil Temps - T1: {0} T2: {1}. Predicted Coil Temps - T1: {2} T2: {3} ",
    "application_error_134": "Treatment delivery has been resumed. Raw Coil Temps - T1: {0} T2: {1}. Predicted Coil Temps - T1: {2} T2: {3} ",
    "application_error_135": "Treatment accuracy reported as {0} : {1}, {2}, {3}, {4}. ",
    "application_error_136": "Run treatment screen has been closed and treatment has been cancelled. ",
    "application_error_137": "StimGuide workflow Error. Exit the current session. ",
    "application_error_138": "Failed to save data, not enough storage available. Free: {0}, Required: {1}. Contact Service. ",
    "application_error_139": "A coil has been connected the mainframe. ",
    "application_error_14": "Build or Edit Treatment Plan displayed. ",
    "application_error_140": "Coil ready to use. Coil ID: {0}, TSPS: {1}, TLTC: {2}, S1TC: {3}, S2TC: {4}, Average Power: {5}. ",
    "application_error_141": "StimGuide is being configured. ",
    "application_error_142": "StimGuide configuration complete. ",
    "application_error_143": "GPIO connection failure. ",
    "application_error_144": "USB/Mass Storage Device connected. ",
    "application_error_145": "USB/Mass Storage Device disconnected. ",
    "application_error_146": "GPIO Exception. ",
    "application_error_147": "Login attempt failed. ",
    "application_error_148": "User: {0} has logged into the system. ",
    "application_error_149": "New user: {0} created by {1} with role: {2}. ",
    "application_error_15": "New individual treatment creation initialized. ",
    "application_error_150": "User: {0} password reset. ",
    "application_error_151": "Coil out of position relative to the treatment target. Suspend treatment and reposition Coil before resuming. ",
    "application_error_152": "Output set from {0} to {1}. HVCAP: {2}. ",
    "application_error_153": "Coil predicted temperature has reached 40C - Raw Coil Temps - T1: {0} T2: {1}. Predicted Coil Temps - T1: {2} T2: {3} ",
    "application_error_154": "Pulse delivered at {0:###0.#}% - HVCAP: {1}. ",
    "application_error_155": "Unknown Fault ({0}). Restart the system. ",
    "application_error_156": "Mainframe EPV limit exceeded. Contact Service. ",
    "application_error_157": "Mainframe HCI limit exceeded. Contact Service. ",
    "application_error_158": "Port Expander Configuration Failure. Restart system and Contact Service.",
    "application_error_159": "Port Expander 0 Failure. Restart system and Contact Service.",
    "application_error_16": "Individual treatment template {0} is being modified. ",
    "application_error_160": "Port Expander 1 Failure. Restart system and Contact Service.",
    "application_error_161": "Product number incompatible with current software.",
    "application_error_162": "Protocol synchronization failure. Please retry treatment delivery.",
    "application_error_163": "Remote upgrade is available for the system {0} - {1} ",
    "application_error_164": "UI Software update initiated - From: {0} To: {1} ",
    "application_error_165": "Mainframe Software update initiated - From: {0} To: {1} ",
    "application_error_166": "UI Software update {0} successful. ",
    "application_error_167": "Mainframe Software update successful. ",
    "application_error_168": "UI Software update (0) failed. ",
    "application_error_169": "Mainframe Software update failed. ",
    "application_error_17": "Individual treatment template {0} saved. ",
    "application_error_170": "System remaining pulses are empty. Contact Sales. ",
    "application_error_171": "Max system pulse usage reached. Contact Sales. ",
    "application_error_172": "Please Switch to Treatment Coil",
    "application_error_173": "System Configuration Unknown. Please Contact Service.",
    "application_error_18": "New combined treatment creation initialized. ",
    "application_error_19": "Combined treatment template {0} is being modified. ",
    "application_error_2": "System Initialization successful. ",
    "application_error_20": "Combined treatment template {0} saved. ",
    "application_error_21": "New treatment plan created and assigned to a patient. ",
    "application_error_22": "Existing treatment plan has been updated. ",
    "application_error_23": "Treatments home displayed. ",
    "application_error_24": "{0} treatment cloned. ",
    "application_error_25": "System - User Info displayed. ",
    "application_error_26": "System - Hardware info displayed. ",
    "application_error_27": "System - System Info displayed. ",
    "application_error_28": "User information modification initiated. ",
    "application_error_29": "User information modified. ",
    "application_error_3": "First-time use wizard initiated. ",
    "application_error_30": "Date and time settings modification initiated. ",
    "application_error_31": "Date and time settings modified. ",
    "application_error_32": "Volume increased. ",
    "application_error_33": "Volume decreased. ",
    "application_error_34": "Brightness increased. ",
    "application_error_35": "Brightness decreased. ",
    "application_error_36": "Language settings modification initiated. ",
    "application_error_37": "Language settings modified. ",
    "application_error_38": "Region changed to {0}. ",
    "application_error_39": "Language set to {0}. ",
    "application_error_4": "Login screen displayed. ",
    "application_error_40": "Report template modification initiated. ",
    "application_error_41": "Report template modified. ",
    "application_error_42": "Contact us displayed. ",
    "application_error_43": "User signed out. ",
    "application_error_44": "User accessed help menu (Main Menu). ",
    "application_error_45": "User accessed help menu (rMT determination). ",
    "application_error_46": "User accessed help menu (Run Treatment). ",
    "application_error_47": "rMT Determination displayed. ",
    "application_error_48": "Run Treatment displayed. ",
    "application_error_49": "Network connection lost. ",
    "application_error_5": "Setup complete. ",
    "application_error_50": "Network connection established. ",
    "application_error_51": "Stimulator connection lost. Wait for reconnect.",
    "application_error_52": "Stimulator connection established. ",
    "application_error_53": "Stimulator connection lost. Wait for reconnect.",
    "application_error_54": "Coil ROM checksum incorrect. Disconnect and Reconnect Coil. ",
    "application_error_55": "EEPROM checksum incorrect. Disconnect and Reconnect Coil. ",
    "application_error_56": "Invalid coil interface category. Disconnect and Reconnect Coil. ",
    "application_error_57": "Invalid coil power category. Disconnect and Reconnect Coil. ",
    "application_error_58": "Coil temperature sensor circuit failure. Disconnect and Reconnect Coil. ",
    "application_error_59": "Bad serial command to coil. Disconnect and Reconnect Coil. ",
    "application_error_6": "Patient home displayed. ",
    "application_error_60": "Internal coil software error. Disconnect and Reconnect Coil. ",
    "application_error_61": "Invalid coil identification. Disconnect and Reconnect Coil. ",
    "application_error_62": "Invalid coil temperature algorithm coefficient. Disconnect and Reconnect Coil. ",
    "application_error_63": "Coil controller malfunction. Disconnect and Reconnect Coil. ",
    "application_error_64": "Rapid² coil algorithm constant checksum error. Disconnect and Reconnect Coil. ",
    "application_error_65": "Invalid coil enhanced power byte checksum. Disconnect and Reconnect Coil. ",
    "application_error_66": "Invalid coil average power checksum. Disconnect and Reconnect Coil. ",
    "application_error_67": "Coil under temperature. Disconnect and Reconnect Coil. ",
    "application_error_68": "Coil brown out detected. Disconnect and Reconnect Coil. ",
    "application_error_69": "Coil serial communications with mainframe lost (Coil Disconnected). Disconnect and Reconnect Coil. ",
    "application_error_7": "Failure to read from database. Retry operation. ",
    "application_error_70": "Bad serial command received outside of TRIGGATE. Disconnect and Reconnect Coil. ",
    "application_error_71": "Coil EMC Detected. Disconnect and Reconnect Coil. ",
    "application_error_72": "Coil invalid power identification. Disconnect and Reconnect Coil. ",
    "application_error_73": "Coil hardware stop activated. Disconnect and Reconnect Coil. ",
    "application_error_74": "Coil watchdog timeout. Disconnect and Reconnect Coil. ",
    "application_error_75": "Coil temperature interlock 3 activated. Disconnect and Reconnect Coil. ",
    "application_error_76": "Coil stop line fault. Disconnect and Reconnect Coil. ",
    "application_error_77": "Coil air extraction unit not operating correctly. Disconnect and Reconnect Coil. ",
    "application_error_78": "Coil EPV EEPROM Checksum error. Disconnect and Reconnect Coil. ",
    "application_error_79": "Coil EPV limit exceeded. Contact Service. ",
    "application_error_8": "\r\n\t\tFailure to write to database. Retry operation. ",
    "application_error_80": "Coil expiry date exceeded. Contact Service. ",
    "application_error_81": "Mainframe power fail. Restart system. ",
    "application_error_82": "Mainframe stack underflow. Restart system. ",
    "application_error_83": "Mainframe stack overflow. Restart system. ",
    "application_error_84": "Mainframe RTS overrun. Restart system. ",
    "application_error_85": "Mainframe watchdog timeout. Restart system. ",
    "application_error_86": "Mainframe unexpected reset. Restart system. ",
    "application_error_87": "Mainframe bad checksum. Restart system. ",
    "application_error_88": "Mainframe SYS debug error. Restart system. ",
    "application_error_89": "Coil over temp. Remove coil from Patient. ",
    "application_error_9": "New patient profile creation initiated. ",
    "application_error_90": "Coil max difference. Restart system. ",
    "application_error_91": "Mainframe stack over temperature. Restart system. ",
    "application_error_92": "Mainframe stack under temperature. Restart system. ",
    "application_error_93": "Mainframe stack max difference. Restart system. ",
    "application_error_94": "HVCAP over temperature. Restart system. ",
    "application_error_95": "HV Transformer over temperature. Restart system. ",
    "application_error_96": "Mainframe charge threshold failure. Restart system. ",
    "application_error_97": "VREF check failure. Restart system. ",
    "application_error_98": "HVCAP voltage comparison failure. Restart system. ",
    "application_error_99": "Mainframe charging fault. Restart system. ",
    "apply": "Apply",
    "are_you_sure": "Are you sure?",
    "armed_upper": "READY",
    "arming_upper": "ARMED",
    "assessment_analytics": "Assessment Analytics",
    "assessments": "Assessments",
    "assessor_type": "Assessed by",
    "assessor_type_external": "External",
    "assessor_type_physician": "Physician",
    "assessor_type_user": "User",
    "back": "Back",
    "basic_search": "Back to Search",
    "bootloader_exit_with_error_code_caption": "Magstim Bootloader Programmer",
    "bootloader_exit_with_error_code_message": "The update has failed, do you want to retry?",
    "bootloader_rollback_not_available_caption": "Magstim Bootloader Programmer",
    "bootloader_rollback_not_available_message": "Unable to find firmware to rollback to previously installed version '{0}' in folder: \r\n    \r\n{1}",
    "cancel": "Cancel",
    "cancel_warning_discard_and_exit": "Discard & exit",
    "cancel_warning_resume_edit": "Resume edit",
    "cancel_warning_title": "Warning",
    "cannot_find_user_in_pdm": "Error getting user - please check with the system administrator that the user is setup correctly",
    "changes_not_saved_warning": "Warning! Changes unsaved. Select OK to leave.",
    "charge_delay_duration": "Duration",
    "charge_delay_ms": "ms",
    "charge_delay_off": "Off",
    "charge_delay_on": "On",
    "charge_delay_title": "Charge Delay",
    "clear_filters": "Clear Filters",
    "clinic": "Clinic",
    "clinic_accuracy": "Clinic Accuracy",
    "clinic_add": "Add Clinic",
    "clinic_address": "Address",
    "clinic_analytics": "Clinic  Analytics",
    "clinic_analytics_help": "Use the buttons below to view the detailed clinic analytics for {0} ",
    "clinic_assessments": "Clinic Assessments",
    "clinic_country": "Country",
    "clinic_edit": "Edit Clinic",
    "clinic_max_users": "Max Users Per Clinic",
    "clinic_name": "Clinic Name",
    "clinic_phone": "Contact Number",
    "clinic_rep": "Clinic Representative",
    "clinic_rmt": "Clinic rMTs",
    "clinic_search": "Clinic Search",
    "clinic_status": "Status",
    "clinic_treatments": "Clinic Treatments",
    "clinic_users_per_clinic": "Users Per Clinic",
    "clinic_zip": "Zip / Postal Code",
    "clinical_assessment": "Clinical Assessment",
    "clinical_assessment_all_scales": "All Scales",
    "clinical_assessment_assessed_by": "Assessed By",
    "clinical_assessment_assessment_count": "Assessment Count",
    "clinical_assessment_assessment_date": "Assessment Date",
    "clinical_assessment_baseline": "Baseline",
    "clinical_assessment_change_all_time": "All Time Change",
    "clinical_assessment_change_from_previous": "Change From Previous",
    "clinical_assessment_change_in_range": "Change in Range",
    "clinical_assessment_chart_no_data": "Chart will show when at least 2 assessments have been carried out",
    "clinical_assessment_column_assessment_count_in_range": "Assessment count (in range)",
    "clinical_assessment_column_average_baseline": "Average baseline",
    "clinical_assessment_column_average_last_recorded": "Average last recorded",
    "clinical_assessment_column_improvement": "Improvement (-ive good)",
    "clinical_assessment_first_assessment_date": "First Assessment Date",
    "clinical_assessment_first_assessment_score": "First Assessment Score",
    "clinical_assessment_first_in_range_assessment_date": "First in Range Assessment Date",
    "clinical_assessment_first_in_range_assessment_score": "First in Range Assessment Score",
    "clinical_assessment_in_range_assessment_count": "Assessment in Range Count",
    "clinical_assessment_last_assessment": "Last Assessment",
    "clinical_assessment_last_assessment_rating": "Last Assessment Rating",
    "clinical_assessment_latest_assessment_date": "Latest Assessment Date",
    "clinical_assessment_rating_scale": "Rating Scale",
    "clinical_assessment_rating_score": "Rating Score",
    "clinical_assessment_rating_score_pc": "Rating Score %",
    "clinical_assessment_self_assessed": "Self assessed",
    "clinical_assessment_test_type": "Assessed Type",
    "clinical_assessment_type": "Assessment Type",
    "clinical_assessment_type_link": "Link",
    "clinical_assessment_type_link_copied": "Link Copied to Clipboard",
    "clinical_assessment_type_manual": "Manual Results Entry",
    "clinical_assessment_type_self": "Patient Self Assessment",
    "clinical_assessment_type_self_get_link": "Generate Link",
    "clinical_assessment_type_self_get_link_help": "Press ",
    "clinical_assessment_type_user": "User Assessment",
    "clinical_assessment_type_user_start": "Start Assessment",
    "clinical_assessments": "Clinical Assessments",
    "clinical_ratings_app_bdi_question_0": "Sadness",
    "clinical_ratings_app_bdi_question_1": "Pessimism",
    "clinical_ratings_app_bdi_question_10": "Agitation",
    "clinical_ratings_app_bdi_question_11": "Loss of Interest",
    "clinical_ratings_app_bdi_question_12": "Indecisiveness",
    "clinical_ratings_app_bdi_question_13": "Wothlessness",
    "clinical_ratings_app_bdi_question_14": "Loss of Energy",
    "clinical_ratings_app_bdi_question_15": "Changes in Sleeping Pattern",
    "clinical_ratings_app_bdi_question_16": "Irritability",
    "clinical_ratings_app_bdi_question_17": "Changes in Appetite",
    "clinical_ratings_app_bdi_question_18": "Concentration Difficulty",
    "clinical_ratings_app_bdi_question_19": "Tiredness or Fatigue",
    "clinical_ratings_app_bdi_question_2": "Past Failure",
    "clinical_ratings_app_bdi_question_20": "Loss of Interest in Sex",
    "clinical_ratings_app_bdi_question_3": "Loss of Pleasure",
    "clinical_ratings_app_bdi_question_4": "Guilty Feelings",
    "clinical_ratings_app_bdi_question_5": "Punishment Feelings",
    "clinical_ratings_app_bdi_question_6": "Self-Dislike",
    "clinical_ratings_app_bdi_question_7": "Self-Criticalness",
    "clinical_ratings_app_bdi_question_8": "Suicidal Thoughts or Wishes",
    "clinical_ratings_app_bdi_question_9": "Crying",
    "clinical_ratings_app_bdi_response_major": "Major",
    "clinical_ratings_app_bdi_response_minor": "Minor",
    "clinical_ratings_app_bdi_response_moderate": "Moderate",
    "clinical_ratings_app_bdi_response_severe": "Severe",
    "clinical_ratings_app_bdi_result_mild": "Mild",
    "clinical_ratings_app_bdi_result_minimal": "Minimal",
    "clinical_ratings_app_bdi_result_moderate": "Moderate",
    "clinical_ratings_app_bdi_result_severe": "Severe",
    "clinical_ratings_app_cesd_question_0": "I was bothered by things that usually don't bother me",
    "clinical_ratings_app_cesd_question_1": "I did not feel like eating",
    "clinical_ratings_app_cesd_question_10": "My sleep was restless",
    "clinical_ratings_app_cesd_question_11": "I was happy",
    "clinical_ratings_app_cesd_question_12": "I talked less than usual",
    "clinical_ratings_app_cesd_question_13": "I felt lonely",
    "clinical_ratings_app_cesd_question_14": "People were unfriendly",
    "clinical_ratings_app_cesd_question_15": "I enjoyed life",
    "clinical_ratings_app_cesd_question_16": "I had crying spells",
    "clinical_ratings_app_cesd_question_17": "I felt sad",
    "clinical_ratings_app_cesd_question_18": "I felt that people dislike me",
    "clinical_ratings_app_cesd_question_19": "I could not get going",
    "clinical_ratings_app_cesd_question_2": "I felt like that I could not shake off the blues even with help from family and friends",
    "clinical_ratings_app_cesd_question_3": "I felt I was just as good as other people",
    "clinical_ratings_app_cesd_question_4": "I had trouble keeping my mind on what I was doing",
    "clinical_ratings_app_cesd_question_5": "I felt depressed",
    "clinical_ratings_app_cesd_question_6": "I felt that everything I did was an effort",
    "clinical_ratings_app_cesd_question_7": "I felt hopeful about my future",
    "clinical_ratings_app_cesd_question_8": "I thought my life has been a failure",
    "clinical_ratings_app_cesd_question_9": "I felt fearful",
    "clinical_ratings_app_cesd_response_major": "Major",
    "clinical_ratings_app_cesd_response_minor": "Minor",
    "clinical_ratings_app_cesd_response_moderate": "Moderate",
    "clinical_ratings_app_cesd_response_none": "None",
    "clinical_ratings_app_cesd_result_depressionindicated": "Depression Indicated",
    "clinical_ratings_app_cesd_result_none": "None",
    "clinical_ratings_app_csdd_question_0": "Anxiety",
    "clinical_ratings_app_csdd_question_1": "Sadness",
    "clinical_ratings_app_csdd_question_10": "Lack of energy",
    "clinical_ratings_app_csdd_question_11": "Diurnal variation of mood",
    "clinical_ratings_app_csdd_question_12": "Difficulty falling asleep",
    "clinical_ratings_app_csdd_question_13": "Multiple awakenings during sleep",
    "clinical_ratings_app_csdd_question_14": "Early morning awakenings",
    "clinical_ratings_app_csdd_question_15": "Suicide",
    "clinical_ratings_app_csdd_question_16": "Self-depreciation",
    "clinical_ratings_app_csdd_question_17": "Pessimism",
    "clinical_ratings_app_csdd_question_18": "Mood congruent delusions",
    "clinical_ratings_app_csdd_question_2": "Lack of reactivity to pleasant events",
    "clinical_ratings_app_csdd_question_3": "Irritability",
    "clinical_ratings_app_csdd_question_4": "Agitation",
    "clinical_ratings_app_csdd_question_5": "Retardation",
    "clinical_ratings_app_csdd_question_6": "Multiple physical complaints",
    "clinical_ratings_app_csdd_question_7": "Loss of interest",
    "clinical_ratings_app_csdd_question_8": "Appetite loss",
    "clinical_ratings_app_csdd_question_9": "Weight loss",
    "clinical_ratings_app_csdd_response_major": "Major",
    "clinical_ratings_app_csdd_response_minor": "Minor",
    "clinical_ratings_app_csdd_response_moderate": "Moderate",
    "clinical_ratings_app_csdd_result_abscence": "Abscence",
    "clinical_ratings_app_csdd_result_definitemajordepression": "Definite Major Depression",
    "clinical_ratings_app_csdd_result_mild": "Mild",
    "clinical_ratings_app_csdd_result_probablemajordepression": "Probable Major Depression",
    "clinical_ratings_app_gad7_question_0": "Feeling nervous, anxious or on edge?",
    "clinical_ratings_app_gad7_question_1": "Not being able to stop or control worrying?",
    "clinical_ratings_app_gad7_question_2": "Worrying too much about different things?",
    "clinical_ratings_app_gad7_question_3": "Trouble relaxing?",
    "clinical_ratings_app_gad7_question_4": "Being so restless that it is hard to sit still?",
    "clinical_ratings_app_gad7_question_5": "Becoming easily annoyed or irritable?",
    "clinical_ratings_app_gad7_question_6": "Feeling afraid as if something awful might happen?",
    "clinical_ratings_app_gad7_response_morethanhalfthedays": "More than half the days",
    "clinical_ratings_app_gad7_response_nearlyeveryday": "Nearly every day",
    "clinical_ratings_app_gad7_response_notatall": "Not at all",
    "clinical_ratings_app_gad7_response_severaldays": "Several days",
    "clinical_ratings_app_gad7_result_mild": "Mild",
    "clinical_ratings_app_gad7_result_moderate": "Moderate",
    "clinical_ratings_app_gad7_result_none": "None",
    "clinical_ratings_app_gad7_result_severe": "Severe",
    "clinical_ratings_app_gds15_question_0": "Are you basically satisfied with your life?",
    "clinical_ratings_app_gds15_question_1": "Have you dropped many of your activities and interests?",
    "clinical_ratings_app_gds15_question_10": "Do you think it is wonderful to be alive now?",
    "clinical_ratings_app_gds15_question_11": "Do you feel pretty worthless the way your are now?",
    "clinical_ratings_app_gds15_question_12": "Do you feel full of energy?",
    "clinical_ratings_app_gds15_question_13": "Do you feel that your situation is hopeless?",
    "clinical_ratings_app_gds15_question_14": "Do you think most people are better off than you are?",
    "clinical_ratings_app_gds15_question_2": "Do you feel that your life is empty?",
    "clinical_ratings_app_gds15_question_3": "Do you often get bored?",
    "clinical_ratings_app_gds15_question_4": "Are you in good spirits most of the time?",
    "clinical_ratings_app_gds15_question_5": "Are you afraid that something bad is going to happen to you?",
    "clinical_ratings_app_gds15_question_6": "Do you feel happy most of the time?",
    "clinical_ratings_app_gds15_question_7": "Do you often feel helpless?",
    "clinical_ratings_app_gds15_question_8": "Do you prefer to stay at home rather than going out and doing new things?",
    "clinical_ratings_app_gds15_question_9": "Do you feel you have more problems with memory than most?",
    "clinical_ratings_app_gds15_response_no": "No",
    "clinical_ratings_app_gds15_response_yes": "Yes",
    "clinical_ratings_app_gds15_result_none": "None",
    "clinical_ratings_app_gds15_result_seekmedicaladvice": "Seek Medical Advice",
    "clinical_ratings_app_gds4_question_0": "Are you basically satisfied with your life?",
    "clinical_ratings_app_gds4_question_1": "Do you feel that your life is empty?",
    "clinical_ratings_app_gds4_question_2": "Are you afraid that something bad is going to happen to you?",
    "clinical_ratings_app_gds4_question_3": "Do you feel happy most of the time?",
    "clinical_ratings_app_gds4_response_no": "No",
    "clinical_ratings_app_gds4_response_yes": "Yes",
    "clinical_ratings_app_gds4_result_depressed": "Depressed",
    "clinical_ratings_app_gds4_result_notdepressed": "Not Depressed",
    "clinical_ratings_app_gds4_result_uncertain": "Uncertain",
    "clinical_ratings_app_hads_question_0": "Feel tense or 'wound up'",
    "clinical_ratings_app_hads_question_1": "I still enjoy the things I used to enjoy",
    "clinical_ratings_app_hads_question_10": "I feel restless as I have to be on the move",
    "clinical_ratings_app_hads_question_11": "I look forwards with enjoyment to things",
    "clinical_ratings_app_hads_question_12": "I get sudden feelings of panic",
    "clinical_ratings_app_hads_question_13": "I can enjoy a good book or radio or TV program",
    "clinical_ratings_app_hads_question_2": "I get a sort of frightened feeling as if something awful is about to happen",
    "clinical_ratings_app_hads_question_3": "I can laugh and see the funny side of things",
    "clinical_ratings_app_hads_question_4": "Worrying thoughts go through my mind",
    "clinical_ratings_app_hads_question_5": "I feel cheerful",
    "clinical_ratings_app_hads_question_6": "I can sit at ease and feel relaxed",
    "clinical_ratings_app_hads_question_7": "I feel as if I am slowed down",
    "clinical_ratings_app_hads_question_8": "I get a sort of frightened feeling like 'butterflies' in the stomach",
    "clinical_ratings_app_hads_question_9": "I have lost interest in my appearance",
    "clinical_ratings_app_hads_response_major": "Major",
    "clinical_ratings_app_hads_response_minor": "Minor",
    "clinical_ratings_app_hads_response_moderate": "Moderate",
    "clinical_ratings_app_hads_response_none": "None",
    "clinical_ratings_app_hads_result_abnormal": "Abnormal",
    "clinical_ratings_app_hads_result_borderline": "Borderline",
    "clinical_ratings_app_hads_result_normal": "Normal",
    "clinical_ratings_app_hamd_question_0": "Depressed Mood",
    "clinical_ratings_app_hamd_question_1": "Feelings of Guilt",
    "clinical_ratings_app_hamd_question_10": "Anxiety - Somatic",
    "clinical_ratings_app_hamd_question_11": "Somatic Symptoms - Gastrointestinal",
    "clinical_ratings_app_hamd_question_12": "Somatic Symptoms - General",
    "clinical_ratings_app_hamd_question_13": "Genital Symptoms",
    "clinical_ratings_app_hamd_question_14": "Hypochondriasis",
    "clinical_ratings_app_hamd_question_15": "Weight Loss",
    "clinical_ratings_app_hamd_question_16": "Insight",
    "clinical_ratings_app_hamd_question_17": "Diurnal Variation",
    "clinical_ratings_app_hamd_question_18": "Depersonalization and Derealization",
    "clinical_ratings_app_hamd_question_19": "Paranoid Symptoms",
    "clinical_ratings_app_hamd_question_2": "Suicide",
    "clinical_ratings_app_hamd_question_20": "Obsessional Symptoms",
    "clinical_ratings_app_hamd_question_3": "Insomnia (Initial)",
    "clinical_ratings_app_hamd_question_4": "Insomnia (Middle)",
    "clinical_ratings_app_hamd_question_5": "Insomnia (Delayed)",
    "clinical_ratings_app_hamd_question_6": "Work and Interests",
    "clinical_ratings_app_hamd_question_7": "Retardation",
    "clinical_ratings_app_hamd_question_8": "Agitation",
    "clinical_ratings_app_hamd_question_9": "Anxiety - Psychic",
    "clinical_ratings_app_hamd_response_absent": "Absent",
    "clinical_ratings_app_hamd_response_major": "Major",
    "clinical_ratings_app_hamd_response_minor": "Minor",
    "clinical_ratings_app_hamd_response_moderate": "Moderate",
    "clinical_ratings_app_hamd_response_severe": "Severe",
    "clinical_ratings_app_hamd_result_mild": "Mild",
    "clinical_ratings_app_hamd_result_moderate": "Moderate",
    "clinical_ratings_app_hamd_result_normal": "Normal",
    "clinical_ratings_app_hamd_result_severe": "Severe",
    "clinical_ratings_app_hamd_result_verysevere": "Very Severe",
    "clinical_ratings_app_idssr_question_0": "Falling asleep",
    "clinical_ratings_app_idssr_question_1": "Sleep during the night",
    "clinical_ratings_app_idssr_question_10": "Decreased or increased appetite",
    "clinical_ratings_app_idssr_question_11": "Decreased or increased weight",
    "clinical_ratings_app_idssr_question_12": "Concentration/decision making",
    "clinical_ratings_app_idssr_question_13": "View of myself",
    "clinical_ratings_app_idssr_question_14": "View of my future",
    "clinical_ratings_app_idssr_question_15": "Thoughts of death or suicide",
    "clinical_ratings_app_idssr_question_16": "General interest",
    "clinical_ratings_app_idssr_question_17": "Energy level",
    "clinical_ratings_app_idssr_question_18": "Capacity for pleasure or enjoyment",
    "clinical_ratings_app_idssr_question_19": "Interest in sex",
    "clinical_ratings_app_idssr_question_2": "Waking up too early",
    "clinical_ratings_app_idssr_question_20": "Feeling slowed down",
    "clinical_ratings_app_idssr_question_21": "Feeling restless",
    "clinical_ratings_app_idssr_question_22": "Aches and pains",
    "clinical_ratings_app_idssr_question_23": "Other bodily symptoms",
    "clinical_ratings_app_idssr_question_24": "Panic / Phobic symptoms",
    "clinical_ratings_app_idssr_question_25": "Constipation / diarrhoea",
    "clinical_ratings_app_idssr_question_26": "Interpersonal sensitivity",
    "clinical_ratings_app_idssr_question_27": "Leaden paralysis / physical energy",
    "clinical_ratings_app_idssr_question_3": "Sleeping too much",
    "clinical_ratings_app_idssr_question_4": "Feeling sad",
    "clinical_ratings_app_idssr_question_5": "Feeling irritable",
    "clinical_ratings_app_idssr_question_6": "Feeling anxious or tense",
    "clinical_ratings_app_idssr_question_7": "Response of your mood to good or desired events",
    "clinical_ratings_app_idssr_question_8": "Mood in relation to the time of day",
    "clinical_ratings_app_idssr_question_9": "The quality of your mood",
    "clinical_ratings_app_idssr_response_major": "Major",
    "clinical_ratings_app_idssr_response_minor": "Minor",
    "clinical_ratings_app_idssr_response_moderate": "Moderate",
    "clinical_ratings_app_idssr_response_none": "None",
    "clinical_ratings_app_idssr_result_mild": "Mild",
    "clinical_ratings_app_idssr_result_moderate": "Moderate",
    "clinical_ratings_app_idssr_result_none": "None",
    "clinical_ratings_app_idssr_result_severe": "Severe",
    "clinical_ratings_app_idssr_result_verysevere": "Very Severe",
    "clinical_ratings_app_madrs_question_0": "Apparent sadness",
    "clinical_ratings_app_madrs_question_1": "Reported sadness",
    "clinical_ratings_app_madrs_question_2": "Inner tension",
    "clinical_ratings_app_madrs_question_3": "Reduced sleep",
    "clinical_ratings_app_madrs_question_4": "Reduced appetite",
    "clinical_ratings_app_madrs_question_5": "Concentration difficulties",
    "clinical_ratings_app_madrs_question_6": "Lassitude",
    "clinical_ratings_app_madrs_question_7": "Inability to feel",
    "clinical_ratings_app_madrs_question_8": "Pessimistic thoughts",
    "clinical_ratings_app_madrs_question_9": "Suicidal thoughts",
    "clinical_ratings_app_madrs_response_extreme": "Extreme",
    "clinical_ratings_app_madrs_response_highest": "Highest",
    "clinical_ratings_app_madrs_response_major": "Major",
    "clinical_ratings_app_madrs_response_minor": "Minor",
    "clinical_ratings_app_madrs_response_moderate": "Moderate",
    "clinical_ratings_app_madrs_response_none": "None",
    "clinical_ratings_app_madrs_response_severe": "Severe",
    "clinical_ratings_app_madrs_result_mild": "Mild",
    "clinical_ratings_app_madrs_result_moderate": "Moderate",
    "clinical_ratings_app_madrs_result_normal": "Normal",
    "clinical_ratings_app_madrs_result_severe": "Severe",
    "clinical_ratings_app_message_submission_complete": "Your clinical rating has been submitted.\r\n    \r\nYou can now close this window.",
    "clinical_ratings_app_phq9_question_0": "Little interest or pleasure in doing things?",
    "clinical_ratings_app_phq9_question_1": "Feeling down, depressed, or hopeless?",
    "clinical_ratings_app_phq9_question_2": "Trouble falling or staying asleep, or sleeping too much?",
    "clinical_ratings_app_phq9_question_3": "Feeling tired or having little energy?",
    "clinical_ratings_app_phq9_question_4": "Poor appetite or overeating?",
    "clinical_ratings_app_phq9_question_5": "Feeling bad about yourself – or that you are a failure or have let yourself or your family down?",
    "clinical_ratings_app_phq9_question_6": "Trouble concentrating on things, such as reading the newspaper or watching television?",
    "clinical_ratings_app_phq9_question_7": "Moving or speaking so slowly that other people could have noticed? Or the opposite – being so fidgety or restless that you have been moving around a lot more than usual?",
    "clinical_ratings_app_phq9_question_8": "Thoughts that you would be better off dead or of hurting yourself in some way?",
    "clinical_ratings_app_phq9_response_morethanhalfthedays": "More than half the days",
    "clinical_ratings_app_phq9_response_nearlyeveryday": "Nearly every day",
    "clinical_ratings_app_phq9_response_notatall": "Not at all",
    "clinical_ratings_app_phq9_response_severaldays": "Several days",
    "clinical_ratings_app_phq9_result_mild": "Mild",
    "clinical_ratings_app_phq9_result_minimal": "Minimal",
    "clinical_ratings_app_phq9_result_moderate": "Moderate",
    "clinical_ratings_app_phq9_result_moderatelysevere": "Moderately Severe",
    "clinical_ratings_app_phq9_result_severe": "Severe",
    "clinical_ratings_app_qids_question_0": "Falling asleep",
    "clinical_ratings_app_qids_question_1": "Sleep during the night",
    "clinical_ratings_app_qids_question_10": "View of myself",
    "clinical_ratings_app_qids_question_11": "Thoughts of death or suicide",
    "clinical_ratings_app_qids_question_12": "General interest",
    "clinical_ratings_app_qids_question_13": "Energy level",
    "clinical_ratings_app_qids_question_14": "Feeling slowed down",
    "clinical_ratings_app_qids_question_15": "Feeling restless",
    "clinical_ratings_app_qids_question_2": "Waking up too early",
    "clinical_ratings_app_qids_question_3": "Sleeping too much",
    "clinical_ratings_app_qids_question_4": "Feeling sad",
    "clinical_ratings_app_qids_question_5": "Decreased appetite",
    "clinical_ratings_app_qids_question_6": "Increased appetite",
    "clinical_ratings_app_qids_question_7": "Decreased weight (Last two weeks)",
    "clinical_ratings_app_qids_question_8": "Increased weight (Last two weeks)",
    "clinical_ratings_app_qids_question_9": "Concentration/Decision Making",
    "clinical_ratings_app_qids_response_major": "Major",
    "clinical_ratings_app_qids_response_minor": "Minor",
    "clinical_ratings_app_qids_response_moderate": "Moderate",
    "clinical_ratings_app_qids_response_none": "None",
    "clinical_ratings_app_qids_result_mild": "Mild",
    "clinical_ratings_app_qids_result_moderate": "Moderate",
    "clinical_ratings_app_qids_result_none": "None",
    "clinical_ratings_app_qids_result_severe": "Severe",
    "clinical_ratings_app_qids_result_verysevere": "VerySevere",
    "clinical_ratings_app_title_assessment": "Assessment {0}",
    "clinical_ratings_app_title_error": "Error",
    "clinical_ratings_app_title_submission_complete": "Submission complete",
    "clinical_ratings_app_undefined": "Undefined",
    "clinical_ratings_app_ybocs_question_0": "Time occupied by obsessive thoughts",
    "clinical_ratings_app_ybocs_question_1": "Obsession-free interval",
    "clinical_ratings_app_ybocs_question_10": "Resistance against compulsions",
    "clinical_ratings_app_ybocs_question_11": "Degree of control over compulsive behaviour",
    "clinical_ratings_app_ybocs_question_2": "Interference due to obsessive thoughts",
    "clinical_ratings_app_ybocs_question_3": "Distress associated with obsessive thoughts",
    "clinical_ratings_app_ybocs_question_4": "Resistance against obsessions",
    "clinical_ratings_app_ybocs_question_5": "Degree of control over obsessive thoughts",
    "clinical_ratings_app_ybocs_question_6": "Time spent performing compulsive behaviours",
    "clinical_ratings_app_ybocs_question_7": "Compulsion-free interval",
    "clinical_ratings_app_ybocs_question_8": "Interference due to compulsive behaviours",
    "clinical_ratings_app_ybocs_question_9": "Distress associated with compulsive behaviour",
    "clinical_ratings_app_ybocs_response_major": "Major",
    "clinical_ratings_app_ybocs_response_minor": "Minor",
    "clinical_ratings_app_ybocs_response_moderate": "Moderate",
    "clinical_ratings_app_ybocs_response_none": "None",
    "clinical_ratings_app_ybocs_response_severe": "Severe",
    "clinical_ratings_app_ybocs_result_extreme": "Extreme",
    "clinical_ratings_app_ybocs_result_mild": "Mild",
    "clinical_ratings_app_ybocs_result_moderate": "Moderate",
    "clinical_ratings_app_ybocs_result_none": "None",
    "clinical_ratings_app_ybocs_result_severe": "Severe",
    "clinical_ratings_app_zungsds_question_0": "I feel down-hearted and blue",
    "clinical_ratings_app_zungsds_question_1": "Morning is when I feel the best",
    "clinical_ratings_app_zungsds_question_10": "My mind is as clear as it used to be",
    "clinical_ratings_app_zungsds_question_11": "I find it easy to do the things I used to",
    "clinical_ratings_app_zungsds_question_12": "I am restless and can’t keep still",
    "clinical_ratings_app_zungsds_question_13": "I feel hopeful about the future",
    "clinical_ratings_app_zungsds_question_14": "I am more irritable than usual",
    "clinical_ratings_app_zungsds_question_15": "I find it easy to make decisions",
    "clinical_ratings_app_zungsds_question_16": "I feel that I am useful and needed",
    "clinical_ratings_app_zungsds_question_17": "My life is pretty full",
    "clinical_ratings_app_zungsds_question_18": "I feel that other would be better off if I were dead",
    "clinical_ratings_app_zungsds_question_19": "I still enjoy the things I used to do",
    "clinical_ratings_app_zungsds_question_2": "I have crying spells or feel like it",
    "clinical_ratings_app_zungsds_question_3": "I have trouble sleeping at night",
    "clinical_ratings_app_zungsds_question_4": "I eat as much as I used to",
    "clinical_ratings_app_zungsds_question_5": "I still enjoy sex",
    "clinical_ratings_app_zungsds_question_6": "I noticed that I am losing weight",
    "clinical_ratings_app_zungsds_question_7": "I have trouble with constipation",
    "clinical_ratings_app_zungsds_question_8": "My heart beats faster than usual",
    "clinical_ratings_app_zungsds_question_9": "I get tired for no reason",
    "clinical_ratings_app_zungsds_response_major": "Major",
    "clinical_ratings_app_zungsds_response_minor": "Minor",
    "clinical_ratings_app_zungsds_response_moderate": "Moderate",
    "clinical_ratings_app_zungsds_response_none": "None",
    "clinical_ratings_app_zungsds_result_mild": "Mild",
    "clinical_ratings_app_zungsds_result_moderate": "Moderate",
    "clinical_ratings_app_zungsds_result_normal": "Normal",
    "clinical_ratings_app_zungsds_result_severe": "Severe",
    "clinical_ratings_error_expired": "The link expired on {0}.\r\n  \r\nPlease contact your clinician for another test.",
    "clinical_ratings_error_invalid_arg": "Test link is invalid.\r\n  \r\nPlease contact your clinician for another test.",
    "clinical_ratings_error_missing_arg": "Test link is missing.\r\n  \r\nPlease contact your clinician for another test.",
    "clinical_ratings_error_submission_failed": "Submssion failed with error code {0}.\r\n  \r\nPlease contact your clinician to return the results.\r\n\r\nYour responses were:\r\n\r\n{1}\r\n",
    "clinical_ratings_must_be_greater_than": "Rating must be greater than or equal to",
    "clinical_ratings_must_be_less_than": "Rating must be less than or equal to",
    "clinical_ratings_no_future": "Cannot be in the future",
    "clinical_ratings_out_of_range": "Rating out of range",
    "clinical_ratings_scale_invalid": "Rating scale invalid",
    "clinics": "Clinics",
    "coil_upper": "COIL",
    "combined_treatment_not_unique": "The combined treatment {0} has the same treatments",
    "comparison_equals": "=",
    "comparison_greater": ">",
    "comparison_greater_equals": ">=",
    "comparison_less": "<",
    "comparison_less_equals": "<=",
    "connected_upper": "CONNECTED",
    "contact_address": "Address",
    "contact_address_detail": "Magstim Inc. \r\nSuite 800, 17200 Medina Road,\r\nPlymouth,\r\nMN 55447",
    "contact_details_feedback": "feedback@magstim.com",
    "contact_email": "Email Us",
    "contact_email_detail": "sales@magstim.com\r\nsupport@magstim.com\r\nfeedback@magstim.com",
    "contact_email_detail_sales": "sales@magstim.com",
    "contact_email_detail_support": "support@magstim.com",
    "contact_email_help": "*Replies will be send to the email address associated with this profile",
    "contact_email_sent": "Your message has been sent, thank you.",
    "contact_map_link": "https://goo.gl/maps/rtNVx1EmDVA18EP87",
    "contact_phone": "Telephone",
    "contact_phone_number": "+1 844-624-7846",
    "contact_send": "Send",
    "contact_web": "Web",
    "contact_web_detail": "https://www.magstim.com/",
    "contact_within_tolerance_count": "Contact Within Tolerance Count",
    "create_combined_treatment_template_confirmation_message": "Treatment has been saved successfully.",
    "create_individual_treatment_template_confirmation_message": "Treatment has been saved successfully.",
    "create_insurance_provider_name_must_be_unique": "Insurance Provider name must be unique",
    "create_organisation_name_must_be_unique": "Organization name must be unique",
    "create_patient_confirmation_message": "Information has been saved successfully.",
    "create_user_all_fields_must_be_completed": "All fields marked with a * must be completed",
    "create_user_email_must_be_unique": "User email must be unique",
    "create_user_error": "Error creating user",
    "date_of_birth_conformation_dob_label": "Date of Birth",
    "date_of_birth_conformation_message": "Please ask your patient to confirm their date of birth, then enter the details below:",
    "date_of_birth_conformation_ok": "OK",
    "date_of_birth_conformation_title": "Date of Birth Confirmation",
    "date_of_birth_error": "Sorry, date of birth incorrect.",
    "date_time_separator": " at ",
    "define_targets_help": "Ensure the coil is at a 45° angle to the mid-line of the head and placed tangential to the curvature of the head",
    "detailed_report_patient_default_title": "Patient Report",
    "detailed_report_patient_heading": "Patient Report : {0}",
    "detailed_report_patient_sub_heading_information": "Patient Information",
    "detailed_report_patient_subject": "Patient {0} - {1}",
    "detailed_report_standard_info_clinic_details": "Clinic Details",
    "detailed_report_standard_info_date_created": "Report created",
    "detailed_report_standard_info_date_range": "Report timeframe",
    "detailed_report_treater_default_title": "Treater Report",
    "detailed_report_treater_heading": "Treater Report : {0}",
    "detailed_report_treater_sub_header_patient": "{0} - {1}",
    "detailed_report_treater_sub_heading_information": "Treater Information",
    "detailed_report_treater_subject": "Treater {0} - {1}",
    "device": "Device",
    "device_accuracy": "Device Accuracy",
    "device_analytics": "Device Analytics",
    "device_analytics_help": "Use the buttons below to view the detailed device analytics for {0}",
    "device_details": "Device Details",
    "device_enforced_wait_time_left": "System can be armed in {0} seconds",
    "device_rmt": "Device rMTs",
    "device_traceability": "Device Traceability",
    "device_treatments": "Device Treatments",
    "device_wait_for_enforced_wait_time": "Please wait until the system can be armed",
    "devices": "Devices",
    "discard_treatment_answer_no": "Cancel",
    "discard_treatment_answer_yes": "Discard",
    "discard_treatment_message": "Are you sure you want to discard this treatment?",
    "discard_treatment_not_allowed_in_combined": "You are unable to delete this individual treatment template while it is used in the following combined treatment templates:\r\n    \r\n{0}\r\n\r\nPlease edit the combined treatment templates to no longer include this individual treatment template and try deleting again.\r\n",
    "discard_treatmentplan_answer_yes": "Confirm",
    "disconnected_upper": "DISCONNECTED",
    "distance_within_tolerance_count": "Distance Within Tolerance Count",
    "download": "Download",
    "download_complete": "{0}% Complete",
    "download_file_count": "{0} of {1}",
    "download_updates": "Downloading Updates...",
    "edit_patient_additional_info": "Additional Information",
    "edit_patient_address_label": "Address",
    "edit_patient_back": "Back",
    "edit_patient_clinical_assessment": "Clinical Assessment Baseline",
    "edit_patient_confirm_cancel": "Any unsaved data will be lost.",
    "edit_patient_contact_number_label": "Contact Number",
    "edit_patient_country_label": "Country",
    "edit_patient_day_label": "DD",
    "edit_patient_diagnosis": "Diagnosis",
    "edit_patient_diagnosis_code_label": "ICD-10 Code Type",
    "edit_patient_dob_name_label": "Date of Birth*",
    "edit_patient_dosage_label": "Dosage",
    "edit_patient_edit_label": "Edit",
    "edit_patient_effective_date_label": "Effective Date",
    "edit_patient_essential_info": "Essential Information (*Required Fields)",
    "edit_patient_ethnicity_label": "Patient Ethnicity",
    "edit_patient_first_name_label": "First Name*",
    "edit_patient_frequency_label": "Frequency",
    "edit_patient_gender_columnname": "Patient Gender",
    "edit_patient_gender_label": "Gender",
    "edit_patient_handedness_label": "Patient Handedness",
    "edit_patient_id_label": "Patient ID*",
    "edit_patient_insurance_provider_label": "Insurance Provider",
    "edit_patient_last_name_label": "Last Name*",
    "edit_patient_managing_physician_label": "Managing Physician",
    "edit_patient_medication_label": "Medication",
    "edit_patient_medication_record": "Medication Record",
    "edit_patient_medications": "Medications",
    "edit_patient_month_label": "MM",
    "edit_patient_next": "Next",
    "edit_patient_notes_label": "General Notes",
    "edit_patient_patient_id_must_be_unique": "Patient ID must be unique",
    "edit_patient_primary_diagnosis_label": "Primary Diagnosis",
    "edit_patient_referring_physician_label": "Referring Physician",
    "edit_patient_required": "required",
    "edit_patient_save_label": "Save",
    "edit_patient_secondary_diagnosis_label": "Secondary Diagnosis",
    "edit_patient_title_label": "Add new or edit patient details (*required fields)",
    "edit_patient_treatment_stage_label": "Treatment Stage",
    "edit_patient_unit_label": "Units",
    "edit_patient_validation_error": "Please correct the following",
    "edit_patient_year_label": "YYYY",
    "edit_patient_zip_label": "Zip",
    "edit_treatment_plan_confirmation_message": "Saved successfully. A new patient treatment plan:\r\n{0}\r\nhas been assigned for\r\n{1} - Patient ID: {2}",
    "edit_treatment_plan_none": "None",
    "edit_treatment_plan_stimguide_required": "StimGuide Required",
    "enum_usertype_magstimadmin": "Magstim Admin",
    "enum_usertype_organisationadmin": "Organization Admin",
    "enum_usertype_organisationuser": "Organization User",
    "error_upper": "ERROR",
    "error_value_reason": "{0} {1}",
    "event_code": "Event Code",
    "event_log": "Event Log",
    "event_message": "Message",
    "event_time": "Date / Time",
    "filter_option_alltime": "All Time",
    "filter_option_last4weeks": "Last 4 Weeks",
    "filter_option_last6months": "Last 6 Months",
    "filter_option_lastyear": "Last Year",
    "frequency_too_high_for_power": "Frequency too high for power",
    "ftu_wizard_cancel_caption": "Any unsaved data will be lost.\r\n    \r\nAre you sure you wish to cancel?",
    "ftu_wizard_cancel_continue": "Continue Setup",
    "ftu_wizard_cancel_shutdown": "Shutdown",
    "full_name": "Full Name",
    "generic_duplicate_property_warning_message": "\"An item with the same {0} already exists. Please try a different {0}.\"",
    "head_tracker_upper": "HEAD TRACKER",
    "help_file_name": "MPS14-US-03.pdf",
    "hide_nav_view": "Hide navigation view",
    "history_details_burst_accuracy": "Average Accuracy",
    "history_details_burst_additionalPulses": "Additional Pulses",
    "history_details_burst_bpc": "Bursts Per Cycle",
    "history_details_burst_cycles": "Total No. of Cycles",
    "history_details_burst_cycleTime": "Cycle Time",
    "history_details_burst_duration": "Treatment Duration",
    "history_details_burst_manualLocation": "Manual Location",
    "history_details_burst_mode": "Mode",
    "history_details_burst_pcRMT": "Treatment %rMT Level",
    "history_details_burst_ppb": "Pulses Per Burst",
    "history_details_burst_pps": "Hz (PPS)",
    "history_details_burst_pulses": "Total No. of Pulses",
    "history_details_burst_stimguideLocation": "StimGuide Location",
    "history_details_standard_accuracy": "Average Accuracy",
    "history_details_standard_additionalPulses": "Additional Pulses",
    "history_details_standard_duration": "Treatment Duration",
    "history_details_standard_manualLocation": "Manual Location",
    "history_details_standard_mode": "Mode",
    "history_details_standard_offTime": "Off Time",
    "history_details_standard_onTime": "On Time",
    "history_details_standard_pcRMT": "Treatment %rMT Level",
    "history_details_standard_pps": "Hz (PPS)",
    "history_details_standard_ppt": "Pulses Per Train",
    "history_details_standard_pulses": "Total No. of Pulses",
    "history_details_standard_stimguideLocation": "StimGuide Location",
    "history_details_standard_trains": "Total No. of Trains",
    "history_details_stimguide_required": "StimGuide Required",
    "home_contact_us": "Contact us",
    "home_patients": "Patients",
    "home_sign_out": "Sign out",
    "home_system": "System",
    "home_treatments": "Treatments",
    "image_upload_help": "jpg or png less than 1MB.",
    "import": "Import",
    "import_export": "Import / Export",
    "import_export_error": "Patient CSV data in unknown / invalid format.\r\n\r\nFor further information on the file format and detailed instructions for importing the data, please consult the Help Documentation, Operating Manual or contact Magstim Support.",
    "import_export_help": "To import pre-existing patient data, please use the Import function.\r\n    \r\nTo export the patient data for download please use the Export function. \r\n\r\nFor further information on the file format and detailed instructions for importing or exporting the data, please consult the Help Documentation, Operating Manual or contact Magstim Support.",
    "include": "Include",
    "include_report_footer": "Include Footer",
    "include_report_header": "Include Header",
    "include_report_image": "Include Image",
    "include_report_title": "Include Title",
    "individual_treatment_not_unique": "The treatment {0} has the same settings",
    "individual_treatment_type_burst": "Burst",
    "individual_treatment_type_standard": "Standard",
    "info_upper": "INFO",
    "insurance_provider": "Insurance Provider",
    "insurance_provider_add": "Add Insurance Provider",
    "insurance_provider_details": "Details",
    "insurance_provider_edit": "Edit Insurance Provider",
    "insurance_provider_name": "Name",
    "insurance_providers": "Insurance Providers",
    "landmark_date": "Created",
    "landmark_delete": "Delete",
    "landmark_delete_message": "Are you sure you want to delete this landmark?",
    "landmark_edit": "Edit",
    "landmark_name": "Name",
    "landmark_none": "None",
    "landmark_show": "Show",
    "landmark_x_pos": "x (mm)",
    "landmark_y_pos": "y (mm)",
    "landmark_z_pos": "z (mm)",
    "landmarks_edit": "Edit Addtional Landmarks",
    "landmarks_manage": "Manage Landmarks",
    "landmarks_to_register": "Landmarks to register",
    "language_english_chinese": "Chinese",
    "language_english_uk": "English (UK)",
    "language_english_us": "English (US)",
    "last_sync_time_message": "Sync last run on {0} at {1}",
    "location": "Location",
    "login_error_invalid": "is invalid",
    "login_error_message": "Details incorrect",
    "login_error_message_permissions": "You do not have the permission to access the device, please contact your system administrator.",
    "login_error_mismatch": "does not match",
    "login_error_required": "is required",
    "login_error_title": "Error",
    "login_error_tooshort": "is too short",
    "login_password": "Password",
    "login_signin": "Sign in",
    "login_tagline": "TMS Therapy",
    "login_username": "Username",
    "logo_too_big_message": "The logo must be less than 1MB. ",
    "marker_upper": "MARKER",
    "max_must_be_more_than_Min": "Max must be more than Min",
    "max_required": "Max value required",
    "max_train_on_time_exceeded": "Max train on time exceeded",
    "medication_add": "Add Medication",
    "message_box_cancel": "Cancel",
    "message_box_done": "Done",
    "message_box_no": "No",
    "message_box_OK": "OK",
    "message_box_yes": "Yes",
    "min_must_be_less_than_max": "Min must be less than Max",
    "min_required": "Min value required",
    "month_1": "January ",
    "month_1_short": "Jan",
    "month_10": "October",
    "month_10_short": "Oct",
    "month_11": "November",
    "month_11_short": "Nov",
    "month_12": "December",
    "month_12_short": "Dec",
    "month_2": "February",
    "month_2_short": "Feb",
    "month_3": "March",
    "month_3_short": "Mar",
    "month_4": "April",
    "month_4_short": "Apr",
    "month_5": "May",
    "month_5_short": "May",
    "month_6": "June",
    "month_6_short": "Jun",
    "month_7": "July",
    "month_7_short": "Jul",
    "month_8": "August",
    "month_8_short": "Aug",
    "month_9": "September",
    "month_9_short": "Sep",
    "more": "more",
    "motor_threshold_exit_close": "Discard and close",
    "motor_threshold_exit_resume": "Resume rMT",
    "motor_threshold_exit_without_save": "Any unsaved data will be lost.\r\n\r\nAre you sure you wish to close?",
    "motor_threshold_help": "Please refer to the Magstim guide to motor threshold assessment for detailed information on how to perform a %rMT assessment safely and effectively.",
    "motor_threshold_info": "rMT Info",
    "motor_threshold_last": "Last Assessment By",
    "motor_threshold_last_date_format": "{0} days ago on {1}",
    "motor_threshold_no_treatment_plan": "Please assign a treatment plan to the patient.",
    "motor_threshold_notes": "Notes",
    "motor_threshold_output": "Output",
    "motor_threshold_previous": "Previous %rMT",
    "motor_threshold_response": "Response",
    "motor_threshold_save_and_close": "Save Output \r\n    & Close",
    "motor_threshold_save_and_treat": "  Save Output & Go \r\n      to Treatment",
    "motor_threshold_sub_tile": "Output Level Adjustment & Counter",
    "motor_threshold_tile": "New Motor Threshold (rMT) Determination",
    "MSG_0001": "Options Menu",
    "MSG_0002": "Single Pulse (MEP)",
    "MSG_0003": "Repetitive Mode",
    "MSG_0004": "Session Mode",
    "MSG_0005": "System",
    "MSG_0006": "File Maintenance",
    "MSG_0007": "Help",
    "MSG_0008": "Quit",
    "MSG_0009": "Single Pulse Mode",
    "MSG_0010": "Power",
    "MSG_0011": "Stimulator",
    "MSG_0012": "Output",
    "MSG_0013": "%rMT",
    "MSG_0014": "Protocol",
    "MSG_0015": "Coil Status",
    "MSG_0016": "System Status",
    "MSG_0017": "Temperature",
    "MSG_0018": "Type",
    "MSG_0019": "STOPPED",
    "MSG_0020": "ARMED",
    "MSG_0021": "READY",
    "MSG_0022": "WAITING",
    "MSG_0023": "Repetitive",
    "MSG_0024": "Session",
    "MSG_0025": "Enhanced",
    "MSG_0026": "File",
    "MSG_0027": "Single Pulse",
    "MSG_0028": "Channel 1",
    "MSG_0029": "Channel 2",
    "MSG_0030": "Time Base",
    "MSG_0031": "A = ",
    "MSG_0032": "Filters",
    "MSG_0033": "2Hz-10kHz",
    "MSG_0034": "20Hz-10kHz",
    "MSG_0035": "Volts/div",
    "MSG_0036": "L1 = ",
    "MSG_0037": "L2 = ",
    "MSG_0038": "Display",
    "MSG_0039": "Both",
    "MSG_0040": "Time Cursors",
    "MSG_0041": "Status",
    "MSG_0042": "Channel 1 Latencies",
    "MSG_0043": "Channel 2 Latencies",
    "MSG_0044": "Amplitude Cursors",
    "MSG_0045": "Trace 1",
    "MSG_0046": "Trace 2",
    "MSG_0047": "ON",
    "MSG_0048": "OFF",
    "MSG_0049": "Repetitive Setup",
    "MSG_0050": "Frequency",
    "MSG_0051": "Duration",
    "MSG_0052": "of Pulses",
    "MSG_0053": "Wait Time",
    "MSG_0054": "of Trains",
    "MSG_0055": "Total Number of Pulses",
    "MSG_0056": "Pulses",
    "MSG_0057": "Number",
    "MSG_0058": "Run Session",
    "MSG_0059": "MEP",
    "MSG_0060": "Number of",
    "MSG_0061": "Complete",
    "MSG_0062": "View",
    "MSG_0063": "Setup",
    "MSG_0064": "Session Setup",
    "MSG_0065": "Line",
    "MSG_0066": "Start Time",
    "MSG_0067": "Scroll Up",
    "MSG_0068": "Delete Line",
    "MSG_0069": "Add/Copy",
    "MSG_0070": "Delete All",
    "MSG_0071": "Scroll Down",
    "MSG_0072": "Session Mode",
    "MSG_0073": "Active Line",
    "MSG_0074": "Traces",
    "MSG_0075": "Scroll Left",
    "MSG_0076": "Scroll Right",
    "MSG_0077": "Back",
    "MSG_0078": "Yes",
    "MSG_0079": "No",
    "MSG_0080": "Shot Number",
    "MSG_0081": "Local Store",
    "MSG_0082": "Memory Card",
    "MSG_0083": "New",
    "MSG_0084": "Open",
    "MSG_0085": "Save",
    "MSG_0086": "Rename",
    "MSG_0087": "Delete",
    "MSG_0088": "Export",
    "MSG_0089": "Import",
    "MSG_0090": "Parameters",
    "MSG_0091": "Details Menu",
    "MSG_0092": "Patient Details",
    "MSG_0093": "ID#:",
    "MSG_0094": "Protocol Description:",
    "MSG_0095": "Name:",
    "MSG_0096": "Sex:",
    "MSG_0097": "Date of Birth:",
    "MSG_0098": "Time",
    "MSG_0099": "Comments:",
    "MSG_0100": "System Options Menu",
    "MSG_0101": "User Configuration",
    "MSG_0102": "System Details",
    "MSG_0103": "System Configuration",
    "MSG_0104": "UI Details",
    "MSG_0105": "POD Details",
    "MSG_0106": "Base Details",
    "MSG_0107": "Coil Details",
    "MSG_0108": "PSU Details",
    "MSG_0109": "Software Number:",
    "MSG_0110": "Hardware Number:",
    "MSG_0111": "Serial Number:",
    "MSG_0112": "Version:",
    "MSG_0113": "Revision:",
    "MSG_0114": "Version",
    "MSG_0115": "Volume",
    "MSG_0116": "Contrast",
    "MSG_0117": "Coil Switch",
    "MSG_0118": "Enter 4 Digit Access Code",
    "MSG_0119": "Clear",
    "MSG_0120": "Enter",
    "MSG_0121": "File:",
    "MSG_0122": "-----",
    "MSG_0123": "Amplitude",
    "MSG_0124": "Cursors",
    "MSG_0125": "Option",
    "MSG_0126": "Session Details",
    "MSG_0127": "Total",
    "MSG_0128": "Trains",
    "MSG_0129": "Train",
    "MSG_0130": "Number",
    "MSG_0131": "Pulses",
    "MSG_0132": "Wait",
    "MSG_0133": "Time",
    "MSG_0134": "Intensity",
    "MSG_0135": "MEP Configuration",
    "MSG_0136": "dt",
    "MSG_0137": "ATTENTION",
    "MSG_0138": "Refer to operating manual before use",
    "MSG_0139": "Service",
    "MSG_0140": "WARNING",
    "MSG_0141": "Coil Rom checksum incorrect",
    "MSG_0142": "Coil EEPROM checksum incorrect",
    "MSG_0143": "Invalid coil category",
    "MSG_0144": "Invalid coil power identification",
    "MSG_0145": "Coil temperature sensor circuit failure",
    "MSG_0146": "Bad communication detected by coil",
    "MSG_0147": "Internal coil software error",
    "MSG_0148": "Invalid coil ID",
    "MSG_0149": "Invalid coil temperature algorithm coefficient",
    "MSG_0150": "Coil controller malfunction",
    "MSG_0151": "Coil disconnected/Coil under temperature",
    "MSG_0152": "Coil brown out detected",
    "MSG_0153": "No serial communications",
    "MSG_0154": "Bad communication detected by coil",
    "MSG_0155": "Coil EMC detected",
    "MSG_0156": "Invalid coil power identification",
    "MSG_0157": "Coil hardware stop activated",
    "MSG_0158": "Coil watchdog timeout",
    "MSG_0159": "Coil temperature 3 interlock activated",
    "MSG_0160": "Coil stop line fault",
    "MSG_0161": "Base powerfail detected",
    "MSG_0162": "Base stack underflow",
    "MSG_0163": "Base stack overflow",
    "MSG_0164": "Base RTS overrun",
    "MSG_0165": "Base watchdog timeout",
    "MSG_0166": "Base unexpected reset detected",
    "MSG_0167": "Base bad ROM checksum",
    "MSG_0168": "Base debug error",
    "MSG_0169": "Coil over temperature, remove from patient",
    "MSG_0170": "Coil under temperature",
    "MSG_0171": "Coil max difference detected",
    "MSG_0172": "Base stack over temperature",
    "MSG_0173": "Base stack under temperature",
    "MSG_0174": "Base stack max difference detected",
    "MSG_0175": "Base HVCAP over temperature",
    "MSG_0176": "Base HV transformer over temperature",
    "MSG_0177": "Base charge threshold failure",
    "MSG_0178": "Base VREF check failure",
    "MSG_0179": "Base HVCAP voltage comparison failure",
    "MSG_0180": "Base charging fault",
    "MSG_0181": "Base HVCAP over voltage",
    "MSG_0182": "Invalid system configuration",
    "MSG_0183": "Base stop line fault",
    "MSG_0184": "Base coil stop line fault",
    "MSG_0185": "UI stop line fault",
    "MSG_0186": "Base dump system fault",
    "MSG_0187": "Invalid coil category for current system configuration",
    "MSG_0188": "Base invalid EEPROM checksum",
    "MSG_0189": "Base faulty charging relay detected",
    "MSG_0190": "Base arm LED drive failure",
    "MSG_0191": "External PSU fault",
    "MSG_0192": "Base over temperature",
    "MSG_0193": "Base snubber board over temperature",
    "MSG_0194": "Base Temperature Outside Limits",
    "MSG_0195": "Base ambient under temperature",
    "MSG_0196": "Base snubber board under temperature",
    "MSG_0197": "ERROR",
    "MSG_0198": "unknown fault",
    "MSG_0199": "2 ms/div",
    "MSG_0200": "5 ms/div",
    "MSG_0201": "10 ms/div",
    "MSG_0202": "20 ms/div",
    "MSG_0203": "50 ms/div",
    "MSG_0204": "50 uV/div",
    "MSG_0205": "100 uV/div",
    "MSG_0206": "200 uV/div",
    "MSG_0207": "500 uV/div",
    "MSG_0208": "1 mV/div",
    "MSG_0209": "2 mV/div",
    "MSG_0210": "5 mV/div",
    "MSG_0211": "10 mV/div",
    "MSG_0212": "Session setup not complete",
    "MSG_0213": "MEP NOT INSTALLED",
    "MSG_0214": "Continue",
    "MSG_0215": "File Store empty",
    "MSG_0216": "Save As",
    "MSG_0217": "View",
    "MSG_0218": "Are you sure you wish to delete patient information ?",
    "MSG_0219": "No file defined !",
    "MSG_0220": "File name edit active !",
    "MSG_0221": "A file is currently open !",
    "MSG_0222": "No more file areas available !",
    "MSG_0223": "A filename must contain at least one character !",
    "MSG_0224": "Are you sure you wish to delete selected file ?",
    "MSG_0225": "Are you sure you wish to overwrite selected file ?",
    "MSG_0226": "Battery",
    "MSG_0227": "Voltage",
    "MSG_0228": "Current",
    "MSG_0229": "Time",
    "MSG_0230": "Date",
    "MSG_0231": "Modify",
    "MSG_0232": "Set Time",
    "MSG_0233": "Date",
    "MSG_0234": "Month",
    "MSG_0235": "Year",
    "MSG_0236": "Hour",
    "MSG_0237": "Minute",
    "MSG_0238": "Second",
    "MSG_0239": "Cancel",
    "MSG_0240": "Line",
    "MSG_0241": "Adaptor",
    "MSG_0242": "Invalid code",
    "MSG_0243": "Ignore the coil switch ?",
    "MSG_0244": "Delete highlighted line ?",
    "MSG_0245": "Delete all session information ?",
    "MSG_0246": "Enter line frequency first",
    "MSG_0247": "No session defined",
    "MSG_0248": "No more lines can be added",
    "MSG_0249": "Option not available",
    "MSG_0250": "Max string length reached",
    "MSG_0251": "Value cannot be changed",
    "MSG_0252": "U34 No communication with base",
    "MSG_0253": "U37 Battery voltage low",
    "MSG_0254": "U35 Loss of communication with base",
    "MSG_0255": "U36 Bad NVRAM checksum",
    "MSG_0256": "U29 ROM checksum incorrect",
    "MSG_0257": "U28 Watchdog timeout",
    "MSG_0258": "U25 Stack underflow",
    "MSG_0259": "U26 Stack overflow",
    "MSG_0260": "U27 RTS overrun",
    "MSG_0261": "U24 UI Power supply failure",
    "MSG_0262": "Contact Info",
    "MSG_0263": "File name already exists",
    "MSG_0264": "Base ambient over temperature",
    "MSG_0265": "Coil too hot to run single train",
    "MSG_0266": "Coil too hot to run more than",
    "MSG_0267": "Window still being edited",
    "MSG_0268": "System ok to run",
    "MSG_0269": "Wait period too short, auto set to minimum ?",
    "MSG_0270": "Page up",
    "MSG_0271": "Page down",
    "MSG_0272": "Top page visible",
    "MSG_0273": "Bottom page visible",
    "MSG_0274": "No more lines",
    "MSG_0275": "Save changes in this window ?",
    "MSG_0276": "Save changes in last window ?",
    "MSG_0277": "Nothing being edited",
    "MSG_0278": "Please wait while new coil is processed",
    "MSG_0279": " train(s)",
    "MSG_0280": "Please wait option still initialising",
    "MSG_0281": "Processing session",
    "MSG_0282": " line(s) of session",
    "MSG_0283": "Wait period too short for line ",
    "MSG_0284": ", auto set to minimum ?",
    "MSG_0285": "Save Session",
    "MSG_0286": "System failed to produce protocol",
    "MSG_0287": "L1",
    "MSG_0288": "L2",
    "MSG_0289": "Resume",
    "MSG_0290": "System not armed",
    "MSG_0291": "Start MEP update",
    "MSG_0292": "Ignore temperature",
    "MSG_0293": "Set coil",
    "MSG_0294": "temperature limit",
    "MSG_0295": "algorithm",
    "MSG_0296": "Close",
    "MSG_0297": "Ignore E80",
    "MSG_0298": "Ignore E98",
    "MSG_0299": "Print",
    "MSG_0300": "No card fitted",
    "MSG_0301": "No Patient files detected",
    "MSG_0302": "Card is write protected",
    "MSG_0303": "File already exists, do you wish to overwrite ?",
    "MSG_0304": "Do you wish to export file as ",
    "MSG_0305": "of Bursts",
    "MSG_0306": "Cycle Time",
    "MSG_0307": "of Cycles",
    "MSG_0308": "Burst Frequency",
    "MSG_0309": "Standard",
    "MSG_0310": "Burst",
    "MSG_0311": "Notes:",
    "MSG_0312": "H/W No:",
    "MSG_0313": "Rev:",
    "MSG_0314": "S/N:",
    "MSG_0315": "Cycle",
    "MSG_0316": "Cycles",
    "MSG_0317": "Printer out of paper",
    "MSG_0318": "Printer level up",
    "MSG_0319": "Printer battery needs recharge",
    "MSG_0320": "Print head too hot, allow to cool",
    "MSG_0321": "Language",
    "MSG_0322": "English",
    "MSG_0323": "French",
    "MSG_0324": "German",
    "MSG_0325": "Spanish",
    "MSG_0326": "Italian",
    "MSG_0327": "Portugese",
    "MSG_0328": "Number of bursts too large, auto set to maximum ?",
    "MSG_0329": "Start flash memory update",
    "MSG_0330": "Flash checksum",
    "MSG_0331": "Erasing",
    "MSG_0332": "Erased",
    "MSG_0333": "Select RED dot and press RED key",
    "MSG_0334": "Re-boot the system to complete screen",
    "MSG_0335": "calibration",
    "MSG_0336": "System file processing limit has been reached on card",
    "MSG_0337": "Please wait, data transfer in progress !",
    "MSG_0338": "No more indexed file names can be generated for this file",
    "MSG_0339": "File date:",
    "MSG_0340": "No MEP data stored in this file",
    "MSG_0341": "No active lines in session setup",
    "MSG_0342": "Resume cancelled print job ?",
    "MSG_0343": "Do you wish to print ",
    "MSG_0344": "Printer communication failure",
    "MSG_0345": "No Printer detected",
    "MSG_0346": " ?",
    "MSG_0347": "Invalid file format detected !",
    "MSG_0348": " ?",
    "MSG_0349": "File already exists, do you wish to overwrite ?",
    "MSG_0350": "No more local store file areas available !",
    "MSG_0351": "U38 Bad external flash checksum detected !",
    "MSG_0352": "No Patient files",
    "MSG_0353": "detected",
    "MSG_0354": "Service Menu",
    "MSG_0355": "System History",
    "MSG_0356": "UI Errors",
    "MSG_0357": "Base Errors",
    "MSG_0358": "Update Device",
    "MSG_0359": "RON #",
    "MSG_0360": "Edit",
    "MSG_0361": "Shot Counter",
    "MSG_0362": "Numerical coil temp",
    "MSG_0363": "Fatal",
    "MSG_0364": "Non-fatal",
    "MSG_0365": "Theta mode",
    "MSG_0366": "Coil start",
    "MSG_0367": "Coil above allowed start temperature",
    "MSG_0368": "Confirm ready to trigger",
    "MSG_0369": "Set Maximum",
    "MSG_0370": "Rapid coil algorithm constant checksum incorrect",
    "MSG_0371": "Invalid enhanced power byte",
    "MSG_0372": "Average power checksum incorrect",
    "MSG_0373": "Erase Local Patient Store",
    "MSG_0374": "Are you sure you wish to erase the local store ?",
    "MSG_0375": " burst(s)",
    "MSG_0376": "Coil too hot to run single burst",
    "MSG_0377": "Cycle period too short, auto set to minimum ?",
    "MSG_0378": "Notch Filter",
    "MSG_0379": "Trace",
    "MSG_0380": "Options",
    "MSG_0381": "MEP Trace Options",
    "MSG_0382": "Auto Peak",
    "MSG_0383": "Upgrade file(s) found on SD card:",
    "MSG_0384": "No upgrade files available on SD card.",
    "MSG_0385": "No SD card present. Please insert SD card and retry.",
    "MSG_0386": "Upgrade complete. Please reboot.",
    "MSG_0387": "Error",
    "MSG_0388": "has occurred during upgrade.",
    "MSG_0389": "Processing file:",
    "MSG_0390": "All upgrade files processed.",
    "MSG_0391": "MEP pod upgrading. Please wait...",
    "MSG_0392": "Trace along blue lines ensuring indicators are within limits.",
    "MSG_0393": "Air Extraction Unit Not Operating Correctly.",
    "MSG_0394": "Charge",
    "MSG_0395": "Delay",
    "MSG_0396": "Charge Delay",
    "MSG_0397": "delay",
    "MSG_0398": "Protocol Presets",
    "MSG_0399": "cTBS",
    "MSG_0400": "iTBS",
    "MSG_0401": "in",
    "MSG_0402": "Pulses per Cycle",
    "MSG_0403": "Coil cooling period is active until",
    "MSG_0404": "Set Coil Cooling",
    "MSG_0405": "Average Power",
    "MSG_0406": "Train Warning",
    "MSG_0407": "Check Maintenance",
    "MSG_0408": "HCI limit reached, Contact your supplier.",
    "MSG_0409": "EPV error, Contact your supplier.",
    "MSG_0410": "EPV limit reached, Contact your supplier.",
    "MSG_0411": "Maintenance overdue, Check Maintenance.",
    "MSG_0412": "EPV: ",
    "MSG_0413": "HCI: ",
    "MSG_0414": "Last Service:",
    "MSG_0415": "Next Service:",
    "MSG_0416": "Jan",
    "MSG_0417": "Feb",
    "MSG_0418": "Mar",
    "MSG_0419": "Apr",
    "MSG_0420": "May",
    "MSG_0421": "Jun",
    "MSG_0422": "Jul",
    "MSG_0423": "Aug",
    "MSG_0424": "Sep",
    "MSG_0425": "Oct",
    "MSG_0426": "Nov",
    "MSG_0427": "Dec",
    "MSG_0428": "Maintenance",
    "MSG_0429": "Maintenance required, Contact your supplier.",
    "MSG_0430": "OK",
    "MSG_0431": "Due Soon",
    "MSG_0432": "Overdue",
    "MSG_0433": "Approaching Limit",
    "MSG_0434": "Exceeded",
    "MSG_0435": "Continue session ?",
    "MSG_0436": "Repetitive Mode (initialising...)",
    "MSG_0437": "Repetitive Mode",
    "MSG_0438": "Repetitive Mode",
    "MSG_0439": "Repetitive Mode",
    "MSG_0440": "Repetitive Mode",
    "MSG_0441": "Repetitive Setup",
    "MSG_0442": "Repetitive Setup",
    "mt_history_list_label": "Motor Threshold Results",
    "navigation_custom_target": "Custom target (x, y, z) ",
    "navigation_custom_target_units": "mm",
    "navigation_settings": "Navigation Settings",
    "navigation_settings_angular_tolerance": "Angular Tolerance",
    "navigation_settings_angular_tolerance_units": "Deg",
    "navigation_settings_contact_tolerance": "Contact Tolerance",
    "navigation_settings_contact_tolerance_units": "mm",
    "navigation_settings_distance_tolerance": "Distance Tolerance",
    "navigation_settings_distance_tolerance_units": "mm",
    "navigation_settings_rotation_tolerance": "Rotation Tolerance",
    "navigation_settings_rotation_tolerance_units": "Degrees",
    "navigation_settings_tilt_tolerance": "Tilt Tolerance",
    "navigation_settings_tilt_tolerance_units": "Degrees",
    "navigation_use_custom_target": "Use custom target",
    "network": "Network",
    "network_settings": "Network Settings",
    "network_settings_check_for_updates": "Check for Updates",
    "network_settings_enable_network": "Enable Network",
    "network_settings_enable_update_checking": "Enable Automatic Update Checking",
    "network_settings_reminder_period": "Automatic Update Reminder Period",
    "network_settings_reminder_period_daily": "Daily",
    "network_settings_reminder_period_monthly": "Monthly",
    "network_settings_reminder_period_weekly": "Weekly",
    "network_settings_start_full_sync": "Start full sync",
    "next": "Next",
    "no": "No",
    "no_data": "-",
    "no_data_words": "No data",
    "not_enough_data_words": "Not enough data",
    "note": "Note",
    "note_add": "Add Note",
    "note_added_by": "Added By",
    "note_created_time": "Created Date",
    "note_edit": "Edit Note",
    "note_note": "Note",
    "note_type": "Type",
    "note_type__diagnosis": "Diagnosis",
    "note_type_clinicalassessment": "Clinical Assessment",
    "note_type_medication": "Medication",
    "note_type_patient": "Patient",
    "note_type_treatment": "Treatment",
    "notes": "Notes",
    "number_of_users": "No. of Users",
    "ocd_warning_text_mdd": "MDD",
    "ocd_warning_text_ocd": "OCD",
    "ocd_warning_title": "Please select the type of target you wish to create.",
    "off": "Off",
    "on": "On",
    "organisation": "Organization",
    "organisation_accuracy": "Organization Accuracy",
    "organisation_add": "Add Organization",
    "organisation_analytics": "Organization Analytics",
    "organisation_analytics_help": "Use the buttons below to view the detailed organization analytics for ",
    "organisation_api_permission_denied": "Organization does not have permission to access this service. Please contact Magstim to gain access to additional services.",
    "organisation_assessments": "Organisation Assessments",
    "organisation_edit": "Edit Organization",
    "organisation_max_clinics": "Max Number of Clinics",
    "organisation_max_user_count_exceeded": "Organization has reached it's user limit, please contact Magstim.",
    "organisation_max_user_count_too_small": "Organization already has more users than the specified maximum.",
    "organisation_max_users": "Max Number of Users",
    "organisation_max_users_much_be_a_positive_number": "You must specify a whole number greater than 1",
    "organisation_name": "Organization Name",
    "organisation_rmt": "Organization rMTs",
    "organisation_role_api_pdm": "PDM Permission",
    "organisation_role_api_reporting": "Analytics Permission",
    "organisation_role_api_sync": "Sync Permission",
    "organisation_treatments": "Organization Treatments",
    "organisation_with_no_admins_error": "Archiving this item will result in the parent Organization not having any administrators.",
    "organisation_with_no_clinics_error": "Archiving this clinic will result in the parent Organization not having any clinics.",
    "organisations": "Organizations",
    "password_reset_no": "Cancel",
    "password_reset_success": "You will receive an email with instructions on how to reset your password in a few minutes.",
    "password_reset_title": "",
    "password_reset_warning": "Are you sure you want to reset the password for the following user?",
    "password_reset_yes": "Reset",
    "patient_accuracy": "Patient Accuracy",
    "patient_analytics": "Patient Analytics",
    "patient_analytics_help": "Use the buttons below to view the detailed patient analytics for {0}",
    "patient_assessments": "Patient Assessments",
    "patient_clinic": "Clinic",
    "patient_clinical_assessment_history": "Clinical Assessment History",
    "patient_clinical_assessment_history_chart": "Clinical Assessments Graph",
    "patient_clinical_assessment_history_table": "Clinical Assessments History",
    "patient_clinical_ratings__history": "Clinical Ratings History",
    "patient_full_name": "Patient Full Name",
    "patient_graph": "Graph",
    "patient_history": "History",
    "patient_history_plan_title": "Treatment Plan",
    "patient_home_archive": "Archive",
    "patient_home_assign_treatment_plan": "Assign Treatment Plan",
    "patient_home_created_by": "Created By",
    "patient_home_current_mt": "Current rMT Level",
    "patient_home_current_plan": "Current Plan",
    "patient_home_current_treatment_stage": "Current Treatment Stage",
    "patient_home_date_of_birth": "Date of Birth",
    "patient_home_date_time_created": "Date/time Created",
    "patient_home_edit_treatment_plan": "Edit Treatment Plan",
    "patient_home_first_name": "First Name",
    "patient_home_general_notes": "General Notes:",
    "patient_home_last_edited": "Last Edited",
    "patient_home_last_mt": "Last rMT Determination",
    "patient_home_last_name": "Last Name",
    "patient_home_last_treated": "Last Treated",
    "patient_home_last_treated_by": "Last Treated By",
    "patient_home_last_treatment": "Last Treatment",
    "patient_home_last_treatment_by": "Last Treatment By",
    "patient_home_mt_history": "rMT History",
    "patient_home_mt_history_chart": "rMT History Chart",
    "patient_home_mt_history_summary": "rMT History Summary",
    "patient_home_new_mt": "New rMT Determination",
    "patient_home_new_treatment_plan": "New Treatment Plan",
    "patient_home_no_plan_assigned": "No plan assigned",
    "patient_home_no_plan_assigned_instructions": "Assign a plan by selecting the assign treatment plan button below.",
    "patient_home_overview": "Overview",
    "patient_home_overview_details": "General Patient Details",
    "patient_home_overview_notes": "Latest Treatment Notes",
    "patient_home_overview_results": "Latest Treatment Results",
    "patient_home_overview_summary": "Treatment Plan Summary",
    "patient_home_patient_id": "Patient ID",
    "patient_home_run_treatment": "Run Treatment",
    "patient_home_search_hint": "Search-as-you-type patient first name, last name or patient ID.",
    "patient_home_search_hint_magstim_admin": "Search-as-you-type patient organisation or clinic.",
    "patient_home_treatment_archive": "Treatment History",
    "patient_home_treatment_center": "Treatment Center",
    "patient_home_treatment_history": "Treatment Plan",
    "patient_home_treatment_plan_and_history": "Treatment Plan/History",
    "patient_home_treatments_completed": "Treatments Completed",
    "patient_imported": "Success 1 Patient Imported",
    "patient_information": "Patient Information",
    "patient_list_grouping_last_treated_last_month": "Last Month",
    "patient_list_grouping_last_treated_last_week": "Last Week",
    "patient_list_grouping_last_treated_older": "Older",
    "patient_list_grouping_last_treated_this_month": "This Month",
    "patient_list_grouping_last_treated_this_week": "This Week",
    "patient_list_grouping_last_treated_this_year": "This Year",
    "patient_list_grouping_last_treated_today": "Today",
    "patient_list_grouping_last_treated_yesterday": "Yesterday",
    "patient_medication_history": "Medication History",
    "patient_note_history": "Notes History",
    "patient_organisation": "Organization",
    "patient_overview": "Overview",
    "patient_progress": "Patient Progress",
    "patient_reports": "Patient Reports",
    "patient_rmt": "Patient rMT",
    "patient_search_list_label": "Patient List",
    "patient_search_new_patient": "New Patient",
    "patient_search_placeholder": "Search for Patient ID, First Name and Last Name.",
    "patient_search_research_mode": "Research Mode",
    "patient_search_title": "Add new patient, or search patient profile to setup or start treatment",
    "patient_status": "Status",
    "patient_status_active": "Active",
    "patient_status_all": "All",
    "patient_status_archived": "Archived",
    "patient_timeline": "Timeline",
    "patient_treatment_overview": "Treatment Overview",
    "patient_treatments": "Patient Treatments",
    "patients_imported": "Success {0} Patients Imported",
    "pdm_account_archived": "This account is archived please contact your Organization administrator.",
    "pdm_account_archived_magstim": "This account is archived please contact your Magstim administrator.",
    "physician": "Physician",
    "physician_add": "Add Physician",
    "physician_edit": "Edit Physician",
    "physician_email": "Email",
    "physician_type": "Type",
    "physician_type_both": "Managing and Referring",
    "physician_type_managing": "Managing",
    "physician_type_referring": "Referring",
    "physicians": "Physicians",
    "plus": "plus",
    "protocol_history_details_header": "Protocol Detail",
    "protocol_mode_burst": "Burst repetitive",
    "protocol_mode_standard": "Standard repetitive",
    "protocol_name": "Protocol Name",
    "protocol_section_column_name_intensity": "Intensity",
    "protocol_section_column_name_is_additional": "",
    "protocol_section_column_name_percent_rmt": "% rMT",
    "protocol_section_column_name_pulses": "Pulses",
    "protocol_section_column_name_time_period": "Time Period",
    "protocol_section_column_name_within_tolerance": "Within Tolerance",
    "protocol_template_itbs": "iTBS",
    "protocol_template_ocd": "OCD",
    "protocol_template_rtms_lower": "rTMS Lower inter-train interval",
    "protocol_template_rtms_upper": "rTMS Upper inter-train interval",
    "protocol_templates_not_found": "All protocol templates not found",
    "protocols": "Protocols",
    "rating_scale_bdi": "BDI-II",
    "rating_scale_bdi_self_assessed": "BDI-II (Self)",
    "rating_scale_cesd": "CES-D",
    "rating_scale_cesd_self_assessed": "CES-D (Self)",
    "rating_scale_csdd": "CSDD",
    "rating_scale_csdd_self_assessed": "CSDD (Self)",
    "rating_scale_gad7": "GAD-7",
    "rating_scale_gad7_self_assessed": "GAD-7 (Self)",
    "rating_scale_gds15": "GDS-15",
    "rating_scale_gds15_self_assessed": "GDS-15 (Self)",
    "rating_scale_gds4": "GDS-4",
    "rating_scale_gds4_self_assessed": "GDS-4 (Self)",
    "rating_scale_hads": "HADS",
    "rating_scale_hads_anxiety": "HADS Anxiety",
    "rating_scale_hads_anxiety_self_assessed": "HADS Anxiety (Self)",
    "rating_scale_hads_depression": "HADS Depression",
    "rating_scale_hads_depression_self_assessed": "HADS Depression (Self)",
    "rating_scale_hads_self_assessed": "HADS (Self)",
    "rating_scale_hamd": "HAM-D",
    "rating_scale_hamd_self_assessed": "HAM-D (Self)",
    "rating_scale_idssr": "IDS-SR",
    "rating_scale_idssr_self_assessed": "IDS-SR (Self)",
    "rating_scale_madrs": "MADRS",
    "rating_scale_madrs_self_assessed": "MADRS (Self)",
    "rating_scale_phq9": "PHQ-9",
    "rating_scale_phq9_self_assessed": "PHQ-9 (Self)",
    "rating_scale_qids": "QIDS",
    "rating_scale_qids_self_assessed": "QIDS (Self)",
    "rating_scale_ybocs": "Y-BOCS",
    "rating_scale_ybocs_self_assessed": "Y-BOCS (Self)",
    "rating_scale_zungsds": "Zung SDS",
    "rating_scale_zungsds_self_assessed": "Zung SDS (Self)",
    "redefine_treatment_target": "Redefine Treatment Target",
    "redefine_treatment_target_warning": "Are you sure you want to use the current coil position as the treatment target?",
    "register_landmark_warning_message": "Please ensure both the head trackers and the markers are detected",
    "register_landmark_warning_title": "Cannot Register Landmark",
    "register_landmarks_close_message": "Discard and Close?",
    "register_landmarks_discard": "Discard and Close",
    "register_landmarks_resume": "Resume",
    "remaining_pulses": "Remaining Pulses:",
    "remaining_time": "Remaining time",
    "report": "Report",
    "report_builder": "Report Builder",
    "report_column_header_motor_thresholds_assessed_by": "Assessed By",
    "report_column_header_motor_thresholds_assessed_by_email": "E-mail",
    "report_column_header_motor_thresholds_assessed_date": "Date",
    "report_column_header_motor_thresholds_level": "rMT Level",
    "report_column_header_motor_thresholds_patient_full_name": "Patient Name",
    "report_column_header_motor_thresholds_patient_id_num": "Patient ID",
    "report_column_header_treatment_assessed_by": "Assessed By",
    "report_column_header_treatment_assessed_by_email": "E-mail",
    "report_column_header_treatment_assessed_date": "Date",
    "report_download": "Download Progress Report",
    "report_email": "eMail",
    "report_footer": "Report Footer",
    "report_header": "Report Header",
    "report_image": "Image",
    "report_logo": "Report Logo",
    "report_patient_clinical_assessment_baseline": "Baseline",
    "report_patient_clinical_assessment_date": "Date",
    "report_patient_clinical_assessment_performed_by": "Performed By",
    "report_patient_clinical_assessment_post_treatment": "Post-Treatment",
    "report_patient_clinical_assessment_rating": "Rating",
    "report_patient_clinical_assessment_scale": "Scale",
    "report_patient_clinical_assessment_table_title": "Progress Table - {0}",
    "report_patient_heading": "{0} - Treatment Report",
    "report_patient_protocol_template_duration_data": "{0}m{1:D2}s",
    "report_patient_protocol_template_frequency": "Frequency",
    "report_patient_protocol_template_frequency_data": "{0}Hz",
    "report_patient_protocol_template_location": "Location",
    "report_patient_protocol_template_number_of_trains": "Number of Trains",
    "report_patient_protocol_template_rmt_data": "{0}%",
    "report_patient_sub_heading_patient_information": "Patient Information",
    "report_patient_sub_heading_patient_progress": "Patient Progress",
    "report_patient_sub_heading_treatment_plan_summary": "Treatment Plan Summary / {0} - {1}",
    "report_patient_sub_heading_treatment_plan_summary_no_treatment": "Treatment Plan Summary",
    "report_patient_subject": "Patient {0} - {1}",
    "report_patient_title": "Treatment Report",
    "report_preview": "Preview",
    "report_section_assessments_title": "Clinical Assessments",
    "report_section_motor_thresholds_title": "Motor Thresholds",
    "report_section_treatment_title": "Treatments",
    "report_sections": "Sections",
    "report_template": "Template",
    "report_template_all": "Full Report",
    "report_template_assessment": "Assessment Report",
    "report_template_rmt": "rMT Report",
    "report_template_treatments": "Treatment Report",
    "report_time_frame": "Timeframe",
    "report_title": "Report Title",
    "rmt_add_additional_treatment_targets": "Save and add additional",
    "rmt_analytics": "rMT Analytics",
    "rmt_chart_no_data": "Chart will show when at least 2 MT determinations have been carried out.",
    "rmt_continue_to_add": "Target saved. Please continue to add a new target",
    "rmt_distance": "Distance",
    "rmt_distance_to_plane": "Distance to plane",
    "rmt_info_accuracy": "Accuracy",
    "rmt_info_date": "Date",
    "rmt_info_level": "Level",
    "rmt_info_position": "Position",
    "rmt_info_position_x": "px",
    "rmt_info_position_y": "py",
    "rmt_info_position_z": "pz",
    "rmt_info_rotation": "Rotation",
    "rmt_info_rotation_w": "rw",
    "rmt_info_rotation_x": "rx",
    "rmt_info_rotation_y": "ry",
    "rmt_info_rotation_z": "rz",
    "rmt_location": "Location",
    "rmt_location_guide": "Location Guide",
    "rmt_must_be_greater_than": "rMT must be greater than or equal to",
    "rmt_must_be_less_than": "rMT must be less than or equal to",
    "rmt_pulse_list_intensity": "Intensity",
    "rmt_pulse_list_peak_to_peak": "Peak to peak",
    "rmt_pulse_list_register": "Register",
    "rmt_pulse_list_response": "Response",
    "rmt_pulse_list_stim": "Stim",
    "rmt_pulse_list_time": "Time",
    "rmt_save_treatment_targets": "Save and close",
    "rmt_select_pulase": "Please Select a Pulse",
    "rmt_select_target": "Please register treatment target",
    "rmt_settings": "rMT Settings",
    "rmt_settings_charge_delay": "Charge delay",
    "rmt_settings_mt_hotspot_target_name": "MT hotspot target name",
    "rmt_settings_please_enter_the_details_below:": "Please enter the details below:",
    "rmt_settings_selected_scalp_landmark": "Selected scalp landmark",
    "rmt_settings_target_name": "Target name",
    "rmt_settings_tms_location_guide": "TMS location guide",
    "rmt_stimulation": "Stimulation",
    "role_admin": "Admin",
    "role_user": "User",
    "rotation_within_tolerance_count": "Rotation Within Tolerance Count",
    "route_admin": "Admin",
    "route_contact": "Contact Us",
    "route_patient_search": "Patient Search",
    "route_treatments_plans": "Treatment Plans",
    "run_treatment": "Run treatment",
    "run_treatment_location_change_message": "The next individual treatment is in location:\r\n    \r\n{0}\r\n\r\nPlease re-position your coil, then confirm when ready.",
    "run_treatment_location_change_message_title": "Change of location",
    "run_treatment_plan_combined": "Combined",
    "run_treatment_plan_controls_intensity": "Intensity",
    "run_treatment_plan_controls_latest_mt_level": "Latest rMT Level",
    "run_treatment_plan_controls_percent_mt": "% rMT",
    "run_treatment_plan_controls_title": "{0} controls",
    "run_treatment_plan_detail_title": "{0} detail",
    "run_treatment_plan_details_additional_pulses": "Additional pulses",
    "run_treatment_plan_details_average_accuracy": "Average accuracy",
    "run_treatment_plan_details_burst_per_second": "Bursts per second",
    "run_treatment_plan_details_bursts_per_cycle": "Bursts per cycle",
    "run_treatment_plan_details_cycle_time": "Cycle time",
    "run_treatment_plan_details_manual_location": "Manual Location",
    "run_treatment_plan_details_mode": "Mode",
    "run_treatment_plan_details_off_time": "Off time",
    "run_treatment_plan_details_on_time": "On time",
    "run_treatment_plan_details_percent_mt_level": "Treatment % rMT Level",
    "run_treatment_plan_details_pulses_per_burst": "Pulses per burst",
    "run_treatment_plan_details_pulses_per_second": "Pulses per second",
    "run_treatment_plan_details_pulses_per_train": "Pulses per train",
    "run_treatment_plan_details_stimguide_location": "Stimguide Location",
    "run_treatment_plan_details_total_duration": "Treatment duration",
    "run_treatment_plan_details_total_pulses": "Total no. of pulses",
    "run_treatment_plan_details_total_trains": "Total no. of trains",
    "run_treatment_plan_done": "End treatment & save data",
    "run_treatment_plan_individual": "Individual",
    "run_treatment_plan_next_treatment": "Next treatment",
    "run_treatment_plan_results_tab_notes": "Notes",
    "run_treatment_plan_results_tab_score": "Score",
    "run_treatment_plan_results_tab_score_additional_pulses": "additional pulses delivered.",
    "run_treatment_plan_results_tab_score_message_average": "Average pulses delivered within preset tolerance.",
    "run_treatment_plan_results_tab_score_message_count": "pulses may not have been delivered within tolerance.",
    "run_treatment_plan_results_tab_summary": "Summary",
    "run_treatment_plan_results_tab_summary_state_abandoned": "X",
    "run_treatment_plan_results_tab_summary_state_additional": "+",
    "run_treatment_plan_results_tab_summary_state_normal": "",
    "run_treatment_plan_results_title": "{0} results",
    "run_treatment_plan_schedule_prescription_message": "Prescribed {0} treatments of:",
    "run_treatment_plan_schedule_progress_message": "This treatment: {0} of {1}",
    "run_treatment_plan_schedule_timeline_label_results": "{0} treatment results",
    "run_treatment_plan_schedule_timeline_label_results_burst": "Burst {0} treatment results",
    "run_treatment_plan_schedule_timeline_label_results_standard": "Standard {0} treatment results",
    "run_treatment_plan_schedule_timeline_label_treatment_burst": "Burst {0} treatment",
    "run_treatment_plan_schedule_timeline_label_treatment_standard": "Standard {0} treatment",
    "run_treatment_plan_schedule_timeline_number_results": "{0}b",
    "run_treatment_plan_schedule_timeline_number_treatment": "{0}a",
    "run_treatment_plan_schedule_title": "Schedule",
    "run_treatment_plan_title": "Running {0}",
    "run_treatment_plan_treatment": "Treatment",
    "running_upper": "RUNNING",
    "search": "Search",
    "search_analytics_help": "Select the type of analytics you want to run on the {0} selected:",
    "search_placeholder": "Search-as-you-type {0}",
    "search_select_help": "Please select at least one {0} from the table.",
    "search_select_help_single": "Please select one {0} from the table.",
    "search_title": "{0} Search",
    "set_contact_offset": "Set contact offset",
    "set_contect_offset_warning_message": "Please ensure both the head trackers and the coil are detected",
    "set_contect_offset_warning_title": "Cannot set contact offset",
    "set_cz": "Set Cz",
    "set_left_preauricular": "Set left preauricular",
    "set_nasion": "Set nasion",
    "set_right_preauricular": "Set right preauricular",
    "setting_hci": "HCI %",
    "settings_admin_password_incorrect": "Admin password incorrect",
    "settings_app_version": "Application Software",
    "settings_audible_indicator": "Enable Tolerance Audio Indicator",
    "settings_date": "Date",
    "settings_epv": "EPV %",
    "settings_epv_status": "EPV Status",
    "settings_hardware_no": "Hardware no.",
    "settings_hci_status": "HCI Status",
    "settings_language": "Language",
    "settings_last_service": "Last service date",
    "settings_locale": "Locale",
    "settings_next_service": "Next service date",
    "settings_proc_mon_version": "Process Monitor Software",
    "settings_revision_no": "Revision no.",
    "settings_serial_number": "Serial Number",
    "settings_service_status": "Service status",
    "settings_software_no": "Software no.",
    "settings_stimguide_version": "StimGuide Version",
    "settings_time": "Time",
    "settings_timezone": "Timezone",
    "settings_train_warning": "Train Warning",
    "settings_user_password_incorrect": "User password is incorrect",
    "settings_version_no": "Version no.",
    "settings_volume": "Volume",
    "settings_windows_sn": "Serial Number",
    "settings_windows_update_version": "Windows Update",
    "settings_windows_version": "Platform Software",
    "show_nav_view": "Show navigation view",
    "sign_out": "Sign Out",
    "signout_warning_message": "You will be signed out in",
    "signout_warning_units": "seconds",
    "software_date": "Date",
    "software_history": "Version History",
    "software_update": "Software Update",
    "status_active": "Active",
    "status_archived": "Archived",
    "status_inactive": "Inactive",
    "status_parentarchived": "Parent Archived",
    "status_upper": "STATUS",
    "stimguide_disconnected": "Stimguide is disconnected are you sure you want to continue?",
    "stimguide_disconnected_no": "No",
    "stimguide_disconnected_yes": "Yes",
    "stimguide_landmark_reuse_generate_new": "Generate new",
    "stimguide_landmark_reuse_text": "Existing landmark is less than {0} hours old.\r\n    \r\nDo you wish to reuse this landmark or generate a new one?",
    "stimguide_landmark_reuse_use_existing": "Use existing",
    "stimuli_within_tolerance_count": "Stimuli Within Tolerance Count",
    "stopped_upper": "STOPPED",
    "success": "Success",
    "support_email_body": "Support request from - {0}\r\n\r\n-------------------\r\n\r\n{1}",
    "support_email_title": "Support Request from Magstim PDM v{0}",
    "sync_hardware_issue_reporting_mail_template_id": "d-3e12de1d52e34cfc8b04949aa9ec0891",
    "syncing_data": "Syncing data...",
    "syncing_data_cancelled": "Syncing data cancelled",
    "syncing_data_completed": "Syncing data completed",
    "syncing_data_error": "Error syncing {0}",
    "syncing_data_stopping": "Syncing data stopping...",
    "system_av_settings": "Audio Settings",
    "system_base_info": "Base Info",
    "system_cloud": "Cloud",
    "system_coil_info": "Coil Info",
    "system_com_port_settings": "COM Port Settings",
    "system_com_port_settings_label": "Device COM Port",
    "system_com_port_settings_reboot_label": "Please restart the application for the COM port setting to take effect.",
    "system_date_and_time": "Date and Time",
    "system_hardware_info": "Hardware Info",
    "system_help": "Help",
    "system_laguage_settings": "Language Settings",
    "system_pc_info": "PC Info",
    "system_psu_info": "PSU Info",
    "system_report_template": "Report Template",
    "system_security": "Security and Login Info",
    "system_system_info": "System Info",
    "system_user_info": "User Info",
    "system_user_information": "User Info",
    "systemuser_api_permission_denied": "System user does not have permission to access this service. Please contact Magstim to gain access to additional services.",
    "table_export_message": "Data exported to {0}",
    "table_export_no_drive_message": "No removable drive detected. Please connect one.",
    "table_export_title": "Export",
    "table_group_name_value": "{0} - {1}",
    "target_trype": "Target Type",
    "tilt_within_tolerance_count": "Tilt Within Tolerance Count",
    "tms_location_guide": "TMS location guide",
    "toggle_nav_view": "Toggle navigation view",
    "treater": "Treater",
    "treater_accuracy": "Treater Accuracy",
    "treater_analytics": "Treater Analytics",
    "treater_analytics_help": "Use the buttons below to view the detailed treater analytics for {0}",
    "treater_assessments": "Treater Assessments",
    "treater_full_name": "Treater Full Name",
    "treater_reports": "Treater Reports",
    "treater_rmt": "Treater rMT",
    "treater_search": "Treater Search",
    "treater_search_analytics_help": "Select the type of analytics you want to run on the treaters selected:",
    "treater_search_select_help": "Please select at least one treater from the table.",
    "treaters": "Treaters",
    "treatment_analytics": "Treatment Analytics",
    "treatment_archive_title": "Treatment Archive",
    "treatment_cancel_message": "The treatment is incomplete, are you sure you want to stop",
    "treatment_cancel_message_error": "Stimulator connection lost. Would you like to attempt to continue?",
    "treatment_cancel_no": "Stop & close",
    "treatment_cancel_title": "Cancel treatment?",
    "treatment_cancel_title_error": "Device Error - Connection Lost",
    "treatment_cancel_yes": "Resume treatment",
    "treatment_canceled_default_note": "Treatment canceled by user",
    "treatment_canceled_no_note_error": "A reason must be entered",
    "treatment_combined_treatment_templates": "Combined treatment templates",
    "treatment_details_millisecounds": "{0}ms",
    "treatment_details_mins_and_seconds": "{0}m{1}s",
    "treatment_details_number_of_pulses": "{0:###0.#}% of pulses ({1} pulses)",
    "treatment_details_power_output": "{0:###0.#}% power output",
    "treatment_details_rmt_level": "{0:###0.#}% rMT ({1:###0.#}% output)",
    "treatment_details_seconds": "{0:.##}s",
    "treatment_details_time_used": "{0}m{1}s out of {2}m{3}s",
    "treatment_edit_combined_summary": "Summary",
    "treatment_edit_combined_title": "Create New or Edit Combined Treatment",
    "treatment_edit_combined_treatment_name": "Treatment Name",
    "treatment_edit_combined_treatment_name_required": "Treatment Name*",
    "treatment_edit_number_of_treatment_label": "Total No. of Treatments",
    "treatment_edit_plan_name_label": "Plan Name*",
    "treatment_edit_plan_name_placeholder": "Plan Name",
    "treatment_edit_plan_summary": "Plan Summary",
    "treatment_failed_to_validate_messaage": "The system cannot deliver the specified protocol with the connected coil. Please either replace the connect coil or edit the protocol.",
    "treatment_failed_to_validate_no": "Replace coil",
    "treatment_failed_to_validate_title": "Failed to validate protocol",
    "treatment_failed_to_validate_yes": "Edit protocol",
    "treatment_history_all_treaters": "All Treaters",
    "treatment_history_changes_header": "Changes During Treatment History",
    "treatment_history_date_allTime": "All Time",
    "treatment_history_date_lastMonths12": "Last Year",
    "treatment_history_date_lastMonths6": "Last 6 Months",
    "treatment_history_date_lastWeeks4": "Last 4 Weeks",
    "treatment_history_details_header": "Treatment Detail",
    "treatment_history_details_title": "Treatment History",
    "treatment_history_table_columnname_completed": "Completed",
    "treatment_history_table_columnname_date": "Date",
    "treatment_history_table_columnname_individualTreatment": "Treatment",
    "treatment_history_table_columnname_performedBy": "Performed by",
    "treatment_history_table_columnname_planName": "Plan Name",
    "treatment_history_table_columnname_totalPulses": "Pulses Delivered",
    "treatment_history_table_device_guid": "Device Guid",
    "treatment_history_table_managing_physician_email": "Managing Physician Email",
    "treatment_history_table_managing_physician_guid": "Managing Physician Guid",
    "treatment_history_table_managing_physician_name": "Managing Physician Name",
    "treatment_history_table_referring_physician_email": "Referring Physician Email",
    "treatment_history_table_referring_physician_guid": "Referring Physician Guid",
    "treatment_history_table_referring_physician_name": "Referring Physician Name",
    "treatment_history_title": "Treatment History",
    "treatment_history_unassign_plan": "Unassign Plan",
    "treatment_history_unassign_plan_confirm_message": "Are you sure you wish to end treatment plan {0}?",
    "treatment_individual_treatment_templates": "Individual treatment templates",
    "treatment_modified_warning": "Note: Parameters modified by the system are highlighted",
    "treatment_name_no_unique": "A combined treatment with that name already exists ",
    "treatment_new_combined": "New combined",
    "treatment_new_individual": "New individual",
    "treatment_no_name_error": "Please enter a name",
    "treatment_no_treatments": "A combined treatment must contain at least 2 treatments",
    "treatment_notes_enter_additional": "Please enter any additional treatment notes",
    "treatment_notes_modify": "Modify Treatment Notes",
    "treatment_plan_edit_title": "Build or Edit Patient Treatment Plan",
    "treatment_resume_message": "The system will disarm in {0} seconds.",
    "treatment_resume_no": "Restart",
    "treatment_resume_title": "Do you wish to resume treatment?",
    "treatment_resume_yes": "Resume",
    "treatment_score_dialog_add_trains": "Add no. of trains",
    "treatment_score_dialog_report_1": "{0:###0.#}%",
    "treatment_score_dialog_report_2": "Pulses delivered within preset tolerance.",
    "treatment_score_dialog_report_3": "pulses may not have been delivered within tolerance.",
    "treatment_score_dialog_title": "Treatment score",
    "treatment_score_dialog_total_pulses": "Total no. of pulses",
    "treatment_settings": "Treatment Settings",
    "treatment_stage_completion": "Primary Plan (Completion)",
    "treatment_stage_initial": "Primary Plan (Initial)",
    "treatment_stage_maintenance": "Maintenance",
    "treatment_summary_card_duration": "Duration",
    "treatment_summary_card_mode": "Mode",
    "treatment_summary_card_pcRMT": "%rMT",
    "treatment_summary_card_pps": "Hz (PPS)",
    "treatment_summary_card_pulses": "Pulses",
    "treatment_summary_manual_location": "Manual Location",
    "treatment_summary_stimguide_location": "StimGuide Location",
    "treatment_target_settings": "Treatment Target Settings",
    "treatment_template_not_found": "Treatment template not found",
    "treatment_templates": "Treatment Templates",
    "treatment_warning": "Select a treatment template below. Notice: The safety and effectiveness of rTMS has only been established using the treatment templates labeled \"FDA\" during a controlled clinical study. The safety and efficacy of all other stimulation protocols have not been established.",
    "update_accept": "Accept",
    "update_decline": "Decline",
    "update_password_error": "Error updating password",
    "update_password_ok_message": "Password has been reset",
    "update_password_ok_title": "Success",
    "update_updates_changelog": "Changelog",
    "update_updates_title": "The following updates are available for the system",
    "updates_confirm": "Are you sure you want to apply the updates?",
    "updates_confirm_cancel": "Are you sure you wish to decline updates?",
    "updates_confirm_cancel_no": "Continue",
    "updates_confirm_cancel_yes": "Decline",
    "updates_confirm_no": "No",
    "updates_confirm_yes": "Update",
    "updates_critical": "(Critical)",
    "updates_error_downloading_updates": "There was an error downloading the updates, please try again later.",
    "updates_error_getting_updates": "There was an error getting the update information, please try again later.",
    "updates_help_1": "Choosing to accept will initiate the update progress",
    "updates_help_2": "Choosing decline will close the software update dialog with the software remaining unchanged",
    "updates_no_updates": "Your system is up to date. ",
    "updates_no_updates_title": "No updates",
    "updates_the_update_will_now_start": "The application will now close and start the updates. The system may restart several times. ",
    "updates_time_of_next_check": "Updates last checked on {0} at {1}, next check on first login after {2} on {3}",
    "upload": "Upload",
    "user": "User",
    "user_add": "Add User",
    "user_edit": "Edit User",
    "user_first_name": "First Name",
    "user_last_name": "Last Name",
    "user_roles": "Roles",
    "user_type": "User Type",
    "user_user_name": "Email",
    "userprofile_edit_details": "Edit User Details",
    "userprofile_enter_details": "Enter User Details",
    "users": "Users",
    "users_no_access": "You do not have the permission to add users, please contact your system administrator.",
    "users_offline_message": "A network connection is required to view and edit users.",
    "users_role_admin": "Admin",
    "users_role_normal": "Normal",
    "usersecurity_edituser": "Edit User Details",
    "usersecurity_newuser": "New User",
    "usersecurity_resetuser": "Reset User Password",
    "usersecurity_selectuser": "Select User",
    "usersettings_login_title": "Security and login information",
    "validating_session": "Validating session...",
    "validation_please_wait": "Please wait...",
    "validation_required": "Required",
    "validation_save": "Save",
    "validation_star": "*",
    "validation_too_large": "Too Large",
    "validation_too_long": "Too Long",
    "validation_too_short": "Too Short",
    "validation_too_small": "Too Small",
    "value_entry_warning": "{0} must be more than {1} and less than {2}",
    "version_new": "To",
    "version_old": "From",
    "view_individual_treatment_burst_bursts_per_cycle": "Bursts per Cycle",
    "view_individual_treatment_burst_bursts_per_second": "Bursts per Second",
    "view_individual_treatment_burst_cycle_time": "Cycle Time (s)",
    "view_individual_treatment_burst_percentage_of_rmt": "% Resting rMT",
    "view_individual_treatment_burst_pulses_per_burst": "Pulses per Burst",
    "view_individual_treatment_burst_pulses_per_second": "Pulses per Second",
    "view_individual_treatment_burst_total_cycles": "Total No. of Cycles",
    "view_individual_treatment_burst_total_duration": "Total Duration",
    "view_individual_treatment_burst_total_pulses": "Total No. of Pulses",
    "view_individual_treatment_standard_off_time": "Off Time",
    "view_individual_treatment_standard_on_time": "On Time",
    "view_individual_treatment_standard_percentage_of_rmt": "% Resting rMT",
    "view_individual_treatment_standard_pulses_per_second": "Pulses per Second",
    "view_individual_treatment_standard_pulses_per_train": "Pulses per Train",
    "view_individual_treatment_standard_total_duration": "Total Duration",
    "view_individual_treatment_standard_total_pulses": "Total No. of Pulses",
    "view_individual_treatment_standard_total_trains": "Total No. of Trains",
    "view_individual_treatment_title": " Individual treatment",
    "view_treatment_template_combined_title": "Combined Treatment Templates",
    "view_treatment_template_individual_title": "Individual Treatment Templates",
    "waiting_upper": "WAITING",
    "with_accuracy_data_postfix": " (with accuracy information)",
    "wizard_setup_complete": "Setup complete\r\nPlease login with your username and password to access your account.",
    "work_flow_define_rmt": "Define Motor Threshold (rMT)",
    "work_flow_define_treatment_target": "Define Treatment Target",
    "work_flow_register_landmarks": "Register Landmarks",
    "yes": "Yes"
  }
}